export const hu = {
    addDatabase: {
        addDatabase: "AdatbÃ¡zis hozzÃ¡adÃ¡sa",
        addFromFile: "HozzÃ¡adÃ¡s fÃ¡jlbÃ³l",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Minden kiszerelÃ©s",
        onePackage: "Egy kiszerelÃ©s",
        priceType: "Ãr tÃ­pusa",
        setPriceVatVisibility: "Ãfa megjelenÃ­tÃ©se",
        setVisibilityAndOrder: "LÃ¡thatÃ³sÃ¡g Ã©s Ã¡r tÃ­pus beÃ¡llÃ­tÃ¡sa",
        withAndWithoutVat: "ÃfÃ¡val Ã©s Ãfa nÃ©lkÃ¼l",
        withVat: "Csak Ãfa-val",
        withoutVat: "Csak Ãfa nÃ¡lkÃ¼l"
    },
    barvis: {
        base: "BÃ¡zis nÃ©v",
        bigCanSize: "Nagy kiszerelÃ©s",
        coating: "Bevonat",
        identifier: "AzonosÃ­tÃ³",
        laboratory: "LaboratÃ³rium",
        orderOverview: "RendelÃ©s Ã¡ttekintÃ©se",
        rank: "Sor",
        smallCanSize: "Kis kiszerelÃ©s"
    },
    basicSetup: {
        alreadyLoggedIn: "Ãn %{login} nÃ©ven van bejelentkezve.",
        askSupplier: " KÃ©rje meg a szoftver szÃ¡llÃ­tÃ³jÃ¡t, hogy osszon ki Ãnnek tÃ¶bb licencet.",
        asterisk: "A csillaggal jelÃ¶lt tÃ©teleket ki kell tÃ¶lteni.",
        identificationKeys: "AzonosÃ­tÃ³ kulcsok",
        importCustomData: "Adott esetben importÃ¡lja az egyÃ©ni adatokat az elÅzÅ adagolÃ³szoftverbÅl.",
        learnIdentification: "Ismerje meg az azonosÃ­tÃ³ kulcsokat a szoftver szÃ¡llÃ­tÃ³jÃ¡tÃ³l.",
        login: "A kezdeti beÃ¡llÃ­tÃ¡s kÃ¶vetkezÅ lÃ©pÃ©sei adminisztrÃ¡tori jogokat igÃ©nyelnek.",
        noDatabase: "MÃ©g nincs adatbÃ¡zis hozzÃ¡adva, legalÃ¡bb egyet be kell illeszteni.",
        offlineLicensing: "Offline licencelÃ©s",
        productSelection: "TermÃ©k kivÃ¡lasztÃ¡sa",
        registrationForm: "RegisztrÃ¡ciÃ³s Å±rlap",
        seeQuestionMark: "A beÃ¡llÃ­tÃ¡srÃ³l a kis kÃ©rdÅjeleknÃ©l tÃ¡jÃ©kozÃ³dhat.",
        selectDefaultPrinter: "VÃ¡lassza ki az alapÃ©rtelmezett nyomtatÃ³t, Ã©s Ã¡llÃ­tsa be a tovÃ¡bbi konfigurÃ¡ciÃ³t. ",
        selectDefaultTemplate:
            "VÃ¡lassza ki az alapÃ©rtelmezett sablonokat a mÃ¡r meglÃ©vÅk kÃ¶zÃ¼l, hozzon lÃ©tre Ãºj sablont vagy tÃ¶ltse be sajÃ¡t sablonjÃ¡t.",
        selectDispenser: "VÃ¡lassza ki a hasznÃ¡lt adagolÃ³ tÃ­pusÃ¡t.",
        selectLanguage: "VÃ¡lassza ki a nyelvet.",
        selectProducts: "VÃ¡lassza ki a rendelkezÃ©sre Ã¡llÃ³ termÃ©kek kÃ¶zÃ¼l azt, amelyet aktivÃ¡lni szeretne.",
        selectSpectroType: "VÃ¡lassza ki az Ãn Ã¡ltal hasznÃ¡lt spektrÃ³tÃ­pust.",
        setAdditionalPrinterOptions: "ÃllÃ­tsa be a tovÃ¡bbi nyomtatÃ¡si beÃ¡llÃ­tÃ¡sokat.",
        setAutomaticUpdates: "ÃllÃ­tsa be az automatikus frissÃ­tÃ©si beÃ¡llÃ­tÃ¡sokat.",
        setCustomItems:
            "ÃllÃ­tsa be az egyÃ©ni elemeket Ã©s az adatok lÃ¡thatÃ³sÃ¡gÃ¡t. GÃ¶rgessen lefelÃ© a tovÃ¡bbi lehetÅsÃ©gek megtekintÃ©sÃ©hez.",
        setEnvironment:
            "ÃllÃ­tsa be a szoftver Ã¡ltalÃ¡nos kÃ¶rnyezetÃ©t. TovÃ¡bbi lehetÅsÃ©gek megtekintÃ©sÃ©hez gÃ¶rgessen lefelÃ©.",
        setFormulaRepresentation:
            "ÃllÃ­tsa be a kÃ©plet megjelenÃ­tÃ©sÃ©t. GÃ¶rgessen lefelÃ© a tovÃ¡bbi lehetÅsÃ©gek megtekintÃ©sÃ©hez.",
        summary:
            "Ezeket a beÃ¡llÃ­tÃ¡sokat bÃ¡rmikor megvÃ¡ltoztathatja, Ã©s mÃ©g tÃ¶bb beÃ¡llÃ­tÃ¡si lehetÅsÃ©get talÃ¡l. JÃ³ szÃ³rakozÃ¡st a %{name} hasznÃ¡latÃ¡hoz!",
        summarySuccess: "Mindent beÃ¡llÃ­tÃ¡sod!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Kaniszter szint beÃ¡llÃ­tÃ¡sok",
        criticalLevelCanister: "Kritikus kaniszter szint",
        fillToMax: "Maximumig tÃ¶ltÃ©s",
        maxDispenseLevel: "tÃ¶ltÃ©si maximum",
        otherCanisters: "TovÃ¡bbi kaniszterek",
        warningLevelCanister: "Kaniszter szint figyelmeztetÃ©s"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "ElÃ©rhetÅ szolgÃ¡ltatÃ¡si tevÃ©kenysÃ©gek",
        canisterInformation: "Canister InformÃ¡ciÃ³",
        canisterPreview: "Kaniszter elÅnÃ©zet",
        currentLevel: "Jelenlegi szint",
        errors: "HibÃ¡k",
        fillState: "TÃ¶ltÃ©si Ã¡llapot",
        fillToMax: "Maximumig tÃ¶ltÃ©s",
        fillingAmount: "TÃ¶ltÃ©si mennyisÃ©g",
        finalLevel: "VÃ©gsÅ szint",
        minimumAmount: "MinimÃ¡lis mennyisÃ©g",
        minimumLevel: "MinimÃ¡lis szint",
        moveTableToRefill: "TÃ¡lca mozgatÃ¡sa az ÃºjratÃ¶ltÃ©shez",
        refillNoAmount: "Nincs Ã¶sszeg megadva",
        refillOverLimit: "A bevitt mennyisÃ©g meghaladja a tartÃ¡ly maximÃ¡lis kapacitÃ¡sÃ¡t",
        refillSummary: "%{amount} %{unit} szÃ­nezÃ©k %{colorant} kerÃ¼l a tartÃ¡lyba %{canisterId}.",
        systemWarningAmount: "MennyisÃ©gi figyelmeztetÃ©s",
        warningAmount: "MennyisÃ©gi figyelmeztetÃ©s"
    },
    changeDatabase: {
        changeDatabase: "AdatbÃ¡zis mÃ³dosÃ­tÃ¡sa/cserÃ©je",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "Ãsszes csatorna tisztÃ­tÃ¡sa",
        cleanChannels: "CsatornÃ¡k tisztÃ­tÃ¡sa",
        cleaningTime: "TisztÃ­tÃ¡si idÅ",
        selectChannels: "CsatornÃ¡k kivÃ¡lasztÃ¡sa",
        startCleaning: "TisztÃ­tÃ¡s indÃ­tÃ¡sa"
    },
    clientServerSettings: {
        activeServer: "AktuÃ¡lis szerver",
        addNewServer: "Ãj szerver hozzÃ¡adÃ¡sa",
        availableServers: "TovÃ¡bbi elÃ©rhetÅ szerverek",
        clientIdentifier: "ÃgyfÃ©l azonosÃ­tÃ³",
        clientServerSettings: "Kliens/szerver beÃ¡llÃ­tÃ¡sok",
        disabledStatus: "Tiltva",
        editServer: "Szerver szerkesztÃ©se",
        fillRequiredFields: "A kÃ¶telezÅen kitÃ¶ltendÅ mezÅket ki kell tÃ¶lteni",
        noOtherServers: "Nincs mÃ¡sik elÃ©rhetÅ szerver",
        offlineStatus: "nem elÃ©rhetÅ",
        onlineStatus: "elÃ©rhetÅ",
        port: "Port",
        serverName: "Szerver neve",
        serverNameMissing: "A szerver nevÃ©t ki kell tÃ¶lteni",
        stabileConnection: "A stabil kapcsolat biztosÃ­tÃ¡sa Ã©rdekÃ©ben hasznÃ¡ljon statikus IP-cÃ­met.",
        wrongFormatIp: "Az IP-cÃ­m helytelen formÃ¡tuma"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "SzÃ­nÃ¡rnyalat",
        fandeckPosition: "Fandeck pozÃ­ciÃ³ja",
        moreInfoIcons: "More info icons",
        notExistingFormula: "Nem lÃ©tezÅ formula",
        orderBy: "RendezÃ©s",
        selectYourGrid: "VÃ¡lassza ki a rÃ¡csot",
        showInPanel: "MegjelenÃ­tÃ©s a panelen",
        warningIcon: "Nem lÃ©tezÅ kÃ©plet figyelmeztetÅ ikon"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "SzÃ­nezÅpasztÃ¡k szÃ¡ma",
        preview: "ElÅnÃ©zet",
        prices: "Ãrak"
    },
    currencySettings: {
        addNewCurrency: "Ãj pÃ©nznem hozzÃ¡adÃ¡sa",
        codePlaceholder: "KÃ³d",
        currencySettings: "PÃ©nznem beÃ¡llÃ­tÃ¡sa",
        namePlaceholder: "NÃ©v",
        ratePlaceholder: "ArÃ¡ny",
        setDecimalPlaces: "Tizedesjegy beÃ¡llÃ­tÃ¡s",
        setMainCurrency: "Alap pÃ©nznem beÃ¡llÃ­tÃ¡sa",
        setRounding: "KerekÃ­tÃ©s beÃ¡llÃ­tÃ¡sa",
        symbolPlaceholder: "SzimbÃ³lum"
    },
    customFandecks: {
        customFandecks: "SzÃ­nkÃ¡rtya vÃ¡lasztÃ¡sa",
        deleteButtonWarning: "A fandeckben lÃ©vÅ Ã¶sszes kÃ©pletet is eltÃ¡volÃ­tjuk.",
        deleteCustomFandeck:
            "TÃ©nyleg tÃ¶rÃ¶lni szeretnÃ© ezt az egyÃ©ni fandecket? Az Ã¶sszes kÃ©plet ebben a fandeckben is tÃ¶rlÅdik.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Fandeck neve"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "Ãj vevÅ hozzÃ¡adÃ¡sa",
        addNewNote: "Ãj megjegyzÃ©s hozzÃ¡adÃ¡sa",
        addedDate: "HozzÃ¡adott dÃ¡tum",
        addedQuantity: "HozzÃ¡adott mennyisÃ©g",
        availableMachine: "SzÃ­nezÅgÃ©p elÃ©rhetÅ",
        brand: "MÃ¡rkanÃ©v",
        brandPlease: "KÃ©rjÃ¼k vÃ¡lasszon mÃ¡rkanevet",
        cancelCustomer: "VevÅ tÃ¶rlÃ©se",
        colorPlease: "KÃ©rjÃ¼k vÃ¡lasszon szÃ­nt",
        confirmCustomerData: "ErÅsÃ­tse meg a vevÅ adatokat",
        confirmNoteData: "ErÅsÃ­tse meg a megjegyzÃ©seket",
        confirmSelectedUser: "SzeretnÃ© a %{customerName} Ã¼gyfelet hasznÃ¡lni ehhez a megrendelÃ©shez.",
        confirmed: "MegerÅsÃ­tve",
        controlData: "VÃ©gleges adat kezelÃ©s",
        customerCellNumber: "VevÅi szÃ¡m",
        customerFilter: "VevÅ szÅ±rÅ",
        customerName: "VevÅ neve",
        customerPhone: "VevÅ telefonszÃ¡ma",
        customerPlease: "KÃ©rjÃ¼k vÃ¡lasszon vevÅt",
        dateFilter: "SzÅ±rÃ©s dÃ¡tum alapjÃ¡n",
        enterPin: "Ãrja be a PIN kÃ³dot",
        enterTheNumberOfPackages: "Ãrja be a kiszerelÃ©sek szÃ¡mÃ¡t",
        existingCustomer: "A felhasznÃ¡lÃ³ mÃ¡r lÃ©tezik",
        fandeckPlease: "KÃ©rjÃ¼k vÃ¡lasszon szÃ­nkÃ¡rtyÃ¡t",
        fillCanisterHistory: "Kaniszter tÃ¶ltÃ©si elÅzmÃ©nyek",
        findCustomer:
            "HÅ±sÃ©gkÃ¡rtya hozzÃ¡rendelÃ©se ehhez a rendelÃ©shez kÃ©rjÃ¼k, olvassa be vonalkÃ³djÃ¡t vagy keressen e-mail cÃ­met",
        findCustomerByEmail: "ÃgyfÃ©l szÅ±rÃ©se e-mailben vagy vonalkÃ³ddal",
        finishPreviousStep: "(KÃ©rjÃ¼k, fejezze be az elÅzÅ lÃ©pÃ©st)",
        formulaUnit: "Recept egysÃ©g",
        getBackToList: "Vissza a vevÅk listÃ¡jÃ¡hoz",
        historyOfOrders: "MegrendelÃ©sek elÅzmÃ©nyei",
        insertNote: "Kattintson a megjegyzÃ©s beillesztÃ©sÃ©re",
        loadHistoryOrder: "SzeretnÃ© betÃ¶lteni a kivÃ¡lasztott megrendelÃ©st?",
        loyaltyCards: "HÅ±sÃ©gkÃ¡rtya",
        machineIsAvailable: "A szÃ­nezÅgÃ©p elÃ©rhetÅ",
        machineIsUnavailable: "A szÃ­nezÅgÃ©p nem elÃ©rhetÅ",
        newLoyaltyCard: "Ãj hÅ±sÃ©gkÃ¡rtya",
        noAvailableMachine: "A szÃ­nezÅgÃ©p nem elÃ©rhetÅ",
        noCustomerSelected: "No customer is selected. Do you want continue?",
        notePlease: "Ãrjon be megjegyzÃ©st!",
        openHistory: "ElÅzmÃ©nyek megnyitÃ¡sa",
        orAdd: "vagy adjon hozzÃ¡ vevÅt",
        orSelect: "vagy vÃ¡lasszon vevÅt",
        orderModification: "Az eredeti sorrend mÃ³dosul. SzeretnÃ© folytatni?",
        orderOverview: "MegrendelÃ©s Ã¡ttekintÃ©se",
        orderToMachine: "KÃ¼ldje el a megrendelÃ©st a szÃ­nezÅgÃ©pre",
        ordersHistory: "RendelÃ©s elÅzmÃ©nyei",
        packagePlease: "KÃ©rjÃ¼k, vÃ¡lasszon kiszerelÃ©st!",
        pleaseSelectBrand: "KÃ©rjÃ¼k vÃ¡lasszon mÃ¡rkanevet",
        previewImage: "KÃ©p elÅnÃ©zete",
        previewPackage: "KiszerelÃ©s elÅnÃ©zete",
        productPlease: "KÃ©rjÃ¼k, vÃ¡lasszon termÃ©ket!",
        resetFilters: "Ãsszes szÅ±rÅ visszaÃ¡llÃ­tÃ¡sa",
        searchForHistoricalOrders: "vagy keressen a megrendelÃ©si elÅzmÃ©nyek kÃ¶zÃ¼l",
        selectBrand: "KÃ©rjÃ¼k vÃ¡lasszon mÃ¡rkanevet",
        selectColor: "Kattintson a szÃ­n kivÃ¡lasztÃ¡sÃ¡ra",
        selectCustomer: "Kattintson a vevÅ kivÃ¡lasztÃ¡sÃ¡ra",
        selectExistingCustomer: "VÃ¡lassza ki a meglÃ©vÅ Ã¼gyfelet",
        selectFandeck: "Kattintson a szÃ­nkÃ¡rtya kivÃ¡lasztÃ¡sÃ¡ra",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Kattintson a kiszerelÃ©s kivÃ¡lasztÃ¡sÃ¡ra",
        selectProduct: "Kattintson a termÃ©k kivÃ¡lasztÃ¡sÃ¡ra",
        shotsCoefficient: "Impulzus adagolÃ¡si egyÃ¼tthatÃ³",
        showDetail: "RÃ©szletek",
        showHideEshopName: "A szÃ­n eshop nevÃ©nek megjelenÃ­tÃ©se/elrejtÃ©se egy kÃ¼lÃ¶n oszlopban",
        showKeyboard: "A billentyÅ±zet megjelenÃ­tÃ©se",
        skipCustomerButton: "VevÅ kivÃ¡lasztÃ¡sÃ¡nak kihagyÃ¡sa",
        skipCustomerText: "Kihagyja, ha nem szeretne belÃ©pni egy Ã¼gyfÃ©l adataiba",
        skipNote: "Jegyzet kihagyÃ¡sa Ã©s Ã¶sszegzÃ©s megtekintÃ©se",
        spectroBrand: "KeresÃ©s a %{brandName} mÃ¡rkÃ¡ban",
        statusAccepted: "elfogadva",
        statusCanceled: "tÃ¶rÃ¶lve",
        statusCreated: "lÃ©trehozva",
        statusDone: "kÃ©sz",
        statusPartlyDone: "rÃ©szben kÃ©sz",
        statusPreparing: "elÅkÃ©szÃ­tÃ©s",
        summaryChosenBase: "BÃ¡zis",
        summaryChosenBrand: "MÃ¡rkanÃ©v",
        summaryChosenCanSize: "lehetsÃ©ges kiszerelÃ©s",
        summaryChosenColor: "szÃ­n",
        summaryChosenColorCard: "szÃ­nkÃ¡rtya",
        summaryChosenProduct: "TermÃ©k",
        summaryChosenQuantity: "mennyisÃ©g",
        summaryColorPreview: "szÃ­n elÅnÃ©zete",
        summaryCustomNote: "EgyÃ©b megjegyzÃ©s",
        summaryCustomerNumber: "vevÅ szÃ¡ma",
        summaryFormula: "Recept",
        summaryFormulaNote: "Recept megjegyzÃ©se",
        summaryNote: "MegjegyzÃ©s",
        sureAboutSend: "Biztos benne hogy el szeretnÃ© kÃ¼ldeni a megrendelÃ©st?",
        useCustomerInOrder: "Akarja hasznÃ¡lni %{customerName} a kÃ¶vetkezÅ rendelÃ©sben?",
        uuid: "UUID",
        viewSummary: "ÃsszesÃ­tÃ©s elÅnÃ©zete",
        volume: "HangerÅ"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "MegrendelÃ©s visszaigazolÃ¡sa",
        pinScreenSaverConfirmation: "A kÃ©pernyÅvÃ©dÅ PIN kÃ³djÃ¡nak megerÅsÃ­tÃ©se",
        pinSettingsConfirmation: "PIN beÃ¡llÃ­tÃ¡sok megerÅsÃ­tÃ©se",
        printAuto: "Automatikus nyomtatÃ¡s engedÃ©lyezÃ©se",
        printerSettings: "NyomtatÃ³ beÃ¡llÃ­tÃ¡sok",
        selectColorWithFandeck: "SzÃ­n Ã©s szÃ­nkÃ¡rtya egyÃ¼tttes kivÃ¡lasztÃ¡sa",
        setKeyboard: "BillentyÅ±zet beÃ¡llÃ­tÃ¡sa",
        setKioskMode: "Kiosk mÃ³d beÃ¡llÃ­tÃ¡sa ",
        setLanguage: "Nyelv beÃ¡llÃ­tÃ¡sa",
        setModule: "Modul beÃ¡llÃ­tÃ¡sa",
        setQuickSelect: "Gyors kivÃ¡lasztÃ¡s beÃ¡llÃ­tÃ¡sa",
        setScreensaverTimeout: "KÃ©pernyÅvÃ©dÅ idÅzÃ­tÅ beÃ¡llÃ­tÃ¡sa",
        setUnit: "EgysÃ©g beÃ¡llÃ­tÃ¡sa"
    },
    customRedlikeMachine: {
        action: "TevÃ©kenysÃ©g",
        additionalPrint: "TovÃ¡bbi nyomtatÃ¡s",
        brand: "MÃ¡rkanÃ©v",
        brandAccess: "FelhasznÃ¡lÃ³ '%{userName}' szÃ¡mÃ¡ra nem elÃ©rhetÅ adatok a '%{brandName}' nevÅ± termÃ©krÅl",
        can: "ElhelyezÃ©s",
        canistersLevel: "Kaniszterek szintjÃ©nek Ã¡ttekintÃ©se",
        closeDetailInformation: "RÃ©szletek bezÃ¡rÃ¡sa",
        colorantsAmount: "SzÃ­nezÅpaszta mennyisÃ©ge",
        confirmRefill: "EllenÅrizze a szÃ­nezÅpaszta ÃºjratÃ¶ltÃ©sÃ©t!",
        deleteOrder: "RendelÃ©s tÃ¶rlÃ©se",
        dialogNoMachine: "A szÃ­nezÅgÃ©p nincs csatlakoztatva",
        dialogNoRcc: "RCC nincs csatlakoztatva",
        dispense: "SzÃ­nezÃ©s",
        dispenserInErrorState: "A szÃ­nezÅgÃ©p hibÃ¡t jelez",
        dispensingIsOk: "A szÃ­nezÅgÃ©p mÅ±kÃ¶dik",
        emergencyButtonPressed: "VÃ©szleÃ¡llÃ­tÃ³ gomb aktivÃ¡lva van",
        errorCode: "HibakÃ³d",
        errorEvents: "SzÃ­nezÅgÃ©p hibaÃ¼zenet",
        errorReset: "Hiba tÃ¶rlÃ©se",
        explanation: "MagyarÃ¡zat",
        imageNotAvailable: "A kÃ©p nem elÃ©rhetÅ",
        incorrectCanister: "A hibÃ¡s kaniszter ellenÅrzÃ©se megtÃ¶rtÃ©nt!",
        incorrectColorant: "HIBA: Helytelen szÃ­nezÅpaszta beolvasÃ¡sa. KÃ©rjÃ¼k, ellenÅrizze a szÃ­nezÅpasztÃ¡t!",
        lastEvents: "UtolsÃ³ esemÃ©nyek",
        machineActions: "AdagolÃ³ Ã©rzÃ©kelÅk",
        machineConfiguration: "SzÃ­nezÅgÃ©p beÃ¡llÃ­tÃ¡sa",
        machineError: "SzÃ­nezÅgÃ©p hiba",
        machineIsBusy: "A szÃ­nezÅgÃ©p dolgozik",
        machineNotAvailable: "A szÃ­nezÅgÃ©p nem Ã©rhetÅ el",
        machineTinting: "KÃ©rjÃ¼k vÃ¡rjon, a gÃ©p szÃ­nez...",
        manualScan: "ManuÃ¡lis vizsgÃ¡lat",
        notEnoughSpace: "HIBA: Nincs elegendÅ hely a szÃ­nezÅpaszta szÃ¡mÃ¡ra",
        numberOfCanistersUnderCriticalLevel: "A kritikus szint alatt lÃ©vÅ tartÃ¡lyok szÃ¡ma %{0}",
        numberOfCanistersUnderWarningLevel: "A figyelmeztetÅ szint alatt lÃ©vÅ tartÃ¡lyok szÃ¡ma %{0}",
        offlinePressed: "KikapcsolÃ³ gomb akivÃ¡lva van",
        orderSettings: "MegrendelÃ©s beÃ¡llÃ­tÃ¡sai",
        otherOrderInformation: "MegrendelÃ©s rÃ©szletei",
        packageCount: "KÃ©sztermÃ©kek szÃ¡ma",
        packageWithSeparator: "KÃ©sztermÃ©k",
        received: "Fogadott",
        receivedOrders: "Fogadott megrendelÃ©sek",
        receivedTime: "BeÃ©rkezÃ©si dÃ¡tum",
        recirculation: "VisszaforgatÃ¡s",
        refillInformation: "SzÃ­nezÅpaszta: %{0}, TÃ¶ltÃ©s: %{1}, Kaniszter: %{2}",
        resetErrors: "VisszaÃ¡llÃ­tÃ¡si hiba",
        scanCanister: "EllenÅrizze a kanisztert!",
        scanColorantPackage: "EllenÅrizze a megfelelÅ szÃ­nezÅpasztÃ¡t!",
        selectedOrder: "KivÃ¡lsztott megrendelÃ©s",
        shelfMovingDown: "A polc lefelÃ© mozog",
        shelfMovingUp: "A polc felfelÃ© mozog",
        solution: "MegoldÃ¡s",
        startDispensing: "Kezdje a szÃ­nezÃ©st",
        stirring: "KeverÃ©s",
        touchToStartFilling: "Ãrintse meg a szÃ­nezÅpaszta betÃ¶ltÃ©sÃ©hez!",
        unknownBrand: "Ismeretlen mÃ¡rkanÃ©v"
    },
    customRedlikeSettings: {
        addPos: "ÃrtÃ©kesÃ­tÃ©si pont informÃ¡ciÃ³",
        addServer: "Szerver hozzÃ¡adÃ¡sa",
        adminOperations: "Admin mÅ±veletek",
        adminSettings: "AdminisztrÃ¡tori beÃ¡llÃ­tÃ¡sok",
        another: "TovÃ¡bbi",
        aslOrService: "ASL vagy szerviz",
        availableMachines: "RendelkezÃ©sre Ã¡llÃ³ szÃ­nezÅgÃ©pek",
        barcode: "VonalkÃ³d",
        basicOperations: "AlapmÅ±veletek",
        canisterBarcodes: "Kaniszter vonalkÃ³dok",
        canisterLevels: "Kaniszter szintek",
        closeConnection: "KÃ¶zeli kapcsolat",
        closeRedlike: "%{name} bezÃ¡rÃ¡sa",
        databaseList: "AdatbÃ¡zisok",
        disabledStatus: "tiltva",
        dispenseLogicType: "AdagolÃ¡s tÃ­pusa",
        dropServers: "KiszolgÃ¡lÃ³val valÃ³ kapcsolat megszakÃ­tÃ¡sa",
        editServer: "KiszolgÃ¡lÃ³ szerkesztÃ©se",
        lastEvent: "UtolsÃ³ esemÃ©ny",
        logOut: "KijelentkezÃ©s",
        machineConfiguration: "KonfigurÃ¡lÃ¡s",
        maxDispenseAmount: "adagolÃ¡si maximum",
        offlineStatus: "nem elÃ©rhetÅ",
        onlineStatus: "elÃ©rhetÅ",
        openFrondesk: "Front desk megnyitÃ¡sa",
        print: "NyomtatÃ¡si beÃ¡llÃ­tÃ¡sok",
        rebootPC: "SzÃ¡mÃ­tÃ³gÃ©p ÃºjraindÃ­tÃ¡sa",
        restartRedlike: "%{name} ÃºjraindÃ­tÃ¡sa",
        restoreConnection: "Kapcsolat visszaÃ¡llÃ­tÃ¡sa",
        scanCanisterBarcode: "Kaniszter vonalkÃ³djÃ¡nak beolvasÃ¡sa",
        scanOrDeleteCanisterBarcode: "VonalkÃ³d beolvasÃ¡sa vagy tÃ¶rlÃ©se",
        setCanisterBarcode: "Kaniszter vonalkÃ³djÃ¡nak beÃ¡llÃ­tÃ¡sa",
        swVersion: "Szoftver verziÃ³szÃ¡ma",
        systemFunctions: "Rendszer funkciÃ³k",
        userSettings: "FelhasznÃ¡lÃ³ beÃ¡llÃ­tÃ¡sai"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "SzÃ­n szerkesztÃ©se",
        editColorant: "SzÃ­nezÅpaszta szerkesztÃ©se",
        emptyColorant: "Ez a szÃ­nezÅpaszta Ã¼res",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "A tÃ¶rzstermÃ©k kÃ©plete",
        formulaForMasterProductWithParam: "A %{productName} tÃ¶rzstermÃ©k kÃ©plete",
        isNotAvailable: "nem elÃ©rhetÅ",
        noBaseSelected: "VÃ¡lasszon ki egy bÃ¡zist",
        noColorantsSelected: "Nincs szÃ­nezÅpaszta kivÃ¡lasztva",
        noFandeckSelected: "VÃ¡lasszon ki egy szÃ­nkÃ¡rtyÃ¡t",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "TermÃ©k kivÃ¡lasztÃ¡sa kÃ¶telezÅ",
        productPreview: "TermÃ©ke elÅnÃ©zete",
        saveCustomRecipe: "Ãj recept mentÃ©se",
        saveIsNotAvailable: "A mentÃ©s nem lehetsÃ©ges",
        showSiblingProducts: "TestvÃ©rtermÃ©kek megjelenÃ­tÃ©se",
        siblingProducts: "TestvÃ©rtermÃ©kek master termÃ©kenkÃ©nt"
    },
    customersTab: {
        addCustomer: "Ãj vevÅ hozzÃ¡adÃ¡sa",
        additionalSettings: "TovÃ¡bbi beÃ¡llÃ­tÃ¡sok",
        adress: "CÃ­me",
        createAndSelect: "HozzÃ¡ad Ã©s kivÃ¡laszt",
        createNewCustomer: "Ãj vevÅ hozzÃ¡adÃ¡sa",
        editCustomer: "VevÅ adatainak szerkesztÃ©se",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "AzonosÃ­tÃ³szÃ¡m",
        information: "Kapcsolati InformÃ¡ciÃ³",
        listOfCustomers: "VevÅk listÃ¡ja",
        rabat: "KedvezmÃ©ny",
        selectCustomer: "VevÅ kivÃ¡lasztÃ¡sa",
        spentLastMonth: "MÃºlt havi vÃ¡sÃ¡rlÃ¡sok Ã¶sszege",
        spentMoney: "VÃ¡sÃ¡rlÃ¡sok Ã¶sszege",
        typeOfMargin: "ÃrrÃ©s tÃ­pusa",
        zipCode: "IrÃ¡nyÃ­tÃ³szÃ¡m"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "VersenykÃ©pes szÃ­nkeresÃ©s folyamatban",
        reallyChangeModule: "Biztos benne hogy meg akarja vÃ¡ltoztatni a modult?",
        reallyCloseRedlike:
            "TÃ©nyleg be akarod zÃ¡rni a %{name}-t? Az Ã¶sszes %{name} panel bezÃ¡rÃ¡sra kerÃ¼l, a nem mentett mÃ³dosÃ­tÃ¡sok elvesznek.",
        reallyDeleteOrder:
            "Biztosan tÃ¶rÃ¶lni szeretnÃ© ezt a megrendelÃ©st? Az ehhez a rendelÃ©shez kapcsolÃ³dÃ³ Ã¶sszes adat elveszik.",
        reallyRebootPC:
            "Biztosan szeretnÃ© ÃºjraindÃ­tani a szÃ¡mÃ­tÃ³gÃ©pet? Az Ã¶sszes ablak bezÃ¡rÃ³dik, Ã©s a mentetlen mÃ³dosÃ­tÃ¡sok elvesznek.",
        reallyRestartRedlike:
            "Biztosan szeretnÃ© ÃºjraindÃ­tani a %{name}-ot?  Az Ã¶sszes ablak bezÃ¡rÃ³dik, Ã©s a mentetlen mÃ³dosÃ­tÃ¡sok elvesznek.",
        reallyShutdownPc:
            "TÃ©nyleg le akarja kapcsolni ezt a szÃ¡mÃ­tÃ³gÃ©pet? Az Ã¶sszes %{name} panel bezÃ¡rÃ¡sra kerÃ¼l, a nem mentett mÃ³dosÃ­tÃ¡sok elvesznek.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Csak maximÃ¡lis pasztamennyisÃ©get adagol",
        2: "KÃ©zi adagolÃ¡st engedÃ©lyez (maximÃ¡lis pasztamennyisÃ©g felett)",
        3: "PasztaadagolÃ¡s alatti ÃºjratÃ¶ltÃ©s",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Fandeck name"
    },
    editFormulaRgbModal: {
        apply: "Alkalmaz",
        blue: "KÃ©k",
        green: "ZÃ¶ld",
        modalLabel: "SzÃ­n elÅnÃ©zete",
        red: "Piros",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "KÃ©plet lap automatikus bezÃ¡rÃ¡sa",
        allowBarcodes: "VonalkÃ³dok engedÃ©lyezÃ©se",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "EngedÃ©lyezÃ©s VÃ¡sÃ¡rlÃ³knak",
        allowDeleteConfirmation: "A tÃ¶rlÃ©s megerÅsÃ­tÃ©se",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "SzÃ­nezÃ©s engedÃ©lyezÃ©se",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "BelsÅ jegyzetek engedÃ©lyezÃ©se",
        allowLight: "EngedÃ©lyez %{name}",
        allowOrderNotificationModal: "Ãj rendelÃ©si Ã©rtesÃ­tÃ©sek megjelenÃ­tÃ©se",
        allowOrdering: "MegrendelÃ©s engedÃ©lyezÃ©se",
        allowPricing: "EngedÃ©lyezze az Ã¡rkÃ©pzÃ©st",
        allowPrint: "NyomtatÃ¡s engedÃ©lyezÃ©se",
        allowProductPreviewImage: "TermÃ©k elÅnÃ©zetÃ©nek engedÃ©lyezÃ©se adagolÃ¡s kÃ¶zben",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "HangjelzÃ©s engedÃ©lyezÃ©se",
        allowSpectro: "Spectro engedÃ©lyezÃ©se",
        allowTabs: "Lapok engedÃ©lyezÃ©se",
        applyZoom: "NagyÃ­tÃ¡s alkalmazÃ¡sa",
        automaticLogout: "Automatikus kijelentkezÃ©s",
        barcodeScan: "VonalkÃ³d beolvasÃ¡s",
        canisterBarcode: "Kaniszter vonalkÃ³dok",
        canisterLevel: "Kaniszter szint ",
        changelog: "VÃ¡ltozÃ¡si naplÃ³",
        closeTab: "BezÃ¡rÃ¡s fÃ¼l",
        colorDifference: "Color difference",
        colorPanelNavItem: "SzÃ­npaletta",
        competitiveColorSearch: "VersenykÃ©pes szÃ­nkeresÃ©s",
        customBanner: "Egyedi banner",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Mutasd meg a kedvezmÃ©nyt",
        dispensingHistory: "AdagolÃ¡s tÃ¶rtÃ©nete",
        dispensingNotes: "AdagolÃ¡si jegyzetek engedÃ©lyezÃ©se",
        enableCustomers: "VevÅk engedÃ©lyezÃ©se",
        enableDeleteConfirmation: "A tÃ¶rlÃ©s megerÅsÃ­tÃ©se",
        enableDispensing: "SzÃ­nezÃ©s engedÃ©lyezÃ©se",
        enableLight: "EngedÃ©lyez %{name}",
        enableMarginMarkup: "Ãr vagy haszonkulcs engedÃ©lyezÃ©se",
        enableNotes: "Jegyzetek engedÃ©lyezÃ©se",
        enableOrdering: "MegrendelÃ©s engedÃ©lyezÃ©se",
        enableProductPreviewImage: "TermÃ©k elÅnÃ©zetÃ©nek engedÃ©lyezÃ©se adagolÃ¡s kÃ¶zben",
        enableSpectro: "Spectro engedÃ©lyezÃ©se",
        enableVirtualKeyboard: "VirtuÃ¡lis billenytyÅ±zet engedÃ©lyezÃ©se",
        environmentsSettings: "ÃltalÃ¡nos beÃ¡llÃ­tÃ¡sok",
        exportTranslationKeys: "FordÃ­tÃ¡si kulcsok bevitele",
        formulaNotes: "KÃ©plet jegyzeteinek engedÃ©lyezÃ©se",
        hintTooltips: "Tippek",
        image: "KÃ©p",
        keyboardShortcuts: "GyorsbillenytyÅ±k",
        languageBased: "Language based",
        lockYourComputer: "ZÃ¡rolja a szÃ¡mÃ­tÃ³gÃ©pet",
        machineReset: "GÃ©p ÃºjraindÃ­tÃ¡s",
        manageTranslations: "FordÃ­tÃ¡sok kezelÃ©se",
        margin: "Csak Ã¡r",
        markup: "Csak haszonkulcs",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Adja meg, hÃ¡ny receptet mutasson egy lapon",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "SzÃ­nes + kÃ©p + tovÃ¡bbi informÃ¡ciÃ³k",
        navigationItems: "NavigÃ¡ciÃ³s eszkÃ¶zÃ¶k beÃ¡llÃ­tÃ¡sa",
        newTab: "Ãj fÃ¼l",
        numberOfPriceGroups: "Ãrcsoportok szÃ¡ma",
        order: "MegrendelÃ©s",
        orderId: "MegrendelÃ©s azonosÃ­tÃ³",
        ordersHistory: "MegrendelÃ©sek elÅzmÃ©nyei",
        overwriteLastTab: "Az utolsÃ³ kÃ©plet lapjÃ¡nak felÃ¼lÃ­rÃ¡sa",
        priceCalculation: "ÃrszÃ¡mÃ­tÃ¡s",
        priceDefBothPurchasePrimary: "MindkettÅ, elsÅdleges vÃ¡sÃ¡rlÃ¡s",
        priceDefBothSellPrimary: "MindkettÅ, elsÅdleges eladÃ¡s",
        priceDefPurchaseOnly: "Csak vÃ©teli Ã¡r",
        priceDefSellOnly: "Csak eladÃ¡si Ã¡r",
        priceDefinition: "Ãr meghatÃ¡rozÃ¡s",
        priceGroupsEnabled: "Ãrcsoportok engedÃ©lyezÃ©se",
        runLightAtStartUp: "FuttatÃ¡s %{light} betÃ¶ltÃ©skor",
        screenSaverTimeout: "KÃ©pernyÅvÃ©dÅ idÅ kiesÃ©se",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "Futtassa a %{name} a szÃ¡mÃ­tÃ³gÃ©p indÃ­tÃ¡sakor",
        setCustomHomeButton: "ÃllÃ­tsa be a kezdÅmÅ±veletet",
        setDecimalPlaces: "Adja meg a tizedesjegyek szÃ¡mÃ¡t!",
        setFormulaPreview: "Recept elÅnÃ©zetÃ©nek beÃ¡llÃ­tÃ¡sa",
        setFormulaUnit: "Recept mÃ©rtÃ©kegysÃ©gÃ©nek beÃ¡llÃ­tÃ¡sa",
        setFts: "Teljes szÃ¶veges keresÃ©s hasznÃ¡lata",
        setInfoItemInRgb: "LÃ¡thatÃ³ informÃ¡ciÃ³k beÃ¡llÃ­tÃ¡sa a kÃ©pletben RGB elÅnÃ©zet",
        setKeyboardShortcuts: "ÃllÃ­tsa be a billentyÅ±parancsokat",
        setKioskMode: "Kiosk mÃ³d beÃ¡llÃ­tÃ¡sa",
        setKioskModeOff: "Kiosk mÃ³d kikapcsolÃ¡sa",
        setKioskModeOn: "Kiosk mÃ³d bekapcsolÃ¡sa",
        setNavigationItems: "NavigÃ¡ciÃ³s elemek beÃ¡llÃ­tÃ¡sa",
        setNavigationItemsList: "ÃllÃ­tsa be a navigÃ¡ciÃ³s elemek lÃ¡thatÃ³sÃ¡gÃ¡t Ã©s sorrendjÃ©t",
        setOrderSearchItems: "MegrendelÃ©s keresÃ©si paramÃ©tereinek beÃ¡llÃ­tÃ¡sa",
        setRounding: "KerekÃ­tÃ©s beÃ¡llÃ­tÃ¡sa",
        setSearchParameters: "FormulakeresÃ©si paramÃ©terek beÃ¡llÃ­tÃ¡sa",
        setTabLimit: "ÃllÃ­tsa be az egy lapon megjelenÅ adatok szÃ¡mÃ¡t",
        setYourLanguage: "Nyelv beÃ¡llÃ­tÃ¡sa",
        setZoom: "NagyÃ­tÃ¡s beÃ¡llÃ­tÃ¡sa",
        showLocalPrices: "Helyi Ã¡rak megjelenÃ­tÃ©se",
        skipPlaceCanDialogEnabled:
            "Ezt a beÃ¡llÃ­tÃ¡st nem lehet megvÃ¡ltoztatni, mert a helybeÃ¡llÃ­tÃ¡s deaktivÃ¡lÃ³dott a gÃ©pbeÃ¡llÃ­tÃ¡sokban",
        sortItems: "NavigÃ¡ciÃ³s elemek rendezÃ©se",
        startDispensing: "AdagolÃ¡s indÃ­tÃ¡sa",
        stir: "KeverÃ©s"
    },
    error: {
        errorDetail: "Hiba rÃ©szletei",
        errorOccurred:
            "VÃ¡ratlan hiba tÃ¶rtÃ©nt. Vegye fel a kapcsolatot az Ã¼gyfÃ©lszolgÃ¡latunkkal! %{0}, hamarosan segÃ­tÃ¼nk",
        hideDetail: "RÃ©szletek elrejtÃ©se"
    },
    favoritesTab: {
        addFolder: "Ãj mappa hozzÃ¡adÃ¡sa",
        closeTabToLoadFormula: "Az Ãºj lap megnyitÃ¡sÃ¡hoz zÃ¡rja be az egyik receptet. ElÃ©rte a maximÃ¡lis szÃ¡mÃº lapot.",
        deleteFolder: "Mappa tÃ¶rlÃ©se",
        editFolder: "Mappa szerkesztÃ©se",
        favoriteFormulas: "Kedvenc receptek",
        formulaNotes: "Formula notes",
        message: {
            formulasFromFolder: "Receptek mappÃ¡bÃ³l",
            moveAllFormulas: "Ãsszes recept Ã¡thelyezÃ©se ebbÅl a mappÃ¡bÃ³l",
            removeAllFormulas: "Ãsszes recept eltÃ¡volÃ­tÃ¡sa ebbÅl a mappÃ¡bÃ³l",
            wantToDeleteFolder: "TÃ©nyleg tÃ¶rÃ¶lni szeretnÃ© ezt a mappÃ¡t?"
        },
        newFolder: "Ãj mappa",
        packages: "KiszerelÃ©sek",
        pricePerPackage: "KiszerelÃ©s Ã¡ra",
        regularPrice: "ListaÃ¡r",
        removeFromFavorites: "TÃ¶rlÃ©s a kedvencekbÅl",
        specialPriceOff: "Egyedi Ã¡r %{number}% kikapcsolÃ¡sa",
        specialPriceVIP: "Egyedi Nagykereskedelmi Ã¡r"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "FogyasztÃ¡s tÃ­pusa",
        filter: "SzÅ±rÅ",
        from: "Honnan",
        to: "CÃ­mzett"
    },
    findText: {
        findTextTitle: "SzÃ¶veg keresÃ©se",
        removeMarks: "A jelek eltÃ¡volÃ­tÃ¡sa",
        search: "KeresÅ szÃ³"
    },
    flashMessage: {
        VMNotAllowed: "VM nem megengedett",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Az adatbÃ¡zis autologin sikertelen.",
        autotaskDuplicateName:
            "AdatbÃ¡zis integritÃ¡si hiba: %{0} elem %{1} %{2} mÃ¡r lÃ©tezik, kÃ©rjÃ¼k, hasznÃ¡ljon mÃ¡sik %{3}",
        barcodeIsUsed: "A vonalkÃ³d mÃ¡r hasznÃ¡latban van.",
        barcodeNotFound: "VonalkÃ³d nem talÃ¡lhatÃ³",
        bugReportSent: "A hibajelentÃ©st elkÃ¼ldtÃ¼k.",
        cannoctConnectToServer: "Nem lehet csatlakozni a kiszolgÃ¡lÃ³hoz",
        cannotWriteLicense: "Nem tud licencet Ã­rni",
        clientConnectionRejected: "A kapcsolat elutasÃ­tva",
        clientNotLoggedIn: "A felhasznÃ¡lÃ³ nincs bejelentkezve",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "VersenykÃ©pes szÃ­neket nem talÃ¡ltunk. MÃ³dosÃ­tsa a keresÃ©si paramÃ©tereket, vagy vÃ¡lasszon mÃ¡sik szÃ­nt.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "SzÃ¡mÃ­tÃ³gÃ©p visszadÃ¡tumozott",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "HibÃ¡s licenc file",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Az Ã¼gyfÃ©l nem talÃ¡lhatÃ³",
        dataNotAvailable: "A kiszolgÃ¡lÃ³ nem tud csatlakozni az adatbÃ¡zishoz",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "VÃ¡ratlan hiba tÃ¶rtÃ©nt az utolsÃ³ kiszolgÃ¡lÃ³i mÅ±velet sorÃ¡n",
        deleteAll: "Ãsszes tÃ¶rlÃ©se",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "A tÃ©li bÅvÃ­tmÃ©nyt a fÃ¼l jobb oldalÃ¡n talÃ¡lhatÃ³ legÃ¶rdÃ¼lÅ lista segÃ­tsÃ©gÃ©vel tilthatja le.",
        duplicateBarcode: "DuplikÃ¡lt vonalkÃ³d mÃ¡r lÃ©tezik.",
        duplicateName: "Ez a nÃ©v mÃ¡r lÃ©tezik",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "LejÃ¡rt a licenc",
        exportSuccess: "Az adatok exportÃ¡lÃ¡sa sikeresen megtÃ¶rtÃ©nt",
        fandeckExist: "Ez az egyÃ©ni fandeck nÃ©v mÃ¡r lÃ©tezik.",
        featureNotAutorized: "Nem engedÃ©lyezett funkciÃ³",
        fileExportComplete: "A fÃ¡jl exportÃ¡lÃ¡sa sikeres volt.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Recept adatai nem elÃ©rhetÅek",
        helperDefaultMessage: "VÃ¡ratlan hiba tÃ¶rtÃ©nt az utolsÃ³ Helper Server mÅ±velet sorÃ¡n",
        helperServerError: "SegÃ­tÅ szerver hiba",
        importAborted: "Az importÃ¡lÃ¡si folyamat megszakadt",
        importSuccess: "Az adatok importÃ¡lÃ¡sa sikeresen megtÃ¶rtÃ©nt",
        incompatibleBaseCan: "A bÃ¡zis nem kompatibilis az adott alaptermÃ©kkel vagy bÃ¡zissal vagy kiszerelÃ©sÃ©vel",
        incorrectPassword: "A rÃ©gi jelszava nem helyes. KÃ©rjÃ¼k, adjon meg egy helyeset.",
        invalidCurrency: "ÃrvÃ©nytelen valuta megnevezÃ©s. AlapÃ©rtelmezett valuta az Euro",
        invalidDatabaseName: "Az adatbÃ¡zis neve nem Ã©rvÃ©nyes",
        invalidEmail: "Az Ãn e-mail cÃ­me nem Ã©rvÃ©nyes",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "ÃrvÃ©nytelen cÃ©ges felhasznÃ¡lÃ³i kÃ³d",
        invalidLicenseFile: "ÃrvÃ©nytelen licecn fÃ¡jl",
        invalidLicenseIdentificationKeys: "Az Ãn licenc azonosÃ­tÃ³ kulcsai nem Ã©rvÃ©nyesek",
        invalidLicenseKey: "Az Ãn licence nem Ã©rvÃ©nyes",
        invalidLicenseProduct: "A licencfÃ¡jl nem felel meg a termÃ©knek",
        invalidRccResponse: "VÃ¡ratlan hiba tÃ¶rtÃ©nt az utolsÃ³ RCC-vÃ¡lasz feldolgozÃ¡sa sorÃ¡n.",
        invalidServerResponse: "VÃ¡ratlan hiba tÃ¶rtÃ©nt a kiszolgÃ¡lÃ³ utolsÃ³ visszajelzÃ©sÃ©nek feldolgozÃ¡sa sorÃ¡n",
        invalidUrl: "ÃrvÃ©nytelen URL",
        itemNotFound: "Az adott tÃ©tel nem talÃ¡lhatÃ³",
        keyboardShortcutUsedInModal:
            "Ez a billentyÅ±parancs nem hasznÃ¡lhatÃ³ a modÃ¡lis ablakban. KÃ©rjÃ¼k, zÃ¡rja be a modÃ¡lis ablakot.",
        keyboardShortcutValidation: "Nem lehet ugyanaz a billentyÅ±parancs kÃ©t kÃ¼lÃ¶nbÃ¶zÅ mÅ±velethez.",
        licenseHasBeenRevoked: "Az engedÃ©lyÃ©t visszavontÃ¡k. A megÃºjÃ­tÃ¡shoz forduljon a szoftver szÃ¡llÃ­tÃ³jÃ¡hoz.",
        licenseProlongationNeeded:
            "SzÃ¼ksÃ©ges a licenc meghosszabbÃ­tÃ¡sa (Ãºj licenc megszerzÃ©sÃ©hez csatlakoztassa a szÃ¡mÃ­tÃ³gÃ©pet az internethez) ",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "MÃ¡sik szÃ¡mÃ­tÃ³gÃ©pen aktivÃ¡lt eredeti licenc",
        logFileArchiveDownloadComplete: "A naplÃ³archÃ­vum letÃ¶ltÃ©se sikeresen befejezÅdÃ¶tt",
        loginError: "VÃ¡ratlan hiba tÃ¶rtÃ©nt a bejelentkezÃ©s sorÃ¡n",
        logoutError: "VÃ¡ratlan hiba tÃ¶rtÃ©nt a kijelentkezÃ©s sorÃ¡n",
        machineIsConnecting: "PasztÃ¡zÃ³gÃ©p csatlakoztatva, kÃ©rem vÃ¡rjon!",
        machineIsNotConnected: "A kÃ©szÃ¼lÃ©k nem csatlakozik az RCC-hez. KÃ©rjÃ¼k, ellenÅrizze az RCC konfigurÃ¡ciÃ³t.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "ElÃ©rte a megnyithatÃ³ maximÃ¡lis lapok szÃ¡mÃ¡t, kÃ©rjÃ¼k zÃ¡rjon be egyet.",
        noTemplate: "A nyomtatÃ¡st nem lehet elvÃ©gezni, mivel nem Ã¡llnak rendelkezÃ©sre sablonok.",
        openNewTab: "KÃ©rjÃ¼k, nyisson egy Ãºj kÃ©pletfÃ¼let a kÃ©plet betÃ¶ltÃ©sÃ©hez vonalkÃ³d hasznÃ¡latÃ¡val",
        orderAlreadyAcquired: "A megrendelÃ©s mÃ¡r beszerzÃ©sre kerÃ¼lt, elÅszÃ¶r fel kell szabadÃ­tani",
        orderCreated: "A rendelÃ©s sikeresen elkÃ¼ldve",
        passwordIsNotUnique: "A rÃ©gi jelszÃ³nak kÃ¼lÃ¶nbÃ¶znie kell az ÃºjtÃ³l.",
        printCannotBeCarriedOut: "A nyomtatÃ¡st nem lehet elvÃ©gezni, mert a nyomtatÃ³ neve Ã©rvÃ©nytelen.",
        problemWithFileExport: "Hiba tÃ¶rtÃ©nt a fÃ¡jl lemezre mentÃ©se kÃ¶zben.",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "A termÃ©k nem engedÃ©lyezett",
        rccDefaultMessage: "VÃ¡ratlan hiba tÃ¶rtÃ©nt az utolsÃ³ RCC mÅ±velet sorÃ¡n",
        rccError: "RCC hiba",
        rccNeedRestart: "KÃ©rjÃ¼k indÃ­tsa Ãºjra az RCC-t",
        restoredSettings: "A beÃ¡llÃ­tÃ¡sok helyreÃ¡lltak.",
        revokedLicense: "Visszavont licenc",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "A formulÃ¡t sikeresen Ã¡tmentettÃ©k az elÅzmÃ©nyekbe.",
        savedLogArchive: "A naplÃ³archÃ­vum sikeresen el lett mentve a kÃ¶nyvtÃ¡rÃ¡ba.",
        scanning: "A beolvasÃ¡s folyamatban van",
        serverError: "Szerver hiba",
        setClientIdentifier: "KÃ©rjÃ¼k, Ã¡llÃ­tsa be az Ã¼gyfÃ©l azonosÃ­tÃ³jÃ¡t",
        showLess: "Kevesebb mutatÃ¡sa",
        showMore: "TÃ¶bb mutatÃ¡sa",
        spectroIsDisconnecting: "SpektrofotomÃ©ter nincs csatlakoztatva, kÃ©rem vÃ¡rjon!",
        spectroIsNotConnected: "A spektrofotomÃ©ter nem csatlakozik. KÃ©rjÃ¼k ellenÅrizze az RCC konfigurÃ¡ciÃ³t.",
        spectroIsNotSelected: "A spektrofotomÃ©ter nem csatlakozik. KÃ©rjÃ¼k ellenÅrizze az RCC konfigurÃ¡ciÃ³t.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Ismeretlen hiba: %{0}",
        userAlreadyLoggedIn: "Ãn mÃ¡r bejelentkezett!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Nem tudott csatlakozni a Web Api kiszolgÃ¡lÃ³hoz",
        webApiInternalError: "Web Api szerver belsÅ hiba",
        webApiInvalidUser: "Web Api szerver Ã©rvÃ©nytelen felhasznÃ¡lÃ³",
        webApiNoLicenseAvailable: "Web Api szerver nincs licenc",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "A bemenet rossz formÃ¡tumÃº %{0} ",
        wrongRccVersion: "KÃ©rjÃ¼k ellenÅrizze az RCC verziÃ³jÃ¡t. A kÃ©szÃ¼lÃ©ke csak az RCC-vel %{0} kompatibilis."
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "AktÃ­v felhasznÃ¡lÃ³",
        logOut: "KijelentkezÃ©s",
        machineErrors: "SzÃ­nezÅgÃ©p hibÃ¡k"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Az adatbÃ¡zisban elÃ©rhetÅ Ã¶sszes egysÃ©g",
        allowCustomFormulas: "Egyedi recepteket engedÃ©lyezÃ©se",
        allowCustomPackageSize: "Egyedi kiszerelÃ©seket engedÃ©lyezÃ©se",
        allowFormulaAutomaticNaming: "Automatikus elnevezÃ©s engedÃ©lyezÃ©se",
        automaticNaming: "Recept automatikus elnevezÃ©se",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "SzÃ­npaletta",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "VersenykÃ©pes szÃ­nkeresÃ©s",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "EgyÃ©ni egysÃ©gek ",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "Egyedi kiszerelÃ©s",
        customUnits: "EgyÃ©ni egysÃ©gek kivÃ¡lasztÃ¡sa",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "SzÃ­nezÅpasztÃ¡k szerkesztÃ©se",
        editColorantsAllowed: "SzÃ­nezÅpasztÃ¡k szerkesztÃ©sÃ©nek engedÃ©lyezÃ©se",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "Kedvenc receptek",
        formulaColorPreview: "Recept szÃ­nes elÅnÃ©zet",
        formulaDataSettings: "Recept adatainak beÃ¡llÃ­tÃ¡sa",
        formulaPanel: "Ãsszes recept",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "Recept beÃ¡llÃ­tÃ¡sok",
        generateColorPreview: "SzÃ­nes elÅnÃ©zet lÃ©trehozÃ¡sa",
        gravimetricOnly: "Csak gravimetrikus egysÃ©gek",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "ÃtmÃ©retezhetÅ tÃ¶bb informÃ¡ciÃ³ panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Az egysÃ©g a kivÃ¡lasztott termÃ©ktÅl fÃ¼gg",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Gyors kivÃ¡lasztÃ¡s",
        setAdditionalFormulaPanel: "TovÃ¡bbi recept beÃ¡llÃ­tÃ¡sa",
        setCompetitiveColorSearch: "VersenykÃ©pes szÃ­nkeresÃ©s engedÃ©lyezÃ©se",
        setInitialFormulaPanel: "Receptek megjelenÃ­tÃ©sÃ©nek beÃ¡llÃ­tÃ¡sa",
        setMaxToleranceForCompetitiveColors: "MaximÃ¡lis tÅ±rÃ©shatÃ¡r beÃ¡llÃ­tÃ¡sa a versenykÃ©pes szÃ­nkeresÃ©shez",
        setNumberOfCompetitiveColors: "VersenykÃ©pes szÃ­nek szÃ¡mÃ¡nak beÃ¡llÃ­tÃ¡sa",
        setSearchPanel: "KeresÃ©si panel beÃ¡llÃ­tÃ¡sa",
        setVisibilityAndOrder: "KÃ¼lÃ¶nbÃ¶zÅ receptek adatainak Ã©s lÃ¡thatÃ³sÃ¡gÃ¡nak beÃ¡llÃ­tÃ¡sa",
        setVisibleUnit: "ÃllÃ­tsa be az egysÃ©geket",
        showColorPreview: "SzÃ­nes elÅnÃ©zet hasznÃ¡lata",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "SzÃ­nezÅanyag-panel vÃ¡logatÃ¡s",
        useBase: "A kivÃ¡lasztÃ¡si elem hasznÃ¡lata az alaphoz",
        useBaseInProductPackage: "KivÃ¡lasztÃ¡si elem hasznÃ¡lata a termÃ©kcsomag alapjÃ¡hoz",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "TermÃ©k kivÃ¡lasztÃ¡si elem hasznÃ¡lata",
        useProductCode: "TermÃ©kkÃ³d hasznÃ¡lata",
        useProductGroups: "Use product groups",
        volumetricOnly: "Csak tÃ©rfogategysÃ©gek"
    },
    general: {
        accepted: "Accepted",
        active: "UtolsÃ³ hasznÃ¡lat",
        actual: "TÃ©nyleges",
        actualLevel: "TÃ©nyleges szint",
        add: "HozzÃ¡adÃ¡s",
        addColorant: "SzÃ­nezÅpaszta hozzÃ¡adÃ¡sa",
        addColorantForPackage: "SzÃ­nezÅanyag hozzÃ¡adÃ¡sa a csomagolÃ¡shoz",
        addFile: "FÃ¡jl hozzÃ¡adÃ¡sa",
        all: "Ãsszes",
        amount: "Ãsszeg",
        applyNow: "Apply now",
        attachments: "MellÃ©kletek",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "ElÃ©rhetÅ",
        back: "Vissza ",
        base: "BÃ¡zis",
        baseInProductPackage: "BÃ¡zis Ã©s kiszerelÃ©s",
        batchNumber: "Batch number",
        bottom: "Bottom",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "VÃ¶dÃ¶r",
        canSize: "KiszerelÃ©s",
        cancel: "MÃ©gse",
        canister: "Kaniszter",
        canisterId: "Kaniszter azonosÃ­tÃ³ja",
        canisterIndex: "Canister Index",
        canisters: "Kaniszterek",
        cap: "ZÃ¡rÃ³kupak",
        capacity: "KapacitÃ¡s",
        channels: "CsatornÃ¡k",
        choose: "VÃ¡lasszon",
        city: "VÃ¡ros",
        clean: "Tiszta",
        clear: "TisztÃ­tÃ¡s",
        client: "ÃgyfÃ©l",
        close: "ZÃ¡rva",
        closeAll: "Close all",
        collapseAll: "Ãsszes Ã¶sszecsukÃ¡sa",
        color: "SzÃ­n",
        colorCode: "SzÃ­n kÃ³dja",
        colorFile: "Colorfile",
        colorName: "SzÃ­n nÃ©v",
        colorPreview: "SzÃ­n elÅnÃ©zete",
        colorant: "SzÃ­nezÅpaszta",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "SzÃ­nezÅpaszta kiszerelÃ©s",
        colorants: "SzÃ­nezÅpasztÃ¡k",
        colors: "Colors",
        company: "CÃ©g",
        competitiveColor: "Competitive color",
        confirm: "MegerÅsÃ­t",
        confirmDeletion: "ValÃ³ban tÃ¶rli vÃ©glegesen ezt az elemet?",
        confirmHelpSettings: "TÃ©nyleg el akarja menteni az Å±rlapot, Ã©s Ã¼resen akarja hagyni a mezÅket?",
        connect: "Kapcsolat",
        continue: "FolytatÃ¡s",
        correction: "Correction",
        country: "OrszÃ¡g",
        created: "KÃ©sz ",
        creationDateOf: "Creation date of",
        criticalLevel: "Kritikus szint",
        currency: "PÃ©nznem",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Egyedi",
        customData: "Custom data",
        customFandeck: "Egyedi recept",
        customFormula: "Custom formula",
        customPackage: "Egyedi",
        customPackageSettings: "EgyÃ©ni csomagbeÃ¡llÃ­tÃ¡sok",
        customer: "VevÅ",
        customerVersion: "VevÅi pÃ©ldÃ¡ny",
        customers: "VevÅk",
        database: "AdatbÃ¡zis",
        date: "DÃ¡tum",
        default: "AlapÃ©rtelmezett",
        delete: "TÃ¶rlÃ©s",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "LeÃ­rÃ¡s",
        disconnect: "SzÃ©tkapcsolÃ¡s",
        discount: "Discount",
        discover: "KeresÃ©s",
        dispense: "SzÃ­nezÃ©s",
        dispensing: "SzÃ­nezÃ©s",
        doNotShowAgain: "Ne jelenÃ­tse meg ezt az Ã¼zenetet Ãºjra.",
        downloadingFile: "FÃ¡jlok letÃ¶ltÃ©se",
        edit: "SzerkesztÃ©s",
        email: "Email",
        enabled: "EngedÃ©lyezve",
        error: "Hiba",
        expandAll: "Minden bÅvÃ­tÃ©se",
        exportData: "Adatok exportÃ¡lÃ¡sa",
        exportPdf: "PDF exportÃ¡lÃ¡sa",
        fan: "SzÃ­n",
        fandeck: "SzÃ­nkÃ¡rtya",
        fandeckCode: "Fandeck code",
        fandeckName: "SzÃ­nkÃ¡rtya neve",
        fandecks: "Fandecks",
        favorite: "Kedvenc",
        fileTransfer: "File transfer",
        filling: "KitÃ¶ltÃ©s",
        fillingDate: "KitÃ¶ltÃ©s dÃ¡tuma",
        find: "TalÃ¡lat",
        finish: "BefejezÃ©s",
        finishedCorrection: "Finished correction",
        formula: "recept",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "QR kÃ³d olvasÃ¡s",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "ElÅzmÃ©nyek",
        hours: "Hou.",
        id: "Id",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "Olvassa be a vonalkÃ³dot",
        install: "TelepÃ­t",
        installed: "TelepÃ­tve",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IP cÃ­m",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "Recept betÃ¶ltÃ©se",
        localVersion: "Helyi verziÃ³",
        machine: "SzÃ­nezÅgÃ©p",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "ÃrrÃ©s",
        markup: "Haszonkulcs",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "MaximÃ¡lis szint",
        maxValue: "MaximÃ¡lis Ã©rtÃ©k",
        maximum: "maximum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "minimum",
        minutes: "Min.",
        missingItem: "HiÃ¡nyzÃ³ elem",
        missingRequiredItems: "Minden kÃ¶telezÅ elemet (csillaggal jelÃ¶lve) ki kell tÃ¶lteni.",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "RÃ©szletek",
        moreInfo: "TÃ¶bb informÃ¡ciÃ³",
        moveDown: "Le",
        moveUp: "Fel",
        myOrders: "MegrendelÃ©sek",
        name: "Neve",
        nameTitle: "CÃ­m",
        new: "Ãj",
        next: "kÃ¶vetezÅ",
        no: "Nem",
        noColorantsAvailable: "SzÃ­nezÅanyagok nem Ã¡llnak rendelkezÃ©sre",
        noFormulas: "MÃ©g nincsenek formulÃ¡k",
        noPricesAvailable: "MÃ©g nincsenek Ã¡rak",
        nominalAmount: "NÃ©vleges mennisÃ©g",
        notAvailable: "Nem Ã¡ll rendelkezÃ©sre",
        note: "MegjegyzÃ©s",
        numberOfCanisters: "Kaniszterek szÃ¡ma",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "CÃ­mkÃ©k szÃ¡ma",
        numberOfPackages: "KiszerelÃ©sek szÃ¡ma",
        off: "KikapcsolÃ¡s",
        ok: "Rendben",
        on: "BekapcsolÃ¡s",
        onFocus: "A fÃ³kuszban",
        open: "Megnyit",
        operator: "Operator",
        options: "OpciÃ³k",
        order: "Order",
        other: "MÃ¡s/MÃ¡sik",
        otherError: "MÃ¡s hiba",
        out: "Out",
        overwrite: "Overwrite",
        package: "KÃ©sztermÃ©k",
        packagePreview: "KiszerelÃ©s elÅnÃ©zete",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Ãr",
        priceGroup: "Ãrcsoport",
        print: "NyomtatÃ¡s",
        printTask: "NyomtatÃ¡si feladat",
        processingStep: "Processing %{step}",
        product: "TermÃ©k",
        productCode: "TermÃ©kkÃ³d",
        productName: "TermÃ©k neve",
        products: "TermÃ©kek",
        pump1: "Pumpa 1",
        pump2: "Pumpa 2",
        purchasePrice: "VÃ©telÃ¡r",
        purge: "TisztitÃ¡s",
        qualityControl: "Quality control",
        quantity: "MennyisÃ©g",
        quantityQty: "QTY",
        quickTint: "Gyors szÃ­nezÃ©s",
        rccIsNotAvailable: "RCC nem elÃ©rhetÅ",
        rccIsNotConnected: "RCC nincs csatlakoztatva",
        rccNotLicensed: "RCC-hez nincs licenc",
        reconnect: "ÃjrakapcsolÃ³dÃ¡s",
        refill: "UtÃ¡ntÃ¶ltÃ©s",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "VisszaÃ¡llÃ­tÃ¡s",
        restart: "ÃjraindÃ­tÃ¡s",
        restore: "Restore",
        retint: "Retint",
        revision: "FelÃ¼lvizsgÃ¡lat",
        safetySheet: "Safety sheet",
        save: "MentÃ©s",
        saveAs: "MentÃ©s mint",
        saveToDispensingHistory: "MentÃ©s az elÅzmÃ©nyekbe",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Ãsszes kivÃ¡lasztÃ¡sa",
        selectChannels: "Csatorna kivÃ¡lasztÃ¡sa",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "EladÃ¡si Ã¡r",
        settings: "BeÃ¡llÃ­tÃ¡sok",
        shelf: "Polc",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "mÃ©ret",
        skip: "Kihagy",
        smartPurge: "Intelligens tisztÃ­tÃ¡s",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "SpeckrofotomÃ©ter",
        standardFormula: "Standard formula",
        status: "Ãllapot",
        street: "Utca",
        sum: "Sum",
        summary: "ÃsszegzÃ©s",
        sync: "Sync",
        technicalSheet: "Technical sheet",
        templates: "Sablonok",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "RendelÃ©sek szÃ­nezÃ©se",
        top: "Top",
        total: "Teljes",
        totalAmount: "Teljes Ã¶sszeg",
        totalBaseAmount: "Teljes alapÃ¶sszeg",
        totalColorantAmount: "Ãsszes szÃ­nezÅanyag mennyisÃ©ge",
        type: "Type",
        ufiCode: "UFI-kÃ³d",
        ufiThreshold: "UFI kÃ¼szÃ¶bÃ©rtÃ©k",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "EgysÃ©gek",
        unknown: "Unknown",
        update: "FrissÃ­tÃ©s",
        updated: "FrissÃ­tett",
        user: "FelhasznÃ¡lÃ³",
        value: "ÃrtÃ©k",
        vat: "Ãfa",
        verified: "Verified",
        version: "VerziÃ³",
        versionId: "VerziÃ³ azonosÃ­tÃ³",
        versionStructure: "VerziÃ³ szerkezete",
        volumetric: "Volumetric",
        warning: "FigyelmeztetÃ©s",
        warningLevel: "FigyelmeztetÃ©si szint",
        withoutName: "(nÃ©v nÃ©lkÃ¼l)",
        workingProperly: "Working properly",
        yes: "Igen",
        zoom: "NagyÃ­tÃ¡s"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan kÃ©rje az ecsettartÃ¡ly tisztÃ­tÃ¡sÃ¡t. Az adagolÃ³ kezelÅjÃ©nek manuÃ¡lisan kell eltÃ¡volÃ­tania, megtisztÃ­tania, majd visszahelyeznie a kefetartÃ¡lyt.",
            capMaintenance:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan kÃ©rje a kupak tisztÃ­tÃ¡sÃ¡t. Az adagolÃ³ kezelÅjÃ©nek manuÃ¡lisan kell megtisztÃ­tania az automatikus kupakot, miutÃ¡n az kinyÃ­lt.",
            cleanAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna tisztÃ­tÃ¡sÃ¡ra vonatkozÃ³ mÅ±veletet.",
            cleanChannels:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott csatornÃ¡k automatikus tisztÃ­tÃ¡sÃ¡ra szolgÃ¡lÃ³ mÅ±veletet a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze.",
            computerReboot:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy a szÃ¡mÃ­tÃ³gÃ©p a meghatÃ¡rozott idÅpontban automatikusan Ãºjrainduljon.",
            computerShutdown:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy a szÃ¡mÃ­tÃ³gÃ©p a meghatÃ¡rozott idÅpontban automatikusan kikapcsoljon.",
            dispenserCleaning:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan kÃ©rje az adagolÃ³ tisztÃ­tÃ¡sÃ¡t. Az adagolÃ³ kezelÅjÃ©nek manuÃ¡lisan kell megtisztÃ­tania a gÃ©pet egy ronggyal.",
            humidifierWaterLevelMaintenance:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan kÃ©rje a pÃ¡rÃ¡sÃ­tÃ³ feltÃ¶ltÃ©sÃ©nek mÅ±veletÃ©t. Az adagolÃ³ kezelÅjÃ©nek manuÃ¡lisan kell ellenÅriznie Ã©s ÃºjratÃ¶ltenie a pÃ¡rÃ¡sÃ­tÃ³ban lÃ©vÅ vizet.",
            purgeAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna kiÃ¼rÃ­tÃ©sÃ©re vonatkozÃ³ mÅ±veletet.",
            purgeChannels:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy az adagolÃ³ a meghatÃ¡rozott csatornÃ¡k automatikus tisztÃ­tÃ¡sÃ¡ra szolgÃ¡lÃ³ mÅ±veletet a meghatÃ¡rozott idÅpontban vÃ©gezze el.",
            recirculateAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna ÃºjrakeringetÃ©sÃ©nek mÅ±veletÃ©t.",
            recirculateChannels:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy az adagolÃ³ a meghatÃ¡rozott csatornÃ¡k automatikus visszakeringtetÃ©sÃ©re vonatkozÃ³ mÅ±veletet a meghatÃ¡rozott idÅpontban vÃ©gezze el.",
            refillAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna ÃºjratÃ¶ltÃ©sÃ©nek mÅ±veletÃ©t.",
            refillCanisters:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy a %{name} a meghatÃ¡rozott csatornÃ¡k automatikus ÃºjratÃ¶ltÃ©sÃ©re vonatkozÃ³ mÅ±veletet a meghatÃ¡rozott idÅpontban vÃ©gezze el.",
            smartPurgeAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna intelligens tisztÃ­tÃ¡sÃ¡nak mÅ±veletÃ©t. A tisztÃ­tÃ¡s vÃ©grehajtÃ¡sra kerÃ¼l, hacsak nem teljesÃ¼lnek az intelligens tisztÃ­tÃ¡si szabÃ¡lyok.",
            smartPurgeChannels:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott csatornÃ¡k intelligens tisztÃ­tÃ¡sÃ¡ra szolgÃ¡lÃ³ mÅ±veletet a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze. A tisztÃ­tÃ¡s vÃ©grehajtÃ¡sra kerÃ¼l, hacsak nem teljesÃ¼lnek az intelligens tisztÃ­tÃ¡si szabÃ¡lyok.",
            stirAll:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy az adagolÃ³ a meghatÃ¡rozott idÅpontban automatikusan elvÃ©gezze az Ã¶sszes csatorna felkeverÃ©sÃ©re vonatkozÃ³ mÅ±veletet.",
            stirCanisters:
                "ÃllÃ­tsa be ezt az automatikus feladatot Ãºgy, hogy az adagolÃ³ a meghatÃ¡rozott csatornÃ¡k automatikus keverÃ©sÃ©re vonatkozÃ³ mÅ±veletet kÃ©rjen a meghatÃ¡rozott idÅpontban.",
            switchPlateMaintenance:
                "ÃllÃ­tsa be ezt az automatikus feladatot, hogy a %{name} a meghatÃ¡rozott idÅpontban automatikusan kÃ©rje a kapcsolÃ³tÃ¡nyÃ©r tisztÃ­tÃ¡sÃ¡t. Az adagolÃ³ kezelÅjÃ©nek manuÃ¡lisan kell eltÃ¡volÃ­tania, megtisztÃ­tania, majd visszahelyeznie a kapcsolÃ³tÃ¡nyÃ©rt."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "LehetÅvÃ© teszi egy Ãºj kiszolgÃ¡lÃ³ manuÃ¡lis hozzÃ¡adÃ¡sÃ¡t, ha azt nem sikerÃ¼lt felismerni a FelfedezÃ©s funkciÃ³val.",
            clientIdentifier:
                "A beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi az Ã¼gyfÃ©l azonosÃ­tÃ¡sÃ¡t, ha egy kiszolgÃ¡lÃ³hoz tÃ¶bb Ã¼gyfÃ©l is csatlakozik.",
            disconnect:
                "InformÃ¡ciÃ³ a jelenleg hasznÃ¡lt kiszolgÃ¡lÃ³rÃ³l. A kapcsolat megszakÃ­tÃ¡sa gomb lehetÅvÃ© teszi, hogy elhagyja ezt a kiszolgÃ¡lÃ³t, Ã©s egy mÃ¡sikra vÃ¡ltson, ha rendelkezÃ©sre Ã¡ll.",
            discover: "Felfedi, hogy van-e mÃ¡s szerver is a hÃ¡lÃ³zatban.",
            dropServers: "TÃ¶rli az Ã¶sszes korÃ¡bban Ã©szlelt szervert a listÃ¡bÃ³l.",
            dropServersNotAvailable: "Nincs elÃ©rhetÅ szerver",
            edit: "LehetÅvÃ© teszi egy mÃ¡r megtalÃ¡lt kiszolgÃ¡lÃ³ kÃ©zi szerkesztÃ©sÃ©t.",
            editDisabled: "Nincs kivÃ¡lasztott kiszolgÃ¡lÃ³."
        },
        continue: "TÃ©nyleg folytatni szeretnÃ©?",
        driverSettings: {
            alfaRestApi: {
                host: "Ãrja be a szÃ¡mÃ­tÃ³gÃ©p Ã¡llomÃ¡snevÃ©t vagy IP-cÃ­mÃ©t.",
                machineType: "Minden Alfa gÃ©pre Ã©rvÃ©nyes. Windowsra Ã©s Linuxra egyarÃ¡nt."
            },
            corobDsProxy: {
                machineType:
                    "ÃrvÃ©nyes a generÃ¡ciÃ³k Slave (D200, D600..), 4G (First One) Ã©s 5G (EvoFlx) esetÃ©ben. A DspProxy-t telepÃ­teni kell. Csak Windows."
            },
            corobEvoDriver: {
                machineType:
                    "ÃrvÃ©nyes az 5G (EvoFlx) generÃ¡ciÃ³ra. Az EVOservice-t telepÃ­teni kell. Windows Ã©s Linux alatt is."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "VÃ¡lassza ki az adagolÃ³ konfigurÃ¡ciÃ³s fÃ¡jljÃ¡t. AlapÃ©rtelmezett elÅbeÃ¡llÃ­tÃ¡s.",
                hldRootDir: "VÃ¡lassza ki a HLD fÅ mappÃ¡jÃ¡t. AlapÃ©rtelmezett elÅbeÃ¡llÃ­tÃ¡s.",
                machineType:
                    "ÃrvÃ©nyes a Corob Flex (500, 520, 540) = korÃ¡bbi Lenteq. A HLD-t be kell szerelni. Csak Windows."
            },
            corobNextDriver: {
                machineType:
                    "ÃrvÃ©nyes a generÃ¡ciÃ³khoz Slave (D200, D600..), 4G (First One) Ã©s 5G (EvoFlx). A NextDriver-t telepÃ­teni kell. Csak Linux."
            },
            dromontDDrv: {
                databasePath:
                    "A kalibrÃ¡ciÃ³s adatokat tartalmazÃ³ adatbÃ¡zisfÃ¡jl elÃ©rÃ©si Ãºtvonala. AlapÃ©rtelmezett alapbeÃ¡llÃ­tÃ¡s.",
                driverPath: "Az illesztÅprogram (D_DRV.exe) elÃ©rÃ©si Ãºtja. AlapÃ©rtelmezett elÅbeÃ¡llÃ­tÃ¡s.",
                machineType:
                    "KÃ¶zvetett automatakommunikÃ¡ciÃ³ a beÃ¡llÃ­tott elÃ©rÃ©si utakon keresztÃ¼l. ÃrvÃ©nyes a V1 Ã©s V2 generÃ¡ciÃ³kra. A D_SET-et telepÃ­teni kell. Windows Ã©s Linux operÃ¡ciÃ³s rendszerekhez egyarÃ¡nt.",
                resultPath:
                    "A mÅ±velet befejezÃ©se utÃ¡n lÃ©trehozott eredmÃ©nyfÃ¡jl elÃ©rÃ©si Ãºtvonala. AlapÃ©rtelmezett elÅre beÃ¡llÃ­tott.",
                serviceSoftwarePath: "A Dromont szervizszoftver (D_SET.exe) elÃ©rÃ©si Ãºtvonala. Defalut elÅbeÃ¡llÃ­tÃ¡s."
            },
            dromontDirect: {
                machineType:
                    "KÃ¶zvetlen adagolÃ³kommunikÃ¡ciÃ³. ÃrvÃ©nyes a V1 Ã©s V2 generÃ¡ciÃ³kra. A D_SET-et telepÃ­teni kell. Windows Ã©s Linux operÃ¡ciÃ³s rendszerekhez egyarÃ¡nt.",
                rootDir: "VÃ¡lassza ki a fÅ Dromont mappÃ¡t, alapÃ©rtelmezett elÅbeÃ¡llÃ­tÃ¡s."
            },
            dromontMisura: {
                driverPath:
                    "Az illesztÅprogram (MisuraRetail.exe) elÃ©rÃ©si Ãºtja a Misura Retail verziÃ³jÃ¡tÃ³l fÃ¼ggÅen vÃ¡ltozhat. AlapÃ©rtelmezett elÅbeÃ¡llÃ­tÃ¡s.",
                extensionPath: "A szolgÃ¡ltatÃ¡si mÅ±veletek kommunikÃ¡ciÃ³s fÃ¡jljÃ¡nak elÃ©rÃ©si Ãºtja.",
                formulaPath: "Az adagolÃ¡shoz szÃ¼ksÃ©ges kommunikÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtja.",
                machineType: "A V3-as generÃ¡ciÃ³ra Ã©rvÃ©nyes. A Dromont MisurÃ¡t telepÃ­teni kell. Csak Windows."
            },
            fastAndFluidIDD: {
                machineType: "ÃrvÃ©nyes minden F&F gÃ©pre. Csak Windows.",
                path: "TÃ¡mogatottak: IDD2 (HA 450, HA 650, X-smart, stb.) - licencelni kell, IDD3 (HP 500, stb.), IDD4 (HA 180, HA 480, HA 680, Xprotint, stb.)."
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "ÃrvÃ©nyes minden F&F gÃ©pre. Windows Ã©s Linux egyarÃ¡nt.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "ÃrvÃ©nyes minden Hero gÃ©pre. Csak Windowsra."
            },
            italtinto: {
                machineType:
                    "ÃrvÃ©nyes minden Italtinto gÃ©pre. Wcal vagy ItaltintoCal telepÃ­tve kell lennie. Csak Windows.",
                path: "A beÃ¡llÃ­tott Italtinto konfigurÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtvonala."
            },
            manualAdvanced: {
                machineType:
                    "ÃrvÃ©nyes minden kÃ©zi gÃ©pre, beleÃ©rtve a tartÃ¡ly tÃ¡mogatÃ¡sÃ¡t is. Windows Ã©s Linux is hasznÃ¡lhatÃ³.",
                path: "Az adagolÃ³ra Ã©s a tartÃ¡lyokra vonatkozÃ³ adatokat tartalmazÃ³ konfigurÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtvonala."
            },
            manualSimple: {
                machineType: "ÃrvÃ©nyes minden kÃ©zi gÃ©pre. Windows Ã©s Linux egyarÃ¡nt.",
                path: "Az adagolÃ³ra vonatkozÃ³ adatokat tartalmazÃ³ konfigurÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtja."
            },
            none: {
                machineType: "Nincs kivÃ¡lasztva az adagolÃ³ illesztÅprogramja."
            },
            santintColorLink3: {
                machineType: "ÃrvÃ©nyes minden Santint gÃ©pre. Csak Windows."
            },
            simulation: {
                machineType: "SzimulÃ¡ciÃ³s adagolÃ³ra Ã©rvÃ©nyes, ha nincs a szÃ¡mÃ­tÃ³gÃ©phez csatlakoztatott valÃ³di adagolÃ³.",
                path: "A szimulÃ¡ciÃ³s konfigurÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtja, amelynek Ã¶sszhangban kell lennie a beillesztett adatbÃ¡zissal."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "A kiegÃ©szÃ­tÅ szoftvercsatlakozÃ³k Ã¡ttekintÃ©se.",
            allowAutoCloseTab:
                "Bekapcsolt beÃ¡llÃ­tÃ¡s esetÃ©n az egyes kÃ©pletlapok automatikusan bezÃ¡rÃ³dnak, miutÃ¡n az adagolÃ¡si folyamat befejezÅdÃ¶tt.",
            allowAutomaticClientStart: "Ha be van kapcsolva, %{name} automatikusan elindul a szÃ¡mÃ­tÃ³gÃ©p indÃ­tÃ¡sa utÃ¡n.",
            allowAutomaticPrint:
                "A cÃ­mke automatikusan kinyomtatÃ¡sra kerÃ¼l. A nyomtatÃ¡s tovÃ¡bbi beÃ¡llÃ­tÃ¡st igÃ©nyel az adagolÃ¡s elÅtt, utÃ¡n vagy mindkÃ©t esetben.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "A recepten a vevÅ rÃ©sz elÃ©rhetÅ lesz.",
            allowDispensing: "A Formula panelen az AdagolÃ¡s gomb aktivÃ¡lÃ³dik.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} lesz elÃ©rhetÅ..",
            allowOrdering: "A recepten aktivÃ¡lÃ³dik a rendelÃ©s gomb.",
            allowPricing:
                "A Formula panelen az Ã¡rak hasznÃ¡lhatÃ³k. Az Ã¡rak lÃ¡thatÃ³sÃ¡ga az ElÃ©rhetÅ Ã¡rak menÃ¼pontban van beÃ¡llÃ­tva. Az Ã¡rak beÃ¡llÃ­tÃ¡sa az ÃrbeÃ¡llÃ­tÃ¡sok menÃ¼pontban tÃ¶rtÃ©nik.",
            allowProductPreviewImage: "A termÃ©k kÃ©pe megjelenik az adagolÃ¡s sorÃ¡n.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification: "MegrendelÃ©s Ã©rkezÃ©sÃ©t  hangjelzÃ©s jelzi",
            allowSpectro: "A Spectro elÃ©rhetÅ lesz",
            allowTabs: "Ha ez a beÃ¡llÃ­tÃ¡s be van kapcsolva, egyszerre tÃ¶bb lapon is dolgozhat.",
            applyZoom:
                "A zoom nagyÃ­tja vagy csÃ¶kkenti a felbontÃ¡st. A CTRL + Ã©s a CTRL billentyÅ±parancsok szintÃ©n alkalmazhatÃ³k.",
            automaticLogout: "ÃllÃ­tsa be, hogy hÃ¡ny perc elteltÃ©vel aktivÃ¡lÃ³djon az automatikus kijelentkezÃ©s.",
            availableDatabases:
                "A beÃ¡llÃ­tÃ¡sok lehetÅvÃ© teszik az adatbÃ¡zisok kÃ¶zÃ¶tti vÃ¡ltÃ¡st, ha tÃ¶bb adatbÃ¡zis is rendelkezÃ©sre Ã¡ll.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "A vonalkÃ³d tesztelÃ©si kÃ¶rnyezet a beolvasott vonalkÃ³d helyessÃ©gÃ©nek ellenÅrzÃ©sÃ©re szolgÃ¡l az adatbÃ¡zisba beillesztett vonalkÃ³dokkal valÃ³ Ã¶sszehasonlÃ­tÃ¡ssal.",
            customBanner: "BeÃ¡llÃ­thatja sajÃ¡t logÃ³jÃ¡t vagy bannerÃ©t Ã©s annak pozÃ­ciÃ³jÃ¡t.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "A kivÃ¡lasztott nyomtatÃ³t a cÃ­mkÃ©k nyomtatÃ¡sÃ¡hoz fogja hasznÃ¡lni, kivÃ©ve, ha ezt a NyomtatÃ³ beÃ¡llÃ­tÃ¡sai ablakban megvÃ¡ltoztatja.",
            defaultTemplate:
                "A kivÃ¡lasztott sablont a cÃ­mkÃ©k nyomtatÃ¡sÃ¡hoz hasznÃ¡lja, kivÃ©ve, ha a NyomtatÃ³ beÃ¡llÃ­tÃ¡sai ablakban ezt megvÃ¡ltoztatja.",
            deleteImportedData:
                "Deletes the previously imported custom data. The data can be imported again after deletion.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "A Recept ablakban elÃ©rhetÅek lesznek az adagolÃ¡si rÃ©szletek.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "%{name},-ben  A virtuÃ¡lis billentyÅ±zet elÃ©rhetÅ lesz",
            exportLocalSettings: "A szÃ¡mÃ­tÃ³gÃ©p helyi beÃ¡llÃ­tÃ¡sainak exportÃ¡lÃ¡sa.",
            exportStaticSql:
                "A szÃ¡mÃ­tÃ³gÃ©p helyi beÃ¡llÃ­tÃ¡sainak exportÃ¡lÃ¡sa. Az exportÃ¡lt fÃ¡jl felhasznÃ¡lhatÃ³ egy adatbÃ¡zis lÃ©trehozÃ¡sÃ¡hoz ezzel a beÃ¡llÃ­tÃ¡ssal.",
            exportTranslationKeys:
                "ExportÃ¡lja a legÃºjabb fordÃ­tÃ¡sokat, Ã©s a fordÃ­tÃ¡s utÃ¡n kÃ¼ldje el e-mailben a szoftverszÃ¡llÃ­tÃ³jÃ¡nak, hogy importÃ¡lja azokat.",
            favoriteButton: "Kattintson a kÃ©plet kedvenckÃ©nt valÃ³ hozzÃ¡adÃ¡sÃ¡hoz",
            formulaNotes: "A recept ablakban megjelennek a recept rÃ©szletei",
            helpSettings: "Az informÃ¡ciÃ³ a gyors hozzÃ¡fÃ©rÃ©s ablakban lÃ©vÅ SÃºgÃ³ rÃ©szben talÃ¡lhatÃ³.",
            importCustomData: "ImportÃ¡lja a helyi egyÃ©ni adatokat a kivÃ¡lasztott formÃ¡tum alapjÃ¡n.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "ImportÃ¡lja a szÃ¡mÃ­tÃ³gÃ©p helyi beÃ¡llÃ­tÃ¡sait.",
            internalNote: "A Formula panelen elÃ©rhetÅvÃ© vÃ¡lik a belsÅ jegyzet szekciÃ³.",
            lockComputer:
                "A beÃ¡llÃ­tÃ¡sok biztosÃ­tjÃ¡k, hogy a %{name} kÃ¶rnyezetÃ©t nem lehet elhagyni - lehetÅvÃ© teszi a vÃ©gsÅ kioszk Ã¼zemmÃ³d Ã©lmÃ©nyÃ©t. Csak Windows esetÃ©n alkalmazhatÃ³.",
            maxNumberTabs: "Az ablak limittel beÃ¡llÃ­thatja, hogy hÃ¡ny recept ablakot lehet egyszerre megnyitni.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "A beÃ¡llÃ­tÃ¡shoz meg kell adni, hogy mennyi cÃ­mke mÃ¡solatot kell kinyomtatni az adagolÃ¡si folyamat utÃ¡n.",
            printAsImage:
                "KÃ©pkÃ©nt tÃ¶rtÃ©nÅ nyomtatÃ¡s segÃ­t megoldani a problÃ©mÃ¡t, amikor a szokÃ¡sos nyomtatÃ¡si mÃ³d nem mÅ±kÃ¶dik. Ne hasznÃ¡lja, ha a normÃ¡l nyomtatÃ¡s megfelelÅen mÅ±kÃ¶dik. Csak a Linuxal kompatibilis.",
            printBeforeDispensing:
                "A beÃ¡llÃ­tÃ¡shoz meg kell adni, hogy mennyi cÃ­mke mÃ¡solatot kell kinyomtatni az adagolÃ¡si folyamat utÃ¡n.",
            printEnabled:
                "Ez a beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi a nyomtatÃ³ hasznÃ¡latÃ¡t a szoftverrel. TovÃ¡bbi beÃ¡llÃ­tÃ¡sok a NyomtatÃ¡si beÃ¡llÃ­tÃ¡sok menÃ¼pontban talÃ¡lhatÃ³k.",
            printOnRequest: "A Recept ablakban aktivÃ¡lÃ³dik a nyomtatÃ¡s gomb",
            printTaskVariable:
                "A nyomtatÃ¡si feladat csak akkor kerÃ¼l feldolgozÃ¡sra, ha az adott nyomtatÃ¡si vÃ¡ltozÃ³ elÃ©rhetÅ a nyomtatÃ¡si adatok kÃ¶zÃ¶tt.",
            quickTintTemplate:
                "A kivÃ¡lasztott sablon lesz hasznÃ¡latban amikor a gyors szÃ­nezÃ©shez hasznÃ¡latos cÃ­mkÃ©ket nyomtatja",
            restoreLocalSettings: "HelyreÃ¡llÃ­tja a szÃ¡mÃ­tÃ³gÃ©p helyi beÃ¡llÃ­tÃ¡sait.",
            runLightAtStartUp: "%{light} fog elindulni a %{name} helyett",
            screenSaverTimeout: "ÃllÃ­tsa be, hogy hÃ¡ny perc elteltÃ©vel aktivÃ¡lÃ³djon a kÃ©pernyÅvÃ©dÅ.",
            selectCustomDataFormat:
                "VÃ¡lassza ki az importÃ¡landÃ³ eredeti adatok formÃ¡tumÃ¡t. Az egyes formÃ¡tumok kÃ¼lÃ¶nbÃ¶zÅ tovÃ¡bbi fÃ¡jlokat Ã©s beÃ¡llÃ­tÃ¡sokat igÃ©nyelhetnek.",
            setCustomHomeButton: "A KezdÅ gombra %{name} kattintva Ã¡tirÃ¡nyÃ­t a kivÃ¡lasztott ablakra",
            setFts: "A teljes szÃ¶veges keresÃ©s lehetÅvÃ© teszi a teljes szÃ¶veges kÃ©plet keresÃ©sÃ©t (a szÃ³ kÃ¶zepÃ©tÅl is, stb.).",
            setKeyboardShortcuts: "KÃ©t kÃ¼lÃ¶nbÃ¶zÅ mÅ±velethez nem lehet ugyanazt a gyorsbillentyÅ±t beÃ¡llÃ­tani.",
            setNumberOfDecimalPlaces:
                "A kerekÃ­tÃ©s azt Ã¡llÃ­tja be, hogy hÃ¡ny tizedesjegy legyen areceptben hasznÃ¡lt szÃ­nezÃ©keknÃ©l.",
            setOrderSearchParameters:
                "A megrendelÃ©s keresÃ©se meghatÃ¡rozza, hogy mely paramÃ©tereket kell hasznÃ¡lni a megrendelÃ©sek kÃ¶zÃ¶tti keresÃ©shez. Csak %{name} Ã©rhetÅ el.",
            setOverwriteLastTab:
                "Ãj kÃ©plet kivÃ¡lasztÃ¡sakor a globÃ¡lis keresÃ©sen keresztÃ¼l, mikÃ¶zben a kÃ©plet lapok korlÃ¡tjÃ¡t elÃ©rte, az utoljÃ¡ra betÃ¶ltÃ¶tt kÃ©plet lapot felÃ¼lÃ­rja az Ãºj kÃ©plet kivÃ¡lasztÃ¡sa.",
            setSearchPanel: "BeÃ¡llÃ­thatja a sajÃ¡t lÃ¡thatÃ³sÃ¡gÃ¡t Ã©s a hasznÃ¡lt elemek sorrendjÃ©t Ãºj kÃ©plet keresÃ©sekor.",
            setVisibilityAndOrder:
                "A kivÃ¡lasztott navigÃ¡ciÃ³s elemek lÃ¡thatÃ³k lesznek a gyors hozzÃ¡fÃ©rÃ©s ablakban. A legmagasabb pozÃ­ciÃ³ a bal szÃ©lsÅ ponttÃ³l kezdÅdik. A navigÃ¡ciÃ³s elemek maximÃ¡lisan megengedett mennyisÃ©ge 6.",
            setYourLanguage: "A nyelv megvÃ¡ltoztatÃ¡sÃ¡hoz a szoftver ÃºjraindÃ­tÃ¡sa szÃ¼ksÃ©ges.",
            settingsSearch: "NÃ©zzen utÃ¡na a kÃ¼lÃ¶nbÃ¶zÅ beÃ¡llÃ­tÃ¡soknak, ha nem tudja, hol talÃ¡lja Åket.",
            showNewOrderNotifications:
                "A megrendelÃ©s Ã©rtesÃ­tÃ©se egy felugrÃ³ ablak, amellyel jelzi, hogy Ãºj megrendelÃ©s Ã©rkezett.",
            sorting:
                "A gyorsszÃ­nezÃ©shez a tartÃ¡lyokat a szÃ­nezÅpasztÃ¡k nevei vagy a tartÃ¡lyazonosÃ­tÃ³k szerint lehet rendezni.",
            turnOnKioskMode: "A KIOSK mÃ³d elrejti a tÃ¡lcÃ¡t",
            windowClosingRules:
                "A beÃ¡llÃ­tÃ¡s eldÃ¶nti, hogy bezÃ¡rÃ³dik-e a gyors szÃ­nezÃ©s ablaka az adagolÃ¡si folyamat elÅtt vagy utÃ¡n."
        },
        formulaSettings: {
            additionalFormulaTab:
                "Ez a beÃ¡llÃ­tÃ¡s hatÃ¡rozza meg, hogy melyik panel jelenjen meg, amikor egy Ãºj kÃ©pletfÃ¼let megnyit.",
            allowCustomFormulas: "Az egyÃ©ni receptek lÃ©trehozÃ¡sa Ã©s keresÃ©se aktivÃ¡lÃ³dik.",
            allowCustomPackageSize: "A Recept ablakban az egyedi kiszerelÃ©s opciÃ³ aktivÃ¡lÃ³dik.",
            allowEditingColorants:
                "A Recept ablakban aktivÃ¡lÃ³dik a szÃ­nezÅpaszta szerkesztÃ©se gomb (a szÃ­n kivÃ¡lasztÃ¡sa utÃ¡n lÃ¡thatÃ³).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "A Recept ablakban a szÃ­nes elÅnÃ©zet lesz az egyetlen lÃ¡thatÃ³ informÃ¡ciÃ³.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "LehetÅvÃ© teszi a szÃ­nelÅnÃ©zeti panel Ã¡tmÃ©retezÃ©sÃ©t.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption:
                "VÃ¡lassza ki, hogy mely mÃ©rtÃ©kegysÃ©gek hasznÃ¡lhatÃ³k az egyÃ©ni csomagmÃ©rethez a Formula panelen.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Ennek a beÃ¡llÃ­tÃ¡snak a engedÃ©lyezÃ©sÃ©vel olyan elÅugrÃ³ ablakok jelennek meg, amelyek megerÅsÃ­tik a kivÃ¡lasztott elem tÃ¶rlÃ©sÃ©t.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "A %{name}, elindÃ­tÃ¡sÃ¡val megjelenik a Kedvencek ablak",
            formulaAutomaticNaming:
                "A megvÃ¡ltoztatott recept automatikusan elnevezÃ©sre kerÃ¼l a vÃ©grehajtott szÃ­nezÃ©k mÃ³dosÃ­tÃ¡sok alapjÃ¡n.",
            formulaPanel: "Ãj lap megnyitÃ¡sakor a Recept ablak jelenik meg.",
            formulaPanelInitial: "A %{name} megnyitÃ¡sakor a Recept ablak jelenik meg.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "A Recept ablakban a termÃ©k kÃ©pe lÃ¡thatÃ³ lesz a szÃ­nes elÅnÃ©zet mellett, azzal a lehetÅsÃ©ggel, hogy az ablakot tovÃ¡bbi informÃ¡ciÃ³val tudja megnyitni.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "LehetÅvÃ© teszi a tÃ¶bb informÃ¡ciÃ³  panel Ã¡tmÃ©retezÃ©sÃ©t.",
            initialFormulaTab: "A beÃ¡llÃ­tÃ¡s hatÃ¡rozza meg, hogy a %{0} indÃ­tÃ¡sa utÃ¡n melyik panel jelenik meg.",
            moreInfo:
                "A KÃ©plet ablakban az informÃ¡ciÃ³s panel lÃ¡thatÃ³ lesz a szÃ­nes elÅnÃ©zet Ã©s a termÃ©k elÅnÃ©zete mellett.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "A beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi a termÃ©kkÃ³dok hasznÃ¡latÃ¡t a termÃ©knevekkel egyÃ¼tt, ha azok rendelkezÃ©sre Ã¡llnak az adatbÃ¡zisban.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "Egy Ãºj ablak megnyitÃ¡sakor megjelenik az Ãj Recept keresÃ©se (ez informÃ¡ciÃ³kat tartalmaz az utoljÃ¡ra kiadott Ã©s a kedvenc receptekrÅl) ",
            searchNewFormulaInitial:
                "A %{name} megnyitÃ¡sakor megjelenik az Ãj Recept keresÃ©se (ez informÃ¡ciÃ³kat tartalmaz az utoljÃ¡ra kiadott Ã©s a kedvenc receptekrÅl) ",
            searchPanelFormulaItems: "A kÃ©pletelemek kÃ¶zÃ¼l legalÃ¡bb egyet ki kell vÃ¡lasztani.",
            searchPanelProductItems: "A termÃ©kelemek kÃ¶zÃ¼l csak egy vÃ¡laszthatÃ³ ki.",
            searchPanelQuickSelect:
                "Nem kell megnyomni a kÃ©plet betÃ¶ltÃ©se gombot. A kÃ©plet kivÃ¡lasztÃ¡sa utÃ¡n kÃ¶zvetlenÃ¼l a fÅ kÃ©plet lapra kerÃ¼l Ã¡tirÃ¡nyÃ­tÃ¡sra.",
            setCompetitiveColorSearch:
                "Ha ez a beÃ¡llÃ­tÃ¡s be van kapcsolva, a SzÃ­npalettÃ¡n elÃ©rhetÅ a versenykÃ©pes szÃ­nkeresÃ©s funkciÃ³ja.",
            setFormulaInfoInPreview: "A kÃ©plet panelen a kivÃ¡lasztott adattÃ­pus mindig lÃ¡thatÃ³ lesz a szÃ­nelÅnÃ©zetben.",
            setFormulaPreview:
                "A beÃ¡llÃ­tÃ¡s megvÃ¡ltoztatja a szÃ­nelÅnÃ©zet, a csomagkÃ©p Ã©s a szÃ­nre vonatkozÃ³ informÃ¡ciÃ³s adatok pozÃ­ciÃ³jÃ¡t Ã©s megjelenÃ­tÃ©sÃ©t.",
            setFormulaRGBPreviewVisibleInformation:
                "A Recept ablakban a kivÃ¡lasztott adattÃ­pus mindig lÃ¡thatÃ³ lesz a szÃ­nes elÅnÃ©zetben.",
            setFormulaUnit:
                "A Recept ablakban ez a beÃ¡llÃ­tÃ¡s dÃ¶nt egy szÃ­n kivÃ¡lasztÃ¡sa utÃ¡n, melyik szÃ­nezÅegysÃ©get nyitja meg elÅszÃ¶r. A Gyors szÃ­nezÃ©s alkalmazÃ¡sban is alkalmazhatÃ³.",
            setFormulaVisibilityAndOrder:
                "A Recept ablakban a kivÃ¡lasztott adatok a TovÃ¡bbi informÃ¡ciÃ³k szakaszban lesznek lÃ¡thatÃ³ak (csak akkor alkalmazandÃ³, ha a Receptben lÃ¡thatÃ³ az ElÅnÃ©zet vagy TovÃ¡bbi informÃ¡ciÃ³).",
            setMaxToleranceForCompetitiveColors:
                "A maximÃ¡lis Delta E (CIA 2000) tÅ±rÃ©shatÃ¡r beÃ¡llÃ­tÃ¡sa a kompetitÃ­v szÃ­nkeresÃ©shez.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "A Recept ablakban ez a beÃ¡llÃ­tÃ¡s dÃ¶nt egy szÃ­n kivÃ¡lasztÃ¡sa utÃ¡n, mely szÃ­nezÅ egysÃ©gek legyenek lÃ¡thatÃ³ak. A Gyors szÃ­nezÃ©s alkalmazÃ¡sban is hasznÃ¡lhatÃ³.",
            showColorPreview:
                "A Recept ablakban kis szÃ­n elÅnÃ©zet jelenik meg a szÃ­n neve mellett, amikor Ãºj kÃ©pletet keres.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "A szÃ­nezÅanyag-mennyisÃ©gek Ã¶sszege az alaphatÃ¡rÃ©rtÃ©k alatt van.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "A minimÃ¡lisan szÃ­nezhetÅ mennyisÃ©g a legkisebb szÃ­nezÅanyag-mennyisÃ©g, amely a laboratÃ³rium Ã¡ltal ajÃ¡nlott mÃ³don adagolhatÃ³.",
            checkOverfill:
                "A beÃ¡llÃ­tÃ¡s ellenÅrzi, hogy van-e elegendÅ hely a dobozban a szÃ­nezÅanyagok szÃ¡mÃ¡ra, kÃ¶zvetlenÃ¼l a mennyisÃ©gek beÃ¡llÃ­tÃ¡sa utÃ¡n.",
            checkTotalCntAmounts:
                "A beÃ¡llÃ­tÃ¡s ellenÅrzi, hogy a termÃ©k alapcsomagjÃ¡ban szereplÅ minimÃ¡lis Ã©s maximÃ¡lis szÃ­nezÅanyag-mennyisÃ©gek hatÃ¡rÃ©rtÃ©kei tÃºllÃ©pÃ©sre kerÃ¼ltek-e. Ezek a hatÃ¡rÃ©rtÃ©kek az adatbÃ¡zisban vannak meghatÃ¡rozva.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "A szÃ­nezÅanyag mennyisÃ©ge a minimÃ¡lisan szÃ­nezhetÅ mennyisÃ©g alatt van.",
            dispensingWithErrorsEnabled:
                "Ha engedÃ©lyezett, az Ã©rvÃ©nyesÃ­tÃ©s megsÃ©rtÃ©se esetÃ©n figyelmeztetÅ Ã¼zenet jelenik meg, de a kiadÃ¡st ennek ellenÃ©re folytatni lehet.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "A szÃ­nezÅanyag-mennyisÃ©gek Ã¶sszege meghaladja a maximÃ¡lis festhetÅ mennyisÃ©get.",
            overfill: "TÃºltÃ¶ltÃ©st Ã©szleltek.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Ismerem a kockÃ¡zatokat, folytassa"
        },
        help: "SÃºgÃ³",
        helpLink: "SegÃ­tsÃ©g KÃ¶zpont",
        helper: {
            automaticallyCheckForUpdates:
                "A rendszer automatikusan ellenÅrzi, hogy a megadott idÅintervallumban van-e frissÃ­tÃ©s a %{name} vagy az adatbÃ¡zis szÃ¡mÃ¡ra.",
            automaticallyDownloadUpdates:
                "Ha van elÃ©rhetÅ frissÃ­tÃ©s, akkor az automatikusan letÃ¶ltÅdik, anÃ©lkÃ¼l, hogy vissza kellene erÅsÃ­tenie.",
            automaticallyInstallNewDatabases:
                "Ha egy eddig hiÃ¡nyzÃ³ DB-t kÃ¼ld, akkor az Ãºj DB-kÃ©nt telepÃ¼l. Ezt kÃ¶vetÅen a DB hasznÃ¡lhatÃ³.",
            automaticallyInstallUpdates:
                "Ha egy frissÃ­tÃ©s letÃ¶ltÃ©sre kerÃ¼lt, akkor az automatikusan telepÃ­tÃ©sre kerÃ¼l, anÃ©lkÃ¼l, hogy azt vissza kellene erÅsÃ­teni.",
            canBrowseChangeLog: "A szoftver frissÃ­tÃ©sekor a hivatalos %{name} changelog lesz megtekinthetÅ.",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "A frissÃ­tÃ©s Ã©jszaka telepÃ¼l, ha a szÃ¡mÃ­tÃ³gÃ©p fut."
        },
        licensing: {
            collect:
                "A naplÃ³fÃ¡jlok letÃ¶ltÅdnek a kivÃ¡lasztott helyre. A naplÃ³fÃ¡jlokra a szÃ¡llÃ­tott szoftver hibaelemzÃ©shez van szÃ¼ksÃ©g.",
            company: "A licencet szolgÃ¡ltatÃ³ cÃ©g.",
            computerID:
                "LicencazonosÃ­tÃ¡s a szoftver szÃ¡llÃ­tÃ³jÃ¡nak segÃ­tÃ©se Ã©rdekÃ©ben, amennyiben segÃ­tsÃ©gre van szÃ¼ksÃ©g.",
            email: "A licenctulajdonos e-mail cÃ­me.",
            licenseUuid: "A licenc azonosÃ­tÃ³ja, hogy segÃ­tse a szoftver szÃ¡llÃ­tÃ³jÃ¡t a szÃ¼ksÃ©ges segÃ­tsÃ©g esetÃ©n.",
            name: "A licenctulajdonos neve.",
            openBugreport:
                "KÃ©rjÃ¼k, Ã©rtesÃ­tsen minket, ha a szoftverben hiba van, Ã©s kÃ¼ldjÃ¶n jelentÃ©st a hiba leÃ­rÃ¡sÃ¡val.",
            posInfoContactperson: "A cÃ­mkÃ©re nyomtatandÃ³ POS-informÃ¡ciÃ³ a tulajdonosrÃ³l.",
            posInfoMachineInformation:
                "A cÃ­mkÃ©re nyomtatandÃ³ vagy a hÃ¡lÃ³zatban felismerhetÅ POS-informÃ¡ciÃ³ az adagolÃ³rÃ³l.",
            posInfoPos: "A cÃ­mkÃ©re nyomtatandÃ³ POS-informÃ¡ciÃ³ a helyszÃ­nrÅl.",
            reactivation: "A jelenlegi licenc ÃºjraaktivÃ¡lÃ¡sa vagy mÃ³dosÃ­tÃ¡sa.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "RegisztrÃ¡ciÃ³s adatok az engedÃ©ly tulajdonosÃ¡nak azonosÃ­tÃ¡sÃ¡ra.",
            registrationMachineInformation: "Az engedÃ©ly kiadÃ³jÃ¡nak azonosÃ­tÃ¡sÃ¡ra szolgÃ¡lÃ³ nyilvÃ¡ntartÃ¡si adatok.",
            registrationPos: "RegisztrÃ¡ciÃ³s informÃ¡ciÃ³ az engedÃ©ly helyÃ©nek azonosÃ­tÃ¡sÃ¡ra.",
            versionScope: "A szoftver lejÃ¡rati hatÃ¡rideje.",
            versionType: "A szoftver termÃ©ktÃ­pusa."
        },
        machineIsBusy: "A hibÃ¡kat nem lehet visszaÃ¡llÃ­tani, mivel a gÃ©p foglalt.",
        machineSettings: {
            allowManualColorantAddition:
                "Ha a kÃ­vÃ¡nt szÃ­nezÅpaszta mennyisÃ©g meghaladja a maximÃ¡lis adagolÃ¡si mennyisÃ©get, a beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi, hogy az adagolÃ¡s utÃ¡n manuÃ¡lisan hozzÃ¡adja azt.",
            autotasks:
                "Az automatikus feladatok azok az automatikus gÃ©p- Ã©s szÃ¡mÃ­tÃ³gÃ©pes karbantartÃ¡si esemÃ©nyek, amelyek beÃ¡llÃ­thatÃ³k bizonyos idÅpontokban vagy idÅkÃ¶zÃ¶nkÃ©nt.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "A vonalkÃ³d ahhoz a tartÃ¡lyhoz van rendelve, amelyben a szÃ­nezÅanyag rendelkezÃ©sre Ã¡ll. A vonalkÃ³d a szÃ­nezÅanyag helyes utÃ¡ntÃ¶ltÃ©sÃ©nek biztosÃ­tÃ¡sÃ¡hoz szÃ¼ksÃ©ges.",
            checkCanBeforeDispense: "A beÃ¡llÃ­tÃ¡s csak a Fast & Fluid szimulÃ¡ciÃ³ra Ã©rvÃ©nyes.",
            checkOverfill:
                "A beÃ¡llÃ­tÃ¡s ellenÅrzi, hogy van-e elÃ©g hely a kaniszterben a szÃ­nezÅpaszta szÃ¡mÃ¡ra az adagolÃ¡s elÅtt.",
            currentlySelectedMachine: "Az aktuÃ¡lisan kivÃ¡lasztott gÃ©prÅl nyÃºjt informÃ¡ciÃ³t.",
            dispenseInvalidColorants:
                "A beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi a gÃ©p konfigurÃ¡ciÃ³jÃ¡ban nem definiÃ¡lt szÃ­nezÅanyagok adagolÃ¡sÃ¡t a szÃ­nezÅanyag kÃ©zi hozzÃ¡adÃ¡sÃ¡ra valÃ³ felszÃ³lÃ­tÃ¡ssal.",
            dispenserConfigurationBackup:
                "LetÃ¶lti Ã©s elmenti az aktuÃ¡lis gÃ©pkonfigurÃ¡ciÃ³t a biztonsÃ¡gi mentÃ©s fenntartÃ¡sa Ã©rdekÃ©ben.",
            dispensingLogic:
                "Az adagolÃ¡si logikai tÃ­pusok biztosÃ­thatjÃ¡k az egyes tartÃ¡lyok eltÃ©rÅ viselkedÃ©sÃ©t, ha a megengedettnÃ©l vagy a kÃ­vÃ¡ntnÃ¡l tÃ¶bb szÃ­nezÅanyagot kell adagolni. A tovÃ¡bbi viselkedÃ©s beÃ¡llÃ­tÃ¡sa az adagolÃ¡si beÃ¡llÃ­tÃ¡sokban tÃ¶rtÃ©nik.",
            enableTmc: "A beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi az adatok kÃ¼ldÃ©sÃ©t a TMC-nek",
            enableUserIdentification: "A felhasznÃ¡lÃ³nak be kell jelentkeznie, mielÅtt az adagolÃ¡s engedÃ©lyezett lenne.",
            machineUnit: "A gÃ©pi egysÃ©g hatÃ¡rozza meg a kaniszterekben lÃ©vÅ szÃ­nezÅpaszta mÃ©rtÃ©kegysÃ©gÃ©t.",
            minDispensedAmount:
                "A minimÃ¡lisan adagolt mennyisÃ©g, ami meghatÃ¡rozza, hogy mennyi szÃ­nezÅpasztÃ¡t kell adagolni a tisztÃ­tÃ¡s hatÃ©konysÃ¡ga Ã©rdekÃ©ben (annak Ã©rdekÃ©ben hogy a tisztÃ­tÃ¡s hatÃ©kony legyen).",
            minimalDispenseAmount:
                "A minimÃ¡lis adagolÃ¡si mennyisÃ©g az a legkisebb javasolt szÃ­nezÅanyag-mennyisÃ©g, amelyet ki lehet adni. Ez alatti mennyisÃ©g esetÃ©n egy Ã¼zenet jelenik meg (az adagolÃ¡s tovÃ¡bbra is lehetsÃ©ges).",
            missingAutotaskCanisters: "LegalÃ¡bb 1 tartÃ¡lyt kell kivÃ¡lasztani",
            missingAutotaskChannels: "LegalÃ¡bb 1 csatornÃ¡t kell kivÃ¡lasztani",
            missingAutotaskChannelsValue: "Az Ã¶sszes kivÃ¡lasztott csatorna hangerejÃ©t ki kell tÃ¶lteni",
            missingAutotaskCleanTime: "A tisztÃ­tÃ¡s idejÃ©t kell kitÃ¶lteni",
            missingAutotaskName: "Az automatikus feladat nevÃ©t kell kitÃ¶lteni",
            missingAutotaskRecirculation: "A recirkulÃ¡ciÃ³ idejÃ©t Ã©s sebessÃ©gÃ©t kell kitÃ¶lteni.",
            missingAutotaskStirring: "A keverÃ©s idejÃ©t Ã©s sebessÃ©gÃ©t ki kell tÃ¶lteni.",
            missingAutotaskVolume: "A tisztÃ­tÃ¡s tÃ©rfogatÃ¡t kell kitÃ¶lteni",
            placeCanSensor:
                "A beÃ¡llÃ­tÃ¡s aktivÃ¡lja a vÃ¶dÃ¶r elhelyezÃ©sÃ©re szolgÃ¡lÃ³ Ã©rzÃ©kelÅt - az adagolÃ¡s csak akkor indul el, ha a vÃ¶drÃ¶t megfelelÅen helyeztÃ©k el.",
            placeCanSensorDelay:
                "AjÃ¡nlott beÃ¡llÃ­tÃ¡s Ã¶sszekapcsolva a vÃ¶dÃ¶rÃ©rzÃ©kelÅvel. BiztosÃ­tja, hogy az adagolÃ¡s csak azutÃ¡n kezdÅdjÃ¶n el, miutÃ¡n a vÃ¶drÃ¶t megfelelÅen elhelyeztÃ©k.",
            purgeVolume:
                "A tisztÃ­tÃ¡si mennyisÃ©g meghatÃ¡rozza, hogy mennyi szÃ­nezÅpasztÃ¡t hasznÃ¡ljon az intelligens tisztÃ­tÃ¡skor.",
            rccUrl: "A Redlike Control Center (RCC) felelÅs az automatÃ¡val valÃ³ kommunikÃ¡ciÃ³Ã©rt.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "A beÃ¡llÃ­tÃ¡s aktivÃ¡lja az Ã©rzÃ©kelÅt a vÃ¶dÃ¶r eltÃ¡volÃ­tÃ¡sÃ¡hoz - az adagolÃ¡st csak akkor tekintik befejezettnek, ha a vÃ¶drÃ¶t elvettÃ©k.",
            removeCanSensorDelay:
                "A javasolt beÃ¡llÃ­tÃ¡s a vÃ¶dÃ¶r Ã©rzÃ©kelÅjÃ©hez kapcsolÃ³dik. Ez biztosÃ­tja, hogy az adagolÃ¡s csak akkor fejezÅdjÃ¶n be ha a vÃ¶drÃ¶t eltÃ¡volÃ­tottÃ¡k.",
            skipPlaceCanDialog:
                "Ha ezt a beÃ¡llÃ­tÃ¡st bekapcsolja, az adagolÃ³ az OK gomb megnyomÃ¡sÃ¡ig nem vÃ¡rja meg a vÃ¶dÃ¶r elhelyezÃ©sÃ©t, hanem automatikusan elindÃ­tja a szÃ­nezÃ©si folyamatot.",
            skipRemoveCanDialog:
                "Ha ez a beÃ¡llÃ­tÃ¡s be van kapcsolva, az adagolÃ³ nem vÃ¡rja meg a vÃ¶dÃ¶r eltÃ¡volÃ­tÃ¡sÃ¡t, amÃ­g az OK gombot meg nem nyomja, hanem az automatikus adagolÃ¡si folyamatot veszi figyelembe.",
            smartPurgeType:
                "Ezzel mÃ©rlegelheti hogy kizÃ¡rÃ³lag adagolÃ¡st vagy az adagolÃ¡ssal mÃ¡s tisztÃ­tÃ¡si esemÃ©nyt indÃ­tson ha kÃ©ri az intelligens tisztÃ­tÃ¡st.",
            splitFormula:
                "Ha a szÃ¼ksÃ©ges szÃ­nezÅpaszta mennyisÃ©ge meghaladja a maximÃ¡lis adagolÃ¡si mennyisÃ©get, akkor a beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi egy rÃ©sz szÃ­nezÅpaszta adagolÃ¡sÃ¡t, a kaniszter ÃºjratÃ¶ltÃ©sÃ©t, majd a maradÃ©k adagolÃ¡s folytatÃ¡sÃ¡t.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Az adagolÃ¡s engedÃ©lyezÃ©se elÅtt az IBase-t vonalkÃ³ddal kell Ã©rvÃ©nyesÃ­teni. A beÃ¡llÃ­tÃ¡s biztosÃ­tja a helyes BÃ¡zis hasznÃ¡latÃ¡t.",
            validateColorantsDuringInit:
                "A gÃ©p konfigurÃ¡ciÃ³ja minden alkalommal Ã¶sszehasonlÃ­tÃ¡sra kerÃ¼l az adatbÃ¡zissal, amikor az RCC Ãºjraindul. EltÃ©rÃ©s esetÃ©n Ã©rtesÃ­tÃ©s Ã©rkezik."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "MegnyÃ­lik egy ablak a vonalkÃ³d kÃ©zi bevitelÃ©nek lehetÅsÃ©gÃ©vel.",
            canisterBarcodes:
                "Megnyit egy ablakot a tartÃ¡ly vonalkÃ³djÃ¡nak Ã¡ttekintÃ©sÃ©vel Ã©s a tartÃ¡ly vonalkÃ³djÃ¡nak beÃ¡llÃ­tÃ¡sÃ¡nak lehetÅsÃ©gÃ©vel.",
            canisterLevel:
                "Megnyit egy ablakot a tartÃ¡lyszintek Ã¡ttekintÃ©sÃ©vel Ã©s a tartÃ¡lyszint beÃ¡llÃ­tÃ¡sÃ¡nak lehetÅsÃ©gÃ©vel.",
            canisters:
                "Megnyit egy panelt a tartÃ¡lyszintek Ã¡ttekintÃ©sÃ©vel Ã©s a tartÃ¡lyszint beÃ¡llÃ­tÃ¡sÃ¡nak lehetÅsÃ©gÃ©vel.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Megnyit egy panelt, ahol lehetÅsÃ©g van Ãºj receptÃºra keresÃ©sÃ©re egy elektronikus csomagban.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Megnyit egy ablakot az elvÃ©gzett tartÃ¡lyfeltÃ¶ltÃ©sek Ã¡ttekintÃ©sÃ©vel.",
            customFormula: "Megnyit egy panelt, ahol Ãºj egyÃ©ni kÃ©pletet hozhat lÃ©tre.",
            customers:
                "Megnyit egy panelt a vevÅk Ã¡ttekintÃ©sÃ©vel Ã©s a vevÅk hozzÃ¡adÃ¡sÃ¡nak/szerkesztÃ©sÃ©nek/tÃ¶rlÃ©sÃ©nek lehetÅsÃ©gÃ©vel.",
            dispensingHistory: "Megnyit egy panelt az elvÃ©gzett adagolÃ¡sok Ã¡ttekintÃ©sÃ©vel.",
            favorites: "Megnyit egy panelt a kedvenc formula kivÃ¡lasztÃ¡sÃ¡nak lehetÅsÃ©gÃ©vel.",
            help: "Megnyit egy ablakot az Ã¼gyfÃ©lszolgÃ¡lati informÃ¡ciÃ³kkal, ha a szÃ¡llÃ­tÃ³ megadta azokat.",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders:
                "KizÃ¡rÃ³lag %{name} esetÃ©ben Ã©rvÃ©nyes, megnyit egy panelt a kiadott rendelÃ©sek Ã¡ttekintÃ©sÃ©vel.",
            machineReset: "ElindÃ­tja az adagolÃ³ visszaÃ¡llÃ­tÃ¡sÃ¡t.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "ErrÅl a szÃ¡mÃ­tÃ³gÃ©prÅl kÃ¼ldÃ¶tt megrendelÃ©sek",
            purge: "Megnyit egy ablakot, amelyben beÃ¡llÃ­thatÃ³ a tartÃ¡ly tisztÃ­tÃ¡sa.",
            quickTint: "Megnyit egy ablakot a kÃ©zi adagolÃ¡s elvÃ©gzÃ©sÃ©nek lehetÅsÃ©gÃ©vel.",
            searchFormula: "Megnyit egy panelt, ahol lehetÅsÃ©g van Ãºj receptÃºra keresÃ©sÃ©re.",
            spectro: "Megnyit egy panelt a spektromÃ©teres mÃ©rÃ©s lehetÅsÃ©gÃ©vel.",
            stir: "Megnyit egy ablakot a tartÃ¡lykeverÃ©s beÃ¡llÃ­tÃ¡sÃ¡nak lehetÅsÃ©gÃ©vel.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Erre a szÃ¡mÃ­tÃ³gÃ©pre kapott megrendelÃ©sek"
        },
        noHelpForLicense: "A licenchez nincs segÃ­tsÃ©g, kÃ©rje beszÃ¡llÃ­tÃ³jÃ¡t, hogy adja hozzÃ¡.",
        posInfo: {
            sync: "SzinkronizÃ¡lja az adatokat a szekciÃ³val RegisztrÃ¡ciÃ³"
        },
        poweredByDeso: "SzolgÃ¡ltatÃ³: %{name}",
        priceSettings: {
            VatPrice: "A szÃ­nezÅpaszta Ãfa tartalma: %",
            VatPriceProduct: "Az Ã¡ltalÃ¡nos termÃ©k ÃFA minden szÃ­nezÅanyag esetÃ©ben ugyanaz lesz. %-ban van megadva.",
            basePurchase: "BÃ¡zis vÃ©telÃ¡ra (kizÃ¡rÃ³lag a BÃ¡zishoz).",
            basePurchasePriceProduct: "Az adott alapcsomag vÃ©telÃ¡ra. A kivÃ¡lasztott pÃ©nznemben.",
            baseSell: "Csak a BÃ¡zis eladÃ¡si Ã¡ra (beleÃ©rtve a BÃ¡zist Ã©s az Ã¡rrÃ©st / felÃ¡rat).",
            baseSellFull: "Teljes Ã¡ron eladni az alapot.",
            cntName: "MeghatÃ¡rozza, hogy az Ã¡r melyik szÃ­nezÅanyagra vonatkozik.",
            cntPurchase: "SzÃ­nezpaszta beszerzÃ©si Ã¡ra (kizÃ¡rÃ³lag szÃ­nezÅpasztÃ¡kkal egyÃ¼tt).",
            cntPurchaseByName: "A szÃ­nezÅpaszta vÃ©telÃ¡ra kÃ¼lÃ¶n-kÃ¼lÃ¶n szÃ¡mÃ­tva (kizÃ¡rÃ³lag szÃ­nezÅpasztÃ¡kkal egyÃ¼tt).",
            cntPurchasePricePerLiter: "A szÃ­nezÅpaszta liter kÃ¶ltsÃ©ge (Ã¡rrÃ©s vagy felÃ¡r nÃ©lkÃ¼l).",
            cntSell: "Az eladÃ¡si Ã¡r csak szÃ­nezÅpasztÃ¡ra (szÃ­nezÅpasztÃ¡t Ã©s Ã¡rrÃ©st / felÃ¡rat is beleÃ©rtve).",
            cntSellByName:
                "A termÃ©kben hasznÃ¡lt Ã¶sszes szÃ­nezÅpaszta eladÃ¡si Ã¡ra mindenre kÃ¼lÃ¶n-kÃ¼lÃ¶n kiszÃ¡mÃ­tva (beleÃ©rtve a szÃ­nezÅpasztÃ¡t Ã©s az Ã¡rrÃ©st / felÃ¡rat).",
            cntSellFull: "Teljes Ã¡ron eladni a szÃ­nezÅanyagokat.",
            cntSellFullByName: "Teljes Ã¡ron eladni a szÃ­nezÃ©keket nÃ©v szerint.",
            cntSellPricePerLiter:
                "A szÃ­nezÅanyag literenkÃ©nti eladÃ¡si Ã¡ra (kizÃ¡rÃ³lag szÃ­nezÅanyaggal egyÃ¼tt). A kivÃ¡lasztott pÃ©nznemben beÃ¡llÃ­tva.",
            cntVat: "A szÃ­nezÅanyag Ãfa Ã©rtÃ©ke %-ban van beÃ¡llÃ­tva.",
            colorants:
                "Az Ã¡ltalÃ¡nos szÃ­nezÅpasztÃ¡k Ã¡ra minden szÃ­nben azonos lesz. Ez a funkciÃ³ kÃ¼lÃ¶nÃ¶sen az Ãfa beÃ¡llÃ­tÃ¡sÃ¡hoz hasznos.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "Az Ã¡ltalÃ¡nos szÃ­nezÅanyagÃ¡rak minden szÃ­nezÅanyag esetÃ©ben azonosak lesznek. Az eladÃ¡si Ã¡rat ajÃ¡nlott a kedvezmÃ©nnyel mÃ³dosÃ­tani. A kivÃ¡lasztott pÃ©nznemben Ã¡llÃ­tsa be.",
            currencyCodeNew: "A pÃ©nznem kÃ³djÃ¡nak hivatalos formÃ¡ban kell lennie, pÃ©ldÃ¡ul EUR.",
            currencyNameNew: "A pÃ©nznem neve, pÃ©ldÃ¡ul Euro.",
            currencyRateNew:
                "A fÅ valuta felÃ© mutatÃ³ Ã¡rfolyam, pÃ©ldÃ¡ul 25,855 CZK 1 â¬ -Ã©rt. A Ã¡rfolyamot folyamatosan kell szerkeszteni, hogy naprakÃ©sz legyen.",
            currencyRoundingNew:
                "A kerekÃ­tÃ©s meghatÃ¡rozza a valuta lehetÅ legkisebb fizetendÅ Ã©rtÃ©kÃ©t, pÃ©ldÃ¡ul az eurÃ³ 0,01-os kerekÃ­tÃ©ssel rendelkezik, mivel a lehetÅ legkisebb Ã©rtÃ©k 1 cent.",
            currencySymbolNew: "A valuta hivatalos szimbÃ³luma, pÃ©ldÃ¡ul â¬ az eurÃ³ra.",
            defaultPrice: "A szÃ­nezÅpaszta Ã¡ra a kivÃ¡lasztott adatbÃ¡zisban van beÃ¡llÃ­tva (Ãfa nÃ©lkÃ¼l).",
            defaultPriceGroup: "A kivÃ¡lasztott adatbÃ¡zisban beÃ¡llÃ­tott Ã¡rcsoport szÃ­nezÅpaszta Ã¡ra (ÃFA nÃ©lkÃ¼l).",
            defaultVatPrice: "A szÃ­nezÅpaszta ÃfÃ¡jÃ¡nak beÃ¡llÃ­tÃ¡sa a kivÃ¡lasztott adatbÃ¡zisban",
            discountHeader:
                "A kedvezmÃ©ny a meghatÃ¡rozott Ã©rtÃ©ket levonja a szÃ­nezÅanyag beszerzÃ©si Ã¡rÃ¡bÃ³l. BeÃ¡llÃ­tÃ¡s %-ban.",
            discountHeaderProduct:
                "A kedvezmÃ©ny a meghatÃ¡rozott Ã©rtÃ©ket levonja a termÃ©k szÃ­nezÅanyag Ã¡rÃ¡bÃ³l. BeÃ¡llÃ­tÃ¡s %-ban.",
            export: "ExportÃ¡ljon egy fÃ¡jlt az aktuÃ¡lisan beillesztett Ã¡rakkal. Az Ã¡rak mÃ³dosÃ­tÃ¡sa utÃ¡n Ãºjra importÃ¡lhatÃ³.",
            import: "Helyesen formÃ¡zott (exportÃ¡lt) fÃ¡jl importÃ¡lÃ¡sa az Ã¡rak beillesztÃ©sÃ©hez vagy mÃ³dosÃ­tÃ¡sÃ¡hoz.",
            localPrices:
                "A helyi Ã¡rak megvÃ¡ltoztatjÃ¡k a fÅ adatbÃ¡zis javasolt Ã¡rait, Ã©s kizÃ¡rÃ³lag helyileg vannak jelen az adott szÃ¡mÃ­tÃ³gÃ©pen.",
            margin: "VÃ¡lassza ki, hogy melyik Ã¡rkalkulÃ¡ciÃ³t kell hasznÃ¡lni a vÃ©gsÅ elÃ©rhetÅ Ã¡r meghatÃ¡rozÃ¡sÃ¡hoz. Az Ã¡rrÃ©s Ã©s a felÃ¡r Ã¶sszeadÃ³dik, mÃ­g a kedvezmÃ©ny levonÃ³dik az adott eladÃ¡si Ã¡rbÃ³l.",
            marginAll: "TÃ¶bb vÃ¶dÃ¶r Ãra (Ã¡rrÃ©s / felÃ¡rral egyÃ¼tt).",
            marginHeader:
                "Az Ã¡rrÃ©s a meghatÃ¡rozott Ã©rtÃ©ket hozzÃ¡adja a szÃ­nezÅanyag beszerzÃ©si Ã¡rÃ¡hoz. BeÃ¡llÃ­tÃ¡s %-ban.",
            marginHeaderProduct:
                "A Margin a meghatÃ¡rozott Ã©rtÃ©ket hozzÃ¡adja a termÃ©k beszerzÃ©si Ã¡rÃ¡hoz. BeÃ¡llÃ­tÃ¡s %-ban.",
            marginPerPkg: "Egy vÃ¶dÃ¶r Ãra (Ã¡rrÃ©s / felÃ¡rral egyÃ¼tt).",
            markupHeader:
                "A felÃ¡r hozzÃ¡adja a meghatÃ¡rozott Ã©rtÃ©ket a szÃ­nezÅanyag beszerzÃ©si Ã¡rÃ¡hoz. BeÃ¡llÃ­tÃ¡s %-ban.",
            markupHeaderProduct:
                "A Markup a meghatÃ¡rozott Ã©rtÃ©ket hozzÃ¡adja a termÃ©k beszerzÃ©si Ã¡rÃ¡hoz. BeÃ¡llÃ­tÃ¡s %-ban.",
            packagePricing: "KiegÃ©szÃ­tÅ pÃ³tdÃ­j az egyes kiszerelÃ©sekhez kÃ¼lÃ¶n-kÃ¼lÃ¶n.",
            packageSurcharge: "Az Ã¡ltalÃ¡nos kiszerelÃ©s Ã¡rak megegyeznek minden kiszerelÃ©s esetÃ©n.",
            priceDefinition:
                "A beÃ¡llÃ­tÃ¡s meghatÃ¡rozza, hogy a vÃ©gleges Ã¡rak kiszÃ¡mÃ­tÃ¡sakor mely Ã¡rtÃ­pusokat hasznÃ¡lja a rendszer.",
            priceGroupNumber:
                "A beÃ¡llÃ­tÃ¡s meghatÃ¡rozza, hogy hÃ¡ny Ã¡rcsoportot hasznÃ¡lnak. Az egyes Ã¡rcsoportok tartomÃ¡nya az AlapÃ©rtelmezett Ã©rtÃ©kek pontban Ã¡llÃ­thatÃ³ be.",
            priceGroupPricePerLiter: "Az Ã¡r kiszÃ¡mÃ­tÃ¡sÃ¡hoz hasznÃ¡lt szÃ­nezÅpaszta Ã¡ra.",
            priceGroups:
                "Az Ã¡rcsoportok megjelenÃ­ti a vonatkozÃ³ Ã¡rcsoport szÃ¡mÃ¡t (a hatÃ¡rokat a beÃ¡llÃ­tott adatbÃ¡zis vagy az Ã¡ltalÃ¡nos Ã¡rkÃ©pzÃ©s hatÃ¡rozza meg).",
            priceGroupsEnabled:
                "A beÃ¡llÃ­tÃ¡s lehetÅvÃ© teszi, hogy Ã¡rcsoportokkal dolgozzon. Az AlapÃ©rtelmezett Ã©rtÃ©kek menÃ¼pontban hatÃ¡rozza meg a tartomÃ¡nyt, a SzÃ­nezÅanyag-Ã¡rkÃ©pzÃ©s menÃ¼pontban pedig az egyes Ã¡rakat.",
            priceGroupsGeneric:
                "Az Ã¡rcsoportok a kÃ©sz termÃ©k Ã¡razÃ¡si Ã¶sszesÃ­tÃ©se, a receptben szereplÅ szÃ­nezÅpaszta Ã¡rak alapjÃ¡n.",
            productBasePackageSellPrice: "Az adott alap csomag eladÃ¡si Ã¡ra. A kivÃ¡lasztott pÃ©nznemben.",
            productBaseSellPrice:
                "A bÃ¡zis literenkÃ©nt szÃ¡mÃ­tott eladÃ¡si Ã¡ra (beleÃ©rtve a bÃ¡zist is, kizÃ¡rÃ³lag). A kivÃ¡lasztott pÃ©nznemben beÃ¡llÃ­tva.",
            productBaseVat: "TermÃ©k alap ÃFA Ã©rtÃ©ke az adott csomaghoz %-ban megadva.",
            productName: "MeghatÃ¡rozza, hogy az Ã¡r melyik termÃ©kalapra vonatkozik.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "Az Ã¶sszes vÃ¶dÃ¶r eladÃ¡si Ã¡ra az egyenkÃ©nti szÃ­nezÃ©sek utÃ¡n kerÃ¼l heghatÃ¡rozÃ¡sra.",
            productSize: "MeghatÃ¡rozza, hogy az adott termÃ©kalap melyik csomagjÃ¡ra vonatkozik az Ã¡r.",
            productVat: "A termÃ©kalap Ã¡fa-Ã©rtÃ©ke %-ban van megadva.",
            products:
                "Az Ã¡ltalÃ¡nos termÃ©kÃ¡rak minden szÃ­nezÅanyag esetÃ©ben azonosak. A beszerzÃ©si Ã¡rat ajÃ¡nlott Ã¡rrÃ©ssel vagy felÃ¡rral mÃ³dosÃ­tani. BeÃ¡llÃ­tÃ¡sa a kivÃ¡lasztott pÃ©nznemben.",
            productsSellPrice:
                "Az Ã¡ltalÃ¡nos termÃ©kÃ¡rak minden szÃ­nezÃ©k esetÃ©ben azonosak lesznek. Az eladÃ¡si Ã¡rat ajÃ¡nlott engedmÃ©nnyel mÃ³dosÃ­tani. A kivÃ¡lasztott pÃ©nznemben kell beÃ¡llÃ­tani.",
            sellPriceAll:
                "TÃ¶bb csomag eladÃ¡si Ã¡ra (beleÃ©rtve az alapot, a szÃ­nezÃ©keket, a pÃ³tdÃ­jkÃ¼lÃ¶nbÃ¶zetet/felÃ¡rat/engedmÃ©nyt).",
            sellPricePerKg:
                "A termÃ©k kilogrammonkÃ©nti eladÃ¡si Ã¡ra (beleÃ©rtve az alapot, szÃ­nezÃ©keket, felÃ¡rkÃ¼lÃ¶nbÃ¶zetet/felÃ¡rat/engedmÃ©nyt).",
            sellPricePerL:
                "A termÃ©k literenkÃ©nti eladÃ¡si Ã¡ra (beleÃ©rtve az alapanyagot, szÃ­nezÃ©ket, felÃ¡r/felÃ¡r/levonÃ¡s).",
            sellPricePerPkg: "Egy csomag eladÃ¡si Ã¡ra (alapanyaggal, szÃ­nezÅanyagokkal, felÃ¡r/felÃ¡r/levonÃ¡ssal egyÃ¼tt).",
            setPriceTypesVisibilityAndOrder:
                "A recept ablakban a kivÃ¡lasztott Ã¡rak lÃ¡thatÃ³ak lesznek az Ã¡rak rÃ©szben. A legmagasabb pozÃ­ciÃ³jÃº itt a bal szÃ©lsÅvel kezdÅdik.",
            surchargeAll: "Az Ã¶sszes vÃ¶dÃ¶r tÃ¶bblet dÃ­ja (felÃ¡rat is beleÃ©rtve).",
            surchargePerPkg: "Egy vÃ¶dÃ¶r tÃ¶bblet dÃ­ja (felÃ¡rat is beleÃ©rtve).",
            tintPurchaseAll:
                "Az Ã¶sszes termÃ©k teljes szÃ­nezÃ©sÃ©nek beszerzÃ©si Ã¡ra (beleÃ©rtve a szÃ­nezÅpasztÃ¡kat Ã©s a felÃ¡rat is).",
            tintPurchasePerPkg:
                "Egy vÃ¶dÃ¶r teljes szÃ­nezÃ©sÃ©nek beszerzÃ©si Ã¡ra (beleÃ©rtve a szÃ­nezÅpasztÃ¡kat Ã©s a felÃ¡rat is).",
            tintSellFullAll: "A szÃ­nÃ¡rnyalat minden csomag esetÃ©ben teljes Ã¡ron eladÃ³.",
            tintlSellFullAllPerPackage: "SzÃ­nezÃ©s teljes Ã¡ron eladni csomagonkÃ©nt.",
            totalPurchaseAll: "Az Ã¶sszes termÃ©k teljes beszerzÃ©si Ã¡ra (beleÃ©rtve az bÃ¡zist Ã©s szÃ­nezÅpasztÃ¡kat is).",
            totalPurchasePerKg:
                "Az Ã¶sszes termÃ©k kilogrammonkÃ©nti teljes beszerzÃ©si Ã¡ra (beleÃ©rtve az bÃ¡zist Ã©s szÃ­nezÅpasztÃ¡kat is).",
            totalPurchasePerL:
                "Az Ã¶sszes termÃ©k literenkÃ©nti teljes beszerzÃ©si Ã¡ra (beleÃ©rtve az bÃ¡zist Ã©s szÃ­nezÅpasztÃ¡kat is).",
            totalPurchasePerPkg: "Egy vÃ¶dÃ¶r teljes beszerzÃ©si Ã¡ra (beleÃ©rtve az bÃ¡zist Ã©s szÃ­nezÅpasztÃ¡kat is).",
            totalSellFullAll: "Ãsszesen eladni teljes Ã¡ron az Ã¶sszes csomagot.",
            totalSellFullPerKg: "Teljes eladÃ¡si Ã¡r kilogrammonkÃ©nt.",
            totalSellFullPerLiter: "Teljes eladÃ¡si Ã¡r literenkÃ©nt.",
            totalSellFullPerPackage: "Teljes eladÃ¡si Ã¡r csomagonkÃ©nt Ã¶sszesen",
            withAndWithoutVat:
                "A Formula panelen az Ã¡r mindkÃ©t vÃ¡ltozatban, Ã¡fÃ¡val Ã©s Ã¡fa nÃ©lkÃ¼l, egyszerre lesz lÃ¡thatÃ³.",
            withVat: "A Formula panelen minden Ã¡r csak az ÃFA-val egyÃ¼tt lesz lÃ¡thatÃ³.",
            withoutVat: "A Formula panelen az Ã¶sszes Ã¡r csak ÃFA nÃ©lkÃ¼l lesz lÃ¡thatÃ³."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "SzinkronizÃ¡lja az adatokat a POS Info szekciÃ³val"
        },
        searchingPleaseWait: "KÃ©rjÃ¼k, vÃ¡rjon, a legjobb egyezÃ©s keresÃ©se folyamatban van.",
        setupSteps: {
            customData: "EgyÃ©ni adatok",
            machineType: "GÃ©p tÃ­pusa",
            userPreferences: "FelhasznÃ¡lÃ³i beÃ¡llÃ­tÃ¡sok"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "ProfilÃ¡lt Ã©rtÃ©kek hasznÃ¡lata esetÃ©n a mÃ©rt eredmÃ©nyek ÃºjraszÃ¡mÃ­tÃ¡sra kerÃ¼lnek a szÅ±rÅhatÃ¡s eltÃ¡volÃ­tÃ¡sa Ã©rdekÃ©ben. EngedÃ©lyezze ezt az opciÃ³t az univerzÃ¡lis spektromÃ©rÃ©shez.",
            XRiteModelRM400: "Nincs szÃ¼ksÃ©g illesztÅprogramokra.",
            datacolorDiagnosticTile: "Datacolor diagnosztikai csempe hasznÃ¡lata",
            datacolorSilent: "Datacolor csendes",
            measureModes: "VÃ¡lassza ki a tÃ¡mogatott fÃ©nyessÃ©gi szinteket.",
            model: "Modell",
            simulationPath: "A szimulÃ¡ciÃ³s fÃ¡jl elÃ©rÃ©si Ãºtvonala. AlapÃ©rtelmezett beÃ¡llÃ­tÃ¡s.",
            spectroType: "A hivatalos spectro illesztÅprogramot telepÃ­teni kell. Csak Windows.",
            spectroTypeCom:
                "Hivatalos spectro illesztÅprogramot kell telepÃ­teni. VigyÃ¡zzon a hasznÃ¡lt COM portra. Windows Ã©s Linux egyarÃ¡nt.",
            spectroTypeDataColorReader:
                "A szÃ¡mÃ­tÃ³gÃ©pnek Bluetooth-kapcsolattal kell rendelkeznie. A spectro-t pÃ¡rosÃ­tani kell a szÃ¡mÃ­tÃ³gÃ©ppel. Windows 10, 2018-as automatikus frissÃ­tÃ©ssel.",
            spectroTypeMinolta2XXXd:
                "Hivatalos spectro illesztÅprogramot kell telepÃ­teni. VigyÃ¡zzon a hasznÃ¡lt COM portra. Windows Ã©s Linux egyarÃ¡nt.",
            spectroTypeNotSelected: "VÃ¡lassza ki a spectro modelljÃ©t.",
            spectroTypeRM400: "Nincs szÃ¼ksÃ©g illesztÅprogramokra.",
            spectroTypeSimulation:
                "A szimulÃ¡ciÃ³s eredmÃ©nyek elÃ©rÃ©sÃ©hez laboratÃ³riumi Ã©rtÃ©kek szÃ¼ksÃ©gesek. Windows Ã©s Linux egyarÃ¡nt.",
            spectroTypeXRite: "Csak Windows."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "Az alapdoboz UFI-kÃ³djÃ¡t vonalkÃ³ddal kell Ã©rvÃ©nyesÃ­teni, mielÅtt a kiadÃ¡st engedÃ©lyeznÃ©k.",
            enableUfiCodes:
                "Az UFI-kÃ³dokat az EU-ban hasznÃ¡ljÃ¡k, Ã©s informÃ¡ciÃ³t nyÃºjtanak arrÃ³l, hogy egy termÃ©k mennyire veszÃ©lyes a kÃ¶rnyezetre.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Ha egy szÃ­nezÅanyag a receptÃºrÃ¡ban meghaladja a megadott hatÃ¡rÃ©rtÃ©ket, az UFI-kÃ³dja felkerÃ¼l a nyomtatott cÃ­mkÃ©re.",
            printUfiCodePercentage:
                "Ha egy szÃ­nezÅanyag a receptÃºrÃ¡ban tÃºllÃ©pi a megadott hatÃ¡rÃ©rtÃ©ket, az UFI-kÃ³dot a szÃ¡zalÃ©kos arÃ¡nyÃ¡val egyÃ¼tt a nyomtatott cÃ­mkÃ©re nyomtatjÃ¡k.",
            ufiCodesByPercentage:
                "A nyomtatÃ¡shoz a tartÃ¡lyban lÃ©vÅ tÃ©nyleges mennyisÃ©g figyelembevÃ©telÃ©vel az Ã©rvÃ©nyes UFI-kÃ³dot kell hasznÃ¡lni. NavigÃ¡ljon a KaniszterbeÃ¡llÃ­tÃ¡sok menÃ¼pontra az egyes kaniszterek hatÃ¡rÃ©rtÃ©kÃ©nek meghatÃ¡rozÃ¡sÃ¡hoz.",
            ufiCodesFromDatabase:
                "A nyomtatÃ¡shoz az adatbÃ¡zis-adminisztrÃ¡tor Ã¡ltal a fÅ adatbÃ¡zisbÃ³l megadott UFI-kÃ³dot kell hasznÃ¡lni.",
            ufiCodesFromLastFilling:
                "A nyomtatÃ¡shoz az Ã¼zemeltetÅ Ã¡ltal megadott, a legutÃ³bbi ÃºjratÃ¶ltÃ©sbÅl szÃ¡rmazÃ³ UFI-kÃ³dot kell hasznÃ¡lni, fÃ¼ggetlenÃ¼l az ÃºjratÃ¶ltÃ¶tt mennyisÃ©gtÅl."
        },
        userManagement: {
            add: "A beÃ¡llÃ­tÃ¡s Ãºj felhasznÃ¡lÃ³t ad hozzÃ¡, aki bejelentkezhet a szoftverbe. A felhasznÃ¡lÃ³hoz vonalkÃ³dot lehet rendelni, Ã©s beÃ¡llÃ­thatÃ³, hogy a szoftver indÃ­tÃ¡sa utÃ¡n automatikusan bejelentkezzen.",
            assignedGroups:
                "MeghatÃ¡rozza, hogy a felhasznÃ¡lÃ³ milyen felhasznÃ¡lÃ³i csoportokhoz tartozik. A kÃ¼lÃ¶nbÃ¶zÅ felhasznÃ¡lÃ³i csoportok kÃ¼lÃ¶nbÃ¶zÅ jogosultsÃ¡gokat osztanak szÃ©t.",
            availableGroups:
                "Ez hatÃ¡rozza meg, hogy milyen felhasznÃ¡lÃ³i csoportok Ã¡llnak a felhasznÃ¡lÃ³ rendelkezÃ©sÃ©re. A kÃ¼lÃ¶nbÃ¶zÅ felhasznÃ¡lÃ³i csoportok kÃ¼lÃ¶nbÃ¶zÅ jogosultsÃ¡gokat osztanak el.",
            loggedUserDelete: "A jelenleg bejelentkezett felhasznÃ¡lÃ³ nem tÃ¶rÃ¶lhetÅ."
        },
        visit: "vagy lÃ¡togasson el",
        visitNoLicense: "TovÃ¡bbi informÃ¡ciÃ³kÃ©rt kÃ©rjÃ¼k keresse fel"
    },
    helpSettings: {
        customHelpLink: "EgyÃ©ni sÃºgÃ³ hivatkozÃ¡s",
        helpSettings: "SÃºgÃ³ beÃ¡llÃ­tÃ¡sok",
        message: "Ãzenet"
    },
    helper: {
        automaticallyCheckForUpdates: "Automatikus frissÃ­tÃ©sek keresÃ©se",
        automaticallyDownloadUpdates: "Automatikus frissÃ­tÃ©sek letÃ¶ltÃ©se",
        automaticallyInstallNewDatabases: "Az Ãºj AdatbÃ¡zisok automatikus telepÃ­tÃ©se",
        automaticallyInstallUpdates: "A frissÃ­tÃ©sek automatikus telepÃ­tÃ©se",
        bugReport: "HibajelentÃ©s",
        canBrowseChangeLog: "Online %{name} vÃ¡ltozÃ¡snaplÃ³ megjelenÃ­tÃ©se.",
        collect: "GyÅ±jtÃ©s",
        collectLogFiles: "NaplÃ³fÃ¡jlok gyÅ±jtÃ©se",
        component: "ÃsszetevÅ",
        content: "Tartalom",
        contentSize: "Tartalom mÃ©rete",
        download: "LetÃ¶ltÃ©s",
        downloadLogFiles: "NaplÃ³fÃ¡jlok letÃ¶ltÃ©se",
        downloadingData: "Adatok letÃ¶ltÃ©se",
        everyHours: "Minden %{interval} Ã³rÃ¡ban",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Ãj verziÃ³",
        notConnected: "A sÃºgÃ³ nem csatlakozik",
        openBugReport: "HibajelentÃ©s megnyitÃ¡sa",
        packageSize: "VÃ¶dÃ¶r mÃ©ret",
        pleaseWait: "KÃ©rjÃ¼k vÃ¡rjon, ez eltarthat egy ideig.",
        send: "KÃ¼ldÃ©s",
        sendBugReportToCustomerService: "HibajelentÃ©s kÃ¼ldÃ©se az Ã¼gyfÃ©lszolgÃ¡latnak",
        sendingReport: "KÃ¼ldÃ©s",
        subject: "TÃ¡rgy"
    },
    helperDialog: {
        1: "EllenÅrizheti a szoftver vagy az adatbÃ¡zis frissÃ­tÃ©seit.",
        2: "Folytatja-e a frissÃ­tÃ©sek letÃ¶ltÃ©sÃ©t?",
        3: "Folytatja-e a letÃ¶ltÃ¶tt frissÃ­tÃ©sek telepÃ­tÃ©sÃ©t?",
        10: "A szoftver Ã©s az adatbÃ¡zis frissÃ­tÃ©seinek ellenÅrzÃ©se, kÃ©rjÃ¼k, vÃ¡rjon...",
        11: "Egy frissÃ­tÃ©s elÃ©rhetÅ a szÃ¡mÃ­tÃ³gÃ©pÃ©hez. SzeretnÃ© letÃ¶lteni?",
        12: "Nincs elÃ©rhetÅ frissÃ­tÃ©s a szÃ¡mÃ­tÃ³gÃ©pÃ©hez.",
        14: "Hiba tÃ¶rtÃ©nt a frissÃ­tÃ©sek keresÃ©se kÃ¶zben. %{0}",
        15: "TerÃ¼leti adatbÃ¡zisok szinkronizÃ¡lÃ¡sa. KÃ©rjÃ¼k, vÃ¡rjon...",
        20: "FrissÃ­tÃ©s letÃ¶ltÃ©se. KÃ©rjÃ¼k, vÃ¡rjon ...",
        21: "A letÃ¶ltÃ¶tt frissÃ­tÃ©s ellenÅrzÃ©se. KÃ©rjÃ¼k, vÃ¡rjon...",
        22: "A frissÃ­tÃ©s letÃ¶ltÃ©se nem sikerÃ¼lt. SzeretnÃ© Ãºjra letÃ¶lteni?",
        23: "A frissÃ­tÃ©s letÃ¶ltÃ©se nem sikerÃ¼lt (a fÃ¡jl hibÃ¡san formÃ¡zott). SzeretnÃ© Ãºjra letÃ¶lteni?",
        24: "Folytassa a frissÃ­tÃ©s telepÃ­tÃ©sÃ©vel?",
        25: "Az automatikus frissÃ­tÃ©s telepÃ­tÃ©se %{0} mÃºlva kezdÅdik",
        26: "Egy frissÃ­tÃ©s elÃ©rhetÅ a szÃ¡mÃ­tÃ³gÃ©pÃ©hez. SzeretnÃ© letÃ¶lteni?",
        27: "Folytassa a frissÃ­tÃ©s telepÃ­tÃ©sÃ©vel?",
        40: "Az alkalmazÃ¡sok Ã©s szolgÃ¡ltatÃ¡sok leÃ¡llÃ­tÃ¡sa. KÃ©rjÃ¼k, vÃ¡rjon...",
        41: "Ãj fÃ¡jlok mÃ¡solÃ¡sa. KÃ©rjÃ¼k vÃ¡rjon...",
        42: "Az alkalmazÃ¡sok Ã©s szolgÃ¡ltatÃ¡sok indÃ­tÃ¡sa. KÃ©rjÃ¼k, vÃ¡rjon...",
        43: "A szoftverfrissÃ­tÃ©s befejezÃ©se. KÃ©rem vÃ¡rjon...",
        44: "A szoftver sikeresen frissÃ¼lt.",
        45: "Meg akarja prÃ³bÃ¡lni Ãºjra a telepÃ­tÃ©st? Ha igen, ellenÅrizze hogy a szoftver Ã¶sszetevÅi jelenleg nem vannak-e hasznÃ¡latban.",
        46: "A PC ÃºjraindÃ­tÃ¡sÃ¡nak elÅkÃ©szÃ­tÃ©se. Az ÃºjraindÃ­tÃ¡s %{0} mÃºlva.",
        999: "BelsÅ hiba tÃ¶rtÃ©nt %{0}",
        automaticInstallation: "Automatikus frissÃ­tÃ©s telepÃ­tÃ©se",
        btnAbort: "LeÃ¡llÃ­tÃ¡s",
        btnCancel: "MÃ©gse",
        btnCheckUpdate: "FrissÃ­tÃ©sek keresÃ©se",
        btnContinue: "FolytatÃ¡s",
        btnDownloadUpdate: "FrissÃ­tÃ©sek letÃ¶ltÃ©se",
        btnInstallUpdate: "FrissÃ­tÃ©sek telepÃ­tÃ©se",
        btnOk: "OK",
        btnRetry: "PrÃ³bÃ¡lja Ãºjra",
        btnSkip: "ÃtugrÃ¡s",
        checkingForUpdates: "FrissÃ­tÃ©sek keresÃ©se",
        downloadingFailed: "A letÃ¶ltÃ©s sikertelen",
        downloadingPackage: "FrissÃ­tÃ©s letÃ¶ltÃ©se. KÃ©rem, vÃ¡rjon...",
        finishingUpdate: "FrissÃ­tÃ©s befejezÃ©se",
        installingUpdate: "FrissÃ­tÃ©s telepÃ­tÃ©se",
        internalError: "BelsÅ hiba",
        rebootRequired: "IndÃ­tsa Ãºjra",
        startingComponents: "A szoftver Ã¶sszetevÅk indÃ­tÃ¡sa",
        stoppingComponents: "A szoftver Ã¶sszetevÅinek leÃ¡llÃ­tÃ¡sa",
        synchronizingDatabases: "A terÃ¼leti adatbÃ¡zisok szinkronizÃ¡lÃ¡sa",
        updateAvailable: "ElÃ©rhetÅ frissÃ­tÃ©s. VÃ¡lassza ki a frissÃ­tendÅ elemeket.",
        updateDownloaded: "A frissÃ­tÃ©s letÃ¶ltÅdÃ¶tt.",
        updateFailed: "A frissÃ­tÃ©si folyamat sikertelen",
        updateInstalled: "A frissÃ­tÃ©s telepÃ­tve van",
        verificationFailed: "A frissÃ­tÃ©s ellenÅrzÃ©se sikertelen",
        verifyingPackage: "A letÃ¶ltÃ¶tt csomag ellenÅrzÃ©se",
        yourSoftwareIsUpToDate: "A szoftvere napra kÃ©sz",
        yourSoftwareVersion: "A szoftver verziÃ³ja: %{0}"
    },
    importData: {
        abortImportingData: "Az importÃ¡lÃ¡s megszakÃ­tÃ¡sa",
        aborted: "Az importÃ¡lÃ¡s megszakadt.",
        backupLocalDB: "Backup local database",
        confirmRestore: "TÃ©nyleg vissza akarja Ã¡llÃ­tani az Ã¶sszes helyi beÃ¡llÃ­tÃ¡st?",
        dataMissing: "Az importÃ¡lÃ¡s meghiÃºsult, mert a forrÃ¡sfÃ¡jl nem tartalmazott adatokat.",
        deleteImportedData: "Az importÃ¡lt adatok tÃ¶rlÃ©se",
        encodingFile: "FÃ¡jl kÃ³dolÃ¡s",
        exportLocalSettings: "Helyi beÃ¡llÃ­tÃ¡sok exportÃ¡lÃ¡sa",
        exportStaticSql: "Statikus SQL exportÃ¡lÃ¡sa",
        fileDamaged: "Az importÃ¡lÃ¡s sikertelen, mert a forrÃ¡sfÃ¡jl sÃ©rÃ¼ltnek tÅ±nik.",
        fileMissing: "Az importÃ¡lÃ¡s sikertelen, mert a forrÃ¡sfÃ¡jl nem lÃ©tezik.",
        format: "FormÃ¡tum",
        formatPath: "A formÃ¡tum Ãºtvonala",
        headerMissing: "Az importÃ¡lÃ¡s sikertelen, mert a fÃ¡jlok fejlÃ©ce hiÃ¡nyzik.",
        import: "ImportÃ¡lÃ¡s",
        importAborted: "ImportÃ¡lÃ¡s megszakÃ­tva",
        importAborting: "ImportÃ¡lÃ¡s megszakÃ­tÃ¡sa",
        importFailed: "Az importÃ¡lÃ¡s vÃ¡ratlan hiba miatt nem sikerÃ¼lt.",
        importLocalSettings: "Helyi beÃ¡llÃ­tÃ¡sok importÃ¡lÃ¡sa",
        importPrices: "ImportÃ¡lÃ¡s Ã¡rak",
        imported: "Sikeres ImportÃ¡lÃ¡s",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "ImportÃ¡lÃ¡s",
        noFormatAvailable: "Nem elÃ©rhetÅ formÃ¡tum",
        processing: "FeldolgozÃ¡s",
        processingCustomFormulas: "Egyedi receptek feldolgozÃ¡sa",
        processingCustomers: "Ãgyfelek feldolgozÃ¡sa",
        productsFile: "TermÃ©kek fÃ¡jl",
        restoreLocalSettings: "Helyi beÃ¡llÃ­tÃ¡sok visszaÃ¡llÃ­tÃ¡sa",
        underProgress: "Az importÃ¡lÃ¡s folyamatban van.",
        unknownFormat: "Az importÃ¡lÃ¡s sikertelen, mert a forrÃ¡sfÃ¡jl ismeretlen formÃ¡tumÃº.",
        userFormulasFile: "FelhasznÃ¡lÃ³i receptek fÃ¡jl"
    },
    infoType: {
        baseDensity: "BÃ¡zis sÅ±rÅ±sÃ©ge",
        baseMass: "BÃ¡zis tÃ¶mege",
        baseUfiCode: "Base UFI code",
        baseVolume: "BÃ¡zis tÃ©rfogata",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BSF fokozat",
        colorLab: "SzÃ­n Lab Ã©rtÃ©ke",
        colorRgb: "SzÃ­n RGB Ã©rtÃ©ke",
        colorRgbHex: "SzÃ­n RGB Hex Ã©rtÃ©ke",
        colorXyz: "SzÃ­n xyz Ã©rtÃ©ke",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "SzÃ­nezÅpaszta tÃ¶mege",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "SzÃ­nezÅpaszta sÅ±rÅ±sÃ©ge",
        formulaDate: "DÃ¡tum kÃ©plet",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula tovÃ¡bbi infÃ³",
        formulaMoreInfoInternal: "Formula tovÃ¡bbi informÃ¡ciÃ³ belsÅ",
        formulaMoreInfoPrint: "Formula TovÃ¡bbi informÃ¡ciÃ³ nyomtatÃ¡s",
        hbw: "HBW Ã©rtÃ©k",
        isPackageGravimetric: "Is package gravimetric",
        maxColorantMass: "A szÃ­nezÅanyag megengedett legnagyobb tÃ¶mege",
        maxColorantVolume: "Legnagyobb megengedett szÃ­nezÅanyag-tÃ©rfogat",
        nominalMass: "Csomag nÃ©vleges tÃ¶mege",
        nominalVolume: "Csomag nÃ©vleges tÃ©rfogata",
        overfillDetected: "TÃºltÃ¶ltÃ©s Ã©szlelve",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "FestÃ©k/termÃ©k Ã¶ssztÃ¶mege",
        totalPaintVolume: "FestÃ©k/termÃ©k Ã¶ssztÃ©rfogata",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Y Ã©rtÃ©k"
    },
    initialTab: {
        favoriteFormulas: "Kedvenc receptek",
        lastDispensedFormulas: "LegutÃ³bbi kikevert receptek",
        searchNewFormula: "Ãj recept keresÃ©se"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "cselekvÃ©s",
        add: "HozzÃ¡adÃ¡s",
        addition: "kiegÃ©szÃ­tÃ©s",
        additional: "TovÃ¡bbi ",
        address: "CÃ­m",
        admin: "admin",
        advanced: "HaladÃ³",
        after: "UtÃ¡n",
        afterDispensing: "adagolÃ¡s utÃ¡n",
        alfa: "Alfa",
        all: "mind",
        allow: "engedÃ©lyezd",
        alphabetically: "Ã¡bÃ©cÃ©rendben",
        amount: "Ã¶sszeg",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "automatikus feladat",
        availablePrice: "elÃ©rhetÅ Ã¡r",
        backup: "biztonsÃ¡gi mentÃ©s",
        banner: "banner",
        barcode: "vonalkÃ³d",
        barcodes: "vonalkÃ³dok",
        base: "alap",
        before: "elÅtt",
        begin: "kezdete",
        bfs: "bfs",
        bottom: "bottom",
        brand: "mÃ¡rka",
        brush: "kefe",
        bug: "hina",
        button: "gomb",
        buy: "vÃ¡sÃ¡rlÃ¡s",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrÃ¡lÃ¡s",
        can: "lehet",
        canHandling: "kanna kezelÃ©s",
        canister: "tartÃ¡ly ",
        canisterFilling: "tartÃ¡ly tÃ¶ltÃ©s",
        canisterLevels: "tartÃ¡lyszintek",
        canisters: "tartÃ¡lyok",
        cap: "sapka",
        center: "kÃ¶zpont",
        centre: "kÃ¶zÃ©psÅ",
        change: "vÃ¡ltozÃ¡s",
        changelog: "vÃ¡ltozÃ¡snaplÃ³",
        channels: "csatornÃ¡k",
        check: "ellenÅrizze",
        chunk: "darab",
        chunks: "darabok",
        city: "vÃ¡ros",
        clean: "tiszta",
        cleaning: "tisztÃ­tÃ¡s",
        clientIdentifier: "Ã¼gyfÃ©l azonosÃ­tÃ³",
        close: "zÃ¡rÃ¡s",
        closest: "legkÃ¶zelebbi",
        code: "kÃ³d",
        collect: "Ã¶sszegyÅ±jteni",
        color: "szÃ­n",
        colorLink3: "SzÃ­nLink3",
        colorPanel: "szÃ­npaletta",
        colorReader: "szÃ­n olvasÃ³",
        colorant: "szÃ­nezÅanyag",
        colorantConsumption: "szÃ­nezÅanyag-fogyasztÃ¡s",
        colorantPrice: "szÃ­nezÅanyag Ã¡ra",
        colorants: "szÃ­nezÃ©kek",
        colorix: "Colorix",
        colour: "szÃ­n",
        communication: "kommunikÃ¡ciÃ³",
        compare: "Ã¶sszehasonlÃ­t",
        competitive: "versenykÃ©pes",
        computer: "szÃ¡mÃ­tÃ³gÃ©p",
        config: "konfigurÃ¡ciÃ³",
        configuration: "konfigurÃ¡ciÃ³",
        confirm: "megerÅsÃ­t",
        confirmation: "visszaigazolÃ¡s",
        connection: "kapcsolat",
        contactPerson: "kapcsolattartÃ³ szemÃ©ly",
        control: "VezÃ©rlÃ©s",
        copies: "mÃ¡solatok",
        corob: "Corob",
        cost: "kÃ¶ltsÃ©g",
        country: "orszÃ¡g",
        create: "lÃ©trehozÃ¡s",
        currency: "valuta",
        current: "jelenlegi",
        custom: "egyÃ©ni",
        customers: "Ã¼gyfelek",
        daily: "napi",
        dark: "Dark",
        data: "adatok",
        database: "adatbÃ¡zis",
        datacolor: "Datacolor",
        date: "dÃ¡tum",
        decimals: "tizedesjegyek",
        default: "alapÃ©rtelmezett",
        delay: "delay",
        delete: "delete",
        deletion: "tÃ¶rlÃ©s",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnosztikai csempe",
        dialog: "dialÃ³gus",
        direct: "kÃ¶zvetlen",
        disconnect: "kapcsolja le a  oldalt.",
        discount: "kedvezmÃ©ny",
        dispense: "adagolÃ³k",
        dispenser: "adagolÃ³",
        dispensing: "adagolÃ³",
        down: "le",
        download: "letÃ¶ltÃ©s",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "szerkesztÃ©se",
        editor: "szerkesztÅ",
        email: "email",
        error: "hiba",
        evoDriver: "Evo MeghajtÃ³",
        evoService: "Evo szerviz",
        excel: "excel",
        expiration: "lejÃ¡rat",
        export: "exportÃ¡lÃ¡s",
        eyeOne: "Egy- szem",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Gyors Ã©s folyÃ©kony",
        file: "fÃ¡jl",
        fill: "fill",
        fillToMax: "kitÃ¶ltÃ©s max.",
        find: "find",
        first: "elsÅ",
        flex: "rugalmas",
        folder: "mappa",
        formula: "formula",
        formulas: "kÃ©pletek",
        from: "cÃ­mrÅl",
        fts5: "fts5",
        fullScreen: "teljes kÃ©pernyÅ",
        fullText: "teljes szÃ¶veg",
        fulltext: "teljes szÃ¶veg",
        g: "g",
        genericPricing: "Ã¡ltalÃ¡nos Ã¡rkÃ©pzÃ©s",
        hLD: "HLD",
        hard: "kemÃ©ny",
        hbw: "hbw",
        help: "segÃ­tsÃ©g",
        helpCenter: "segÃ­tÅ kÃ¶zpont",
        hero: "Hero",
        history: "tÃ¶rtÃ©nelem",
        home: "otthon",
        host: "hÃ¡zigazda",
        humidifier: "pÃ¡rÃ¡sÃ­tÃ³",
        iDD: "IDD",
        identification: "azonosÃ­tÃ³",
        image: "kÃ©p",
        impGallon: "imp. gallon",
        impQuart: "imp. kvart",
        import: "import",
        individually: "egyedileg",
        info: "info",
        information: "informÃ¡ciÃ³",
        initial: "kezdeti",
        initialization: "inicializÃ¡lÃ¡s",
        initialize: "inicializÃ¡lÃ¡s",
        insert: "beillesztÃ©s",
        install: "telepÃ­tÃ©s",
        intellyPurge: "belsÅ tisztÃ­tÃ¡s",
        invalid: "Ã©rvÃ©nytelen",
        ipAddress: "ip cÃ­m",
        italtinto: "Italtinto",
        items: "tÃ©telek",
        keyboard: "billentyÅ±zet",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "laboratÃ³rium",
        label: "cÃ­mke",
        labels: "cÃ­mkÃ©k",
        language: "nyelv",
        largo: "largo",
        last: "utolsÃ³",
        lenteq: "Lenteq",
        levels: "szintek",
        license: "licenc",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "terhelÃ©s",
        lock: "lock",
        logFiles: "naplÃ³fÃ¡jlok",
        logic: "logika",
        logo: "logo",
        lower: "lower",
        machine: "gÃ©p",
        machineConfiguration: "gÃ©pkonfigurÃ¡ciÃ³",
        machineManagement: "gÃ©pkezelÃ©s",
        machineName: "gÃ©p neve",
        main: "fÅ",
        maintenance: "karbantartÃ¡s",
        manual: "kÃ©zi",
        manualAddition: "kÃ©zi kiegÃ©szÃ­tÃ©s",
        manualDispensing: "kÃ©zi adagolÃ¡s",
        manualScan: "kÃ©zi szkennelÃ©s",
        margins: "margÃ³k",
        markups: "jelÃ¶lÃ©sek",
        mass: "tÃ¶meg",
        match: "mÃ©rkÅzÃ©s",
        measure: "intÃ©zkedÃ©s",
        measurement: "mÃ©rÃ©s",
        measurementUnits: "mÃ©rtÃ©kegysÃ©gek",
        melody: "dallam",
        message: "Ã¼zenet",
        minimal: "minimÃ¡lis",
        minolta: "Minolta",
        minus: "mÃ­nusz",
        minutes: "percek",
        misura: "Misura",
        ml: "ml",
        mode: "mÃ³d",
        model: "modell",
        modification: "mÃ³dosÃ­tÃ¡s",
        modify: "mÃ³dosÃ­tÃ¡s",
        monthly: "havi",
        moreInfo: "tÃ¶bb informÃ¡ciÃ³",
        movableTable: "mozgathatÃ³ asztal",
        move: "move",
        music: "zene",
        myOrders: "rendelÃ©seim",
        name: "nÃ©v",
        naming: "elnevezÃ©s",
        nano: "Nano",
        navigation: "navigÃ¡ciÃ³",
        new: "Ãºj",
        nextDriver: "KÃ¶vetkezÅVezetÅ",
        night: "night",
        nixPro: "Nix Pro",
        notes: "jegyzetek",
        notification: "Ã©rtesÃ­tÃ©s",
        number: "szÃ¡m",
        off: "ki",
        open: "nyitott",
        order: "megrendelÃ©s",
        ordering: "megrendelÃ©s",
        overfill: "tÃºltÃ¶ltÃ©s",
        overview: "Ã¡ttekintÃ©s",
        overwrite: "felÃ¼lÃ­rÃ¡s",
        own: "sajÃ¡t",
        pCPDriver: "PCPDriver",
        package: "csomag",
        packagePrice: "csomag Ã¡ra",
        packages: "csomagok",
        panels: "panelek",
        parameter: "paramÃ©ter",
        path: "path",
        pc: "pc",
        phone: "telefon",
        phoneNumber: "telefonszÃ¡m",
        picture: "kÃ©p",
        place: "hely",
        placement: "elhelyezÃ©s",
        plug: "dugÃ³",
        plugger: "dugaszolÃ³",
        plugging: "dugulÃ¡selhÃ¡rÃ­tÃ¡s",
        plugin: "plugin",
        plus: "plusz",
        pointOfSale: "Ã©rtÃ©kesÃ­tÃ©si pont",
        popUp: "pop-up",
        pos: "pos",
        present: "jelen",
        preview: "elÅnÃ©zet",
        price: "Ã¡r",
        priceExport: "Ã¡r export",
        priceGroup: "Ã¡rcsoport",
        priceImport: "Ã¡r import",
        prices: "Ã¡rak",
        pricing: "Ã¡rkÃ©pzÃ©s",
        primaryCurrency: "elsÅdleges pÃ©nznem",
        print: "nyomtatÃ¡s",
        printer: "nyomtatÃ³",
        printing: "nyomtatÃ¡s",
        problem: "problÃ©ma",
        product: "termÃ©k",
        productPrice: "termÃ©k Ã¡ra",
        profiledValues: "profilozott Ã©rtÃ©kek",
        punch: "lyukasztÃ³",
        puncher: "lyukasztÃ³",
        punching: "lyukasztÃ³",
        purge: "tisztÃ­tÃ³",
        purgeType: "tisztÃ­tÃ¡s tÃ­pusa",
        purgeVolume: "tisztÃ­tÃ¡si mennyisÃ©g",
        quality: "minÅsÃ©g",
        quick: "gyors",
        quickTint: "gyors Ã¡rnyalat",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "olvasÃ³",
        reboot: "ÃºjraindÃ­tÃ¡s",
        receive: "fogadja a  cÃ­met.",
        recirculate: "recirculate",
        recirculation: "recirkulÃ¡ciÃ³",
        redlike: "Redlike",
        refill: "ÃºjratÃ¶ltÃ©s",
        registration: "regisztrÃ¡ciÃ³",
        regular: "rendszeres",
        removal: "eltÃ¡volÃ­tÃ¡s",
        remove: "eltÃ¡volÃ­tani",
        report: "jelentÃ©s",
        reset: "visszaÃ¡llÃ­tÃ¡s",
        resolution: "felbontÃ¡s",
        restart: "ÃºjraindÃ­tÃ¡s",
        rgb: "rgb",
        rights: "jogok",
        rounding: "kerekÃ­tÃ©s",
        rules: "szabÃ¡lyok",
        sanTint: "SanTint",
        save: "save",
        scale: "skÃ¡la",
        scan: "szkennelÃ©s",
        scope: "scope",
        screen: "kÃ©pernyÅ",
        screensaver: "kÃ©pernyÅvÃ©dÅ",
        search: "keresÃ©s",
        secondaryCurrency: "mÃ¡sodlagos valuta",
        select: "kivÃ¡lasztÃ¡sa",
        selectedFormula: "Selected formula",
        sell: "eladni",
        sensor: "Ã©rzÃ©kelÅ",
        serialNumber: "sorozatszÃ¡m",
        server: "szerver",
        servers: "szerverek",
        service: "szolgÃ¡ltatÃ¡s",
        serviceAction: "szolgÃ¡ltatÃ¡si mÅ±velet",
        serviceActions: "szolgÃ¡ltatÃ¡si tevÃ©kenysÃ©gek",
        serviceSoftware: "szolgÃ¡ltatÃ¡si szoftver",
        serviceWindow: "szolgÃ¡ltatÃ¡s ablak",
        settings: "beÃ¡llÃ­tÃ¡sok",
        shelf: "polc",
        shortcuts: "parancsikonok",
        shot: "lÃ¶vÃ©s",
        show: "mutasd meg a",
        shutDown: "leÃ¡llÃ­tÃ¡s",
        shutdown: "leÃ¡llÃ­tÃ¡s",
        silent: "csend",
        simple: "egyszerÅ±",
        simulation: "szimulÃ¡ciÃ³",
        size: "mÃ©ret",
        skip: "kihagyÃ¡sa",
        smartPurge: "intelligens tisztÃ­tÃ¡s",
        software: "szoftver",
        softwareSupplier: "szoftver szÃ¡llÃ­tÃ³",
        sort: "rendezÃ©s",
        sound: "hang",
        spectro: "spectro",
        spectrophotometer: "spektrofotomÃ©ter",
        speed: "sebessÃ©g",
        split: "osztott",
        start: "indÃ­tÃ¡s",
        startup: "indÃ­tsd el",
        statistics: "statisztika",
        status: "stÃ¡tusz",
        stir: "stir",
        stirring: "keverÃ©s",
        street: "utca",
        support: "tÃ¡mogatÃ¡s",
        surcharge: "pÃ³tdÃ­j",
        tab: "lap",
        tabs: "lapok",
        task: "feladat",
        template: "sablon",
        testing: "tesztelÃ©s",
        time: "idÅ",
        tintingManagementCenter: "szÃ­nezÃ©s menedzsment kÃ¶zpont",
        to: "a  cÃ­mre",
        toDispense: "adagolni",
        tolerance: "tolerancia",
        top: "felsÅ",
        total: "Ã¶sszesen",
        translation: "fordÃ­tÃ¡s",
        turnOff: "kikapcsolÃ¡s",
        turntable: "forgÃ³tÃ¡nyÃ©r",
        type: "tÃ­pus",
        uIDD: "UIDD",
        uSGallon: "U.S. gallon",
        uSQuart: "U.S quart",
        unit: "egysÃ©g",
        up: "fel",
        update: "frissÃ­tÃ©s",
        url: "URL",
        user: "felhasznÃ¡lÃ³",
        userGroups: "felhasznÃ¡lÃ³i csoportok",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "HÃA",
        validate: "Ã©rvÃ©nyesÃ­t",
        validation: "Ã©rvÃ©nyesÃ­tÃ©s",
        version: "verziÃ³",
        virtual: "virtuÃ¡lis",
        volume: "kÃ¶tet",
        weekly: "heti",
        window: "ablak",
        windows: "Windows",
        with: "a  cÃ­men",
        without: "nÃ©lkÃ¼l",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y Ã©rtÃ©k",
        zipCode: "irÃ¡nyÃ­tÃ³szÃ¡m",
        zoom: "nagyÃ­tÃ¡s"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Licenc aktivÃ¡lÃ¡sa",
        activateNewLicense: "Ãj licenc aktivÃ¡lÃ¡sa",
        checkLicenseKey: "EllenÅrizze a licenckulcsot",
        companyId: "VÃ¡llalati azonosÃ­tÃ³",
        contactPerson: "KapcsolattartÃ³",
        copy: "MÃ¡solÃ¡s",
        country: "OrszÃ¡g",
        emptyCity: "A vÃ¡ros kÃ¶telezÅ adat",
        emptyCountry: "Az orszÃ¡g kÃ¶telezÅ adat",
        emptyName: "Shop name is a required information",
        enterIdentificationKeys: "Adja meg az azonosÃ­tÃ³ kulcsokat",
        expirationDate: "LejÃ¡rat dÃ¡tuma:  %{dateTime}",
        fillRegistration: "TÃ¶ltse ki a regisztrÃ¡ciÃ³s adatokat",
        insertLicense: "Helyezze be a generÃ¡lt kulcsot az offline aktivÃ¡lÃ¡shoz",
        invalidEmail: "Email input is invalid",
        invalidPhone: "Phone input is invalid",
        itemsMarkedasterisk: "(a csillaggal jelÃ¶lt tÃ©teleket ki kell tÃ¶lteni)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "BÃ©relt licenc",
        licenseActivated: "A licenc mÃ¡r aktivÃ¡lva van",
        licenseStatus: "Licenc Ã¡llapota",
        licenseWillExpire: "A licenc %{dayCount} nap mÃºlva lejÃ¡r",
        licenseWillExpireOneDay: "Az Ãn engedÃ©lye %{dayCount} nap mÃºlva jÃ¡r le.",
        machineInformation: "SzÃ­nezÅgÃ©p informÃ¡ciÃ³",
        noLicenseAvailable: "Nincs elÃ©rhetÅ licenc",
        noProductsForKey: "A megadott azonosÃ­tÃ³ kulcsokhoz nem Ã¡llnak rendelkezÃ©sre termÃ©kek.",
        pointOfSale: "ÃrtÃ©kesÃ­tÃ©si pont",
        producer: "GyÃ¡rtÃ¡svezetÅ",
        reactivate: "ReaktivÃ¡lÃ¡s",
        reactivateLicense: "Reactivate license",
        region: "RÃ©giÃ³",
        registerLicense: "KÃ©rjÃ¼k, kÃ©szÃ­tsen mÃ¡solatot az aktivÃ¡lÃ¡si kÃ©relemrÅl, Ã©s navigÃ¡ljon a kÃ¶vetkezÅhÃ¶z:",
        registrationForm: "RegisztrÃ¡ciÃ³s Å±rlap",
        selectProduct: "TermÃ©k vÃ¡lasztÃ¡s",
        serialNumber: "SzÃ©ria szÃ¡m",
        skipNewLicense: "Ha kÃ©sÅbb szeretnÃ© aktivÃ¡lni az Ãºj licencet, kattintson a KihagyÃ¡s gombra.",
        unlimitedLicense: "KorlÃ¡tlan licenc",
        userId: "FelhasznÃ¡lÃ³i azonosÃ­tÃ³",
        uuid: "UUID licenc",
        versionDetails: "A verziÃ³ rÃ©szletei",
        versionScope: "VerziÃ³ hatÃ¡lya",
        versionType: "VerziÃ³ tÃ­pusa",
        zip: "Postai irÃ¡nyÃ­tÃ³szÃ¡m"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "BelÃ©pÃ©s",
        loginAs: "BejelentkezÃ©s mÃ¡sik felhasznÃ¡lÃ³kÃ©nt",
        messages: {
            incorrectUsername: "Helytelen felhasznÃ¡lÃ³nÃ©v vagy jelszÃ³"
        },
        password: "JelszÃ³",
        username: "FelhasznÃ¡lÃ³nÃ©v"
    },
    machineActionHistory: {
        actionHistory: "Hiba Ã¼zenetek"
    },
    machineErrors: {
        channel: "Csatorna",
        code: "KÃ³d",
        machineErrors: "SzÃ­nezÅgÃ©p hibÃ¡k",
        noMachineErrors: "Jelenleg nincsenek gÃ©phibÃ¡k",
        resetErrors: "VisszaÃ¡llÃ­tÃ¡si hibÃ¡k"
    },
    machineSettings: {
        action: "EsemÃ©ny",
        addAutotask: "automatikus feladat hozzÃ¡adÃ¡sa",
        autoCanisterIn: "Automata kaniszter be",
        autoCanisterOut: "Automata kaniszter ki",
        automaticRefill: "Automatikus utÃ¡ntÃ¶ltÃ©s",
        autotaskSettings: "Autotask beÃ¡llÃ­tÃ¡sok",
        backupConfiguration: "SzÃ­nezÅgÃ©p konfigurÃ¡ciÃ³ biztonsÃ¡gi mentÃ©se",
        brushMaintenance: "KefÃ©k kezelÃ©se",
        capMaintenance: "ZÃ¡rÃ³kupak kezelÃ©se",
        checkCanisterBeforeDispense: "SzÃ­nezÃ©s elÅtt ellenÅrizze a kanisztereket!",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "EllenÅrizze a szÃ­nezÅanyagok minimÃ¡lisan szÃ­nezhetÅ mennyisÃ©gÃ©t",
        checkOverfill: "EllenÅrizze a kanna tÃºltÃ¶ltÃ©sÃ©t",
        checkTotalCntAmounts: "EllenÅrizze az alapfestÃ©k teljes szÃ­nezÅanyag-mennyisÃ©gÃ©t",
        cleanAll: "Mindent tisztÃ­t",
        computerReboot: "SzÃ¡mÃ­tÃ³gÃ©p ÃºjraindÃ­tÃ¡sa",
        computerShutdown: "SzÃ¡mÃ­tÃ³gÃ©p kikapcsolÃ¡sa",
        connectMachine: "Csatlakoztassa a szÃ­nezÅgÃ©pet",
        days: "Nap/Napok",
        daysOfMonth: "Napok a hÃ³napban",
        devices: "EszkÃ¶zÃ¶k",
        disabled: "Letiltva",
        dispenseAndPurge: "AdagolÃ¡s Ã©s tisztÃ­tÃ¡s",
        dispenseOnly: "Csak adagolÃ¡s",
        dispenserCleaning: "SzÃ­nezÅgÃ©p tisztÃ­tÃ¡s",
        dispensingWithErrorsEnabled: "Az Ã©rvÃ©nyesÃ­tÃ©si hibÃ¡k ellenÃ©re engedÃ©lyezze az adagolÃ¡st",
        editAutotask: "Automatikus feladat szerkesztÃ©se",
        firstRun: "First run",
        hours: "Ãra",
        humidifier: "PÃ¡ramentesÃ­tÅ",
        humidifierWaterLevelMaintenance: "PÃ¡rÃ¡sÃ­tÃ³ vÃ­z szintjÃ©nek kezelÃ©se",
        machineConfigurationNoCanisters: "A gÃ©p konfigurÃ¡ciÃ³ja nem tartalmaz tartÃ¡lyokat.",
        machineName: "GÃ©p neve",
        machineSettings: "GÃ©p beÃ¡llÃ­tÃ¡sai",
        manualPuncher: "KÃ©zi lyukasztÃ³",
        minDispensedAmount: "Minimum adagolÃ¡si mennyisÃ©g",
        minutes: "Perc",
        nextRun: "KÃ¶vetkezÅ futtatÃ¡s",
        noAutotasksSet: "Nincsenek automatikus feladatok beÃ¡llÃ­tva",
        noDataAvailable: "Nincsenek adatok",
        noMachine: "Nincs szÃ­nezÅgÃ©p csatlakoztatva",
        onStart: "IndulÃ¡skor",
        plugger: "DugÃ³",
        postpone: "Elhalaszt",
        puncher: "LyukasztÃ³",
        purgeAll: "Teljes tisztÃ­tÃ¡s",
        purgeOnly: "Csak tisztÃ­tÃ¡s",
        recirculateAll: "VisszatÃ¶ltÃ©s  ",
        recirculateChannels: "VisszatÃ¶ltÃ©s a csatornÃ¡kbÃ³l",
        recirculationSpeed: "VisszatÃ¶ltÃ©s sebessÃ©ge",
        recirculationTime: "VisszatÃ¶ltÃ©si idÅ",
        refillAll: "Minden ÃºjratÃ¶ltÃ©se",
        refillCanisters: "Kaniszterek ÃºjratÃ¶ltÃ©se",
        runAt: "FuttatÃ¡s ",
        runDefinedDaysAt: "MeghatÃ¡rozott napok",
        runEvery: "FuttatÃ¡s minden",
        runInDays: "FuttatÃ¡si napok",
        serialNum: "SzÃ©ria szÃ¡m",
        settingsMachine: "SzÃ­nezÅgÃ©p beÃ¡llÃ­tÃ¡sok",
        smartPurgeAll: "Ãsszes intelligens tisztÃ­tÃ¡sa",
        smartPurgeChannels: "CsatornÃ¡k intelligens tisztÃ­tÃ¡sa",
        smartPurgeRules: "Az intelligens tisztÃ­tÃ¡s szabÃ¡lyai",
        startType: "IndÃ­tÃ¡si mÃ³d",
        stirAll: "Mindent megkever",
        stirCanisters: "Kaniszterek keverÃ©se",
        stirringSpeed: "KeverÃ©si sebessÃ©g",
        stirringTime: "KeverÃ©si idÅ",
        switchPlateMaintenance: "KapcsolÃ³tÃ¡lca kezelÃ©s",
        theCurrentlySelectedMachine: "Jelenleg hasznÃ¡lt gÃ©p",
        threshold: "HatÃ¡rÃ©rtÃ©k",
        turntable: "Asztal mozgatÃ¡s",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "TÃ©rfogat",
        weekdays: "A hÃ©t napjai"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "HozzÃ¡adÃ¡s a kedvencekhez",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Egy vagy tÃ¶bb szÃ­nezÅanyag Ã©rvÃ©nytelen",
        dispensedPackages: "MegszÃ­nezett kiszerelÃ©sek",
        dispensingInProgress: "Folyamatban lÃ©vÅ szÃ­nezÃ©s",
        dispensingIsAborted: "MegszakÃ­tott szÃ­nezÃ©s",
        dispensingIsNotAvailable: "A szÃ­nezÃ©s nem Ã¡ll rendelkezÃ©sre",
        dispensingProgress: "%{done} kÃ©sz az %{all}-bÅl",
        editColorant: "SzÃ­n szerkesztÃ©se",
        editNote: "MegjegyzÃ©s szerkesztÃ©se",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "FelÃ¼lÃ­rt adagolÃ¡s",
        formulaInvalidColorants: "A recept Ã©rvÃ©nytelen szÃ­nezÅpasztÃ¡kat tartalmaz: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "Receptek elÅzmÃ©nyei",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "SzÃ­nezÅgÃ©p hibÃ¡s",
        machineIsBusy: "SzÃ­nezÅgÃ©p dolgozik",
        machineNotConnected: "SzÃ­nezÅgÃ©p nincs csatlakoztatva",
        manualColorantAddition: "KÃ©zi adagolÃ¡s ",
        modifiedFormula: "A recept mÃ³dosult",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "Nem Ã¡ll rendelkezÃ©sre alap",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Nincsenek szÃ­nezÅpasztÃ¡k",
        noCustomer: "Nincs vevÅ",
        noCustomers: "Nincs elÃ©rhetÅ vevÅ",
        noDispenseNotesAvailable: "Nincs elÃ©rhetÅ megjegyzÃ©s az adagolÃ¡shoz",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nincs recept kivÃ¡lasztva",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "Nincs elÃ©rhetÅ megjegyzÃ©s",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nincs kivÃ¡lasztott csomag",
        noProductAvailable: "No product is available",
        noResultsFound: "Nincs talÃ¡lat",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "MegrendelÃ©s",
        orderingIsNotAvailable: "MegrendelÃ©s nem elÃ©rhetÅ",
        originalColor: "Original color",
        overAvailableLevel: "A rendelkezÃ©sre Ã¡llÃ³ szint felett",
        package: "KÃ©sztermÃ©k",
        packageIsRequired: "Csomag szÃ¼ksÃ©ges",
        packaging: "CsomagolÃ¡s",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "NyomtatÃ³ nem elÃ©rhetÅ",
        productFiles: "TermÃ©k fÃ¡jlok",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "ListaÃ¡r",
        resetFormulaData: "Ãj recept",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "MentÃ©s mÃ¡skÃ©nt",
        saveToStatsIsNotAvailable: "Nem Ã©rhetÅ el az elÅzmÃ©nyekbe valÃ³ mentÃ©s",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Egyedi Ã¡r",
        specialPriceVip: "Nagykereskedelmi Ã¡r",
        splitFormula: "Osztott Recept",
        withVAT: "ÃfÃ¡val",
        withoutVAT: "Ãfa nÃ©lkÃ¼l"
    },
    marginSettings: {
        allBases: "Minden bÃ¡zis",
        allProducts: "Ãsszes termÃ©k",
        editMargin: "ÃrrÃ©s szerkesztÃ©se",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "ÃrrÃ©s beÃ¡llÃ­tÃ¡sok",
        marginsFor: "ÃrrÃ©sek ",
        markupColorants: "SzÃ­nezÅpaszta haszonkulcs",
        sizeOfPackage: "KiszerelÃ©s mÃ©rete",
        valueBase: "ÃrtÃ©kalap",
        valueColorant: "ÃrtÃ©k szÃ­nezÅanyag"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "SzÃ­nezÅpaszta mennyisÃ©gÃ©nek megvÃ¡ltoztatÃ¡sa",
        payAttention: "Figyeljen oda!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "SzÃ­nkÃ¡rtyÃ¡k szÅ±rÃ©se",
            formulasOverLimit: "%{count} eredmÃ©nyek. KÃ©rjÃ¼k Ã­rjon tÃ¶bb karaktert!",
            foundFormulas: "%{count} recept talÃ¡lhatÃ³",
            help: "SÃºgÃ³",
            helpText:
                "Ãrja be '%{filter}' a receptek keresÃ©sekor '%{formula}', a termÃ©k nevÃ©t '%{product}' -val/vel kezdÅdÅen Ã©s a szÃ­nkÃ¡rtya nevÃ©t '%{fandeck}'.",
            productFilter: "TermÃ©kek szÅ±rÃ©se",
            searchInFormulas: "KeresÃ©s a receptekben",
            typeMore: "KÃ©rjÃ¼k Ã­rjon be tÃ¶bb karaktert!"
        },
        menu: {
            actionHistory: "MÅ±veleti elÅzmÃ©nyek",
            additionalFormulaTab: "TovÃ¡bbi kÃ©plet lap",
            advancedSettings: "SpeciÃ¡lis beÃ¡llÃ­tÃ¡sok",
            autotaskSettings: "Automatikus feladat beÃ¡llÃ­tÃ¡sok",
            availableDatabases: "ElÃ©rhetÅ adatbÃ¡zisok",
            availablePrices: "ElÃ©rhetÅ Ã¡rak",
            bugReport: "HibajelentÃ©s",
            canisterBarcodes: "Kaniszter VonalkÃ³dja",
            canisterDispensingLogic: "AdagolÃ¡si logika",
            canisterFilling: "Kaniszter utÃ¡ntÃ¶ltÃ©s",
            canisterSettings: "Kaniszter beÃ¡llÃ­tÃ¡sai",
            clientServerSettings: "ÃgyfÃ©l/KiszolgÃ¡lÃ³ beÃ¡llÃ­tÃ¡sok",
            closing: "ZÃ¡rÃ¡s",
            color: "szÃ­n",
            colorModification: "SzÃ­n mÃ³dosÃ­tÃ¡sa",
            colorPanel: "SzÃ­npaletta beÃ¡llÃ­tÃ¡sok",
            colorRepresentation: "SzÃ­nes Ã¡brÃ¡zolÃ¡s Ã©s adatok",
            colorSearch: "SzÃ­n keresÃ©s",
            colorant: "SzÃ­nezÅanyag",
            colorantConsumption: "SzÃ­nezÅanyag-fogyasztÃ¡s",
            colorantPricing: "SzÃ­nezÅpaszta Ã¡rkÃ©pzÃ©s ",
            colorantRefillHistory: "SzÃ­nezÅanyag utÃ¡ntÃ¶ltÃ©s tÃ¶rtÃ©nete",
            competitiveSearch: "VersenykÃ©pes szÃ­nkeresÃ©s",
            connections: "Kapcsolatok",
            currency: "PÃ©nznem beÃ¡llÃ­tÃ¡sai",
            customData: "Egyedi adatok",
            database: "AdatbÃ¡zis",
            databaseCheck: "AdatbÃ¡zis ellenÅrzÃ©se",
            databaseConnection: "AdatbÃ¡zis kapcsolat",
            defaultValues: "AlapÃ©rtelmezett Ã©rtÃ©kek",
            devices: "EszkÃ¶zÃ¶k",
            dispensingHistory: "SzÃ­nezÃ©si elÅzmÃ©ny",
            dispensingSettings: "AdagolÃ¡si beÃ¡llÃ­tÃ¡sok",
            driverSettings: "MeghajtÃ³ beÃ¡llÃ­tÃ¡sok",
            environment: "MegjelenÃ­tÃ©s beÃ¡llÃ­tÃ¡sai",
            environmentConfiguration: "MegjelenÃ­tÃ©s beÃ¡llÃ­tÃ¡sai",
            environmentalSettings: "KÃ¶rnyezeti beÃ¡llÃ­tÃ¡sok",
            favorites: "Kedvencek",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Adat",
            formulaModification: "Formula modification",
            formulaPanels: "Formula panelek",
            formulaSettings: "Recept beÃ¡llÃ­tÃ¡sok",
            formulaUnit: "KÃ©plet egysÃ©g",
            generalSearch: "ÃltalÃ¡nos keresÃ©s",
            globalSettingsSearch: "GlobÃ¡lis beÃ¡llÃ­tÃ¡sok keresÃ©se",
            helpItems: "SÃºgÃ³ beÃ¡llÃ­tÃ¡sok",
            importAndExport: "Import and export",
            importAndExportData: "EgyÃ©ni adatok importÃ¡lÃ¡sa",
            importCustomData: "Adat ImportÃ¡lÃ¡s",
            initialFormulaTab: "Kezdeti kÃ©plet lap",
            interfaceSettings: "Interface beÃ¡llÃ­tÃ¡sok",
            keyboardShortcuts: "GyorsbillenytyÅ±k",
            language: "Nyelv",
            languageSettings: "Nyelvi beÃ¡llÃ­tÃ¡sok",
            layout: "ElrendezÃ©s",
            license: "Licenc",
            licenseData: "Licencadatok",
            licenseIdentification: "Licenc azonosÃ­tÃ¡sa",
            licenseStatus: "LicencszerzÅdÃ©s",
            licenseSupplier: "Licenc szÃ¡llÃ­tÃ³",
            licenseVersion: "Licenc verziÃ³",
            localData: "Helyi adatok",
            machine: "GÃ©p informÃ¡ciÃ³k",
            machineActions: "GÃ©p beÃ¡llÃ­tÃ¡sok",
            machineAndDevices: "GÃ©pek Ã©s eszkÃ¶zÃ¶k",
            machineManagement: "GÃ©pkezelÃ©s",
            machineSettings: "GÃ©p beÃ¡llÃ­tÃ¡sok",
            mainSettings: "FÅ beÃ¡llÃ­tÃ¡sok",
            maintenance: "KarbantartÃ¡s",
            marginAndDiscount: "ÃrrÃ©s Ã©s Ã¡rengedmÃ©ny",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "NavigÃ¡ciÃ³s elemek",
            newFormulaWindow: "Recept",
            orderSearch: "MegrendelÃ©s keresÃ©se",
            orderSettings: "RendelÃ©si beÃ¡llÃ­tÃ¡sok",
            packageSurcharge: "Csomag pÃ³tdÃ­j",
            popUps: "Pop-Ups",
            posInfo: "Partner informÃ¡ciÃ³",
            price: "Ãr beÃ¡llÃ­tÃ¡sok",
            priceManagement: "ÃrkezelÃ©s",
            priceSettings: "Ãr beÃ¡llÃ­tÃ¡sok",
            pricingOptions: "ÃrkÃ©pzÃ©si lehetÅsÃ©gek",
            printSettings: "NyomtatÃ¡s",
            productPricing: "TermÃ©k Ã¡ra",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Gyors szÃ­nezÃ©s",
            rccConfig: "RCC adatbÃ¡zis beÃ¡llÃ­tÃ¡sok",
            rccConnection: "RCC ElÃ©rÃ©si Ãºt beÃ¡llÃ­tÃ¡sai",
            rccSettings: "RCC eszkÃ¶z beÃ¡llÃ­tÃ¡sok",
            refillSettings: "Refill Settings",
            refillingLogic: "ÃjratÃ¶ltÃ©si logika",
            registration: "RegisztrÃ¡ciÃ³",
            searchSettings: "KeresÃ©si beÃ¡llÃ­tÃ¡sok",
            serverPlugins: "KiszolgÃ¡lÃ³ bÅvÃ­tmÃ©nyek",
            serviceActions: "Szerviz mÅ±veletek",
            settings: "BeÃ¡llÃ­tÃ¡sok",
            simplifiers: "EgyszerÅ±sÃ­tÅk",
            singleActions: "Egyszeri mÅ±veletek",
            smartPurgeRules: "Intelligens tisztÃ­tÃ¡si szabÃ¡lyok",
            softwareOptions: "SzoftverbeÃ¡llÃ­tÃ¡sok",
            spectroSettings: "SpeckrofotomÃ©ter beÃ¡llÃ­tÃ¡sa",
            statistics: "StatisztikÃ¡k",
            switchToFrontdesk: "ElsÅdleges pultra vÃ¡ltÃ¡s",
            switchToFullRedlike: "VÃ¡ltok %{name} -ra/re",
            switchToLight: "VÃ¡ltok %{name} -ra/re",
            switchToMachine: "GÃ©pre vÃ¡ltÃ¡s",
            tabs: "Tabs & Pop-Ups",
            testBarcodes: "Teszt vonalkÃ³dok",
            updateOptions: "FrissÃ­tÃ©si beÃ¡llÃ­tÃ¡sok",
            userManagemenet: "FelhasznÃ¡lÃ³ kezelÃ©se",
            visibleUnits: "LÃ¡thatÃ³ egysÃ©gek"
        },
        navBar: {
            barcode: "VonalkÃ³d",
            help: "SÃºgÃ³",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "Nincsenek Ãºj Ã©rtesÃ­tÃ©sek"
        },
        tabBar: {
            closeActive: "BezÃ¡rÃ¡s folyamatban",
            closeAll: "Ãsszes bezÃ¡rÃ¡sa",
            closeAllExceptActive: "ZÃ¡rja be az Ã¶sszeset, kivÃ©ve az aktÃ­vakat",
            customFormula: "Custom Formula",
            dispensingHistory: "SzÃ­nezÃ©si elÅzmÃ©nyek",
            favorites: "Kedvencek",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "HozzÃ¡rendelÃ©s",
        assignment: "Feladat",
        createdDate: "LÃ©trehozÃ¡s dÃ¡tuma",
        finishDispensing: "SzÃ­nezÃ©s vÃ©ge",
        foundInOrders: "KeresÃ©s megrendelÃ©sek kÃ¶zt",
        inactiveDatabase: "Recept inaktÃ­v vagy ismeretlen adatbÃ¡zisbÃ³l %{0}",
        inactiveUnknownDatabase: "A recept inaktÃ­v vagy ismeretlen adatbÃ¡zisbÃ³l szÃ¡rmazik",
        newOrderReceived: "Ãj megrendelÃ©se Ã©rkezett!",
        noOrderSelected: "Nincs megrendelÅ kivÃ¡lasztva",
        release: "TÃ¶rlÃ©s",
        status: {
            accepted: "elfogadott",
            canceled: "mÃ³dosÃ­tott",
            created: "lÃ©trehozott",
            done: "kÃ©sz",
            partlyDone: "rÃ©szben kÃ©sz",
            preparing: "elÅkÃ©szÃ­t",
            unknown: "ismeretlen"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "CÃ­m",
        contactName: "Kontakt neve",
        contactPerson: "Kontakt szemÃ©ly",
        identification: "AzonosÃ­tÃ¡s",
        machineInformation: "SzÃ­nezÅgÃ©p informÃ¡ciÃ³",
        pos: "EladÃ¡s helye",
        secondAddress: "MÃ¡sodik cÃ­m",
        shopIdentification: "Ãzlet azonosÃ­tÃ¡s",
        shopName: "Ãzlet neve",
        url: "Url kÃ³d",
        zipCode: "IrÃ¡nyÃ­tÃ³szÃ¡m"
    },
    priceTypeList: {
        priceBasePurchase: "BÃ¡zis beszerzÃ©si Ã¡ra",
        priceBaseSell: "BÃ¡zis eladÃ¡si Ã¡ra",
        priceBaseSellFull: "Teljes Ã¡ron eladni az alapot",
        priceCntPurchase: "SzÃ­nezÅpaszta beszerzÃ©si Ã¡ra",
        priceCntPurchaseByColorantName: "SzÃ­nezÅpaszta %{0} beszerzÃ©si Ã¡ra",
        priceCntPurchaseByName: "SzÃ­nezÅpaszta beszerzÃ©si Ã¡ra nÃ©v szerint",
        priceCntSell: "SzÃ­nezÅpaszta eladÃ¡sisi Ã¡ra",
        priceCntSellByColorantName: "SzÃ­nezÅpaszta %{0} eladÃ¡si Ã¡ra",
        priceCntSellByName: "SzÃ­nezÅpaszta eladÃ¡sisi Ã¡ra nÃ©v szerint",
        priceCntSellFull: "Teljes Ã¡ron eladni a szÃ­nezÅanyagokat",
        priceCntSellFullByColorantName: "Teljes Ã¡ron eladni %{0} szÃ­nezÅanyagot",
        priceCntSellFullByName: "Teljes Ã¡ron eladni a szÃ­nezÃ©keket nÃ©v szerint",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "ÃrrÃ©s minden kiszerelÃ©sre",
        priceMarginPerPkg: "ÃrrÃ©s egy kiszerelÃ©sre",
        priceSellPriceAll: "EladÃ¡si Ã¡r minden kiszerelÃ©sre",
        priceSellPricePerKg: "EladÃ¡si Ã¡r kiligrammonkÃ©nt",
        priceSellPricePerL: "EladÃ¡si Ã¡r literenkÃ©nt",
        priceSellPricePerPkg: "EladÃ¡si Ã¡r egy kiszerelÃ©sre",
        priceSurchargeAll: "Ãsszes keverÃ©si dÃ­j",
        priceSurchargePerPkg: "KeverÃ©si dÃ­j",
        priceTintPurchaseAll: "SzÃ­nfelÃ¡r az Ã¶sszes termÃ©kre",
        priceTintPurchasePerPkg: "SzÃ­nfelÃ¡r egy kiszerelÃ©sre",
        priceTintSellFullAll: "A szÃ­nezÃ©s teljes Ã¡rat ad el minden csomagra",
        priceTintSellFullAllPerPackage: "SzÃ­nezÃ©s csomagonkÃ©nt teljes Ã¡ron eladni",
        priceTotalPurchaseAll: "Teljes Ã¡r minden kiszerelÃ©sre",
        priceTotalPurchasePerKg: "Teljes Ã¡r kilogrammonkÃ©nt",
        priceTotalPurchasePerL: "Teljes Ã¡r literenkÃ©nt",
        priceTotalPurchasePerPkg: "Teljes Ã¡r egy kiszerelÃ©sre",
        priceTotalSellFullAll: "Teljes eladÃ¡si Ã¡r az Ã¶sszes csomag teljes Ã¡rÃ¡Ã©rt",
        priceTotalSellFullPerKg: "Teljes eladÃ¡si Ã¡r kilogrammonkÃ©nt",
        priceTotalSellFullPerLiter: "Teljes eladÃ¡si Ã¡r literenkÃ©nt",
        priceTotalSellFullPerPackage: "Teljes eladÃ¡si Ã¡r csomagonkÃ©nt Ã¶sszesen"
    },
    pricing: {
        allBases: "Minden bÃ¡zis",
        allPackages: "Minden kiszerelÃ©s",
        backup: "Backup",
        basesOfProduct: "A %{productName} alapjai",
        colorantPricing: "SzÃ­nezÅpaszta Ã¡ra",
        export: "Kivitel",
        import: "Bevitel",
        packagePricing: "KiszerelÃ©s Ã¡ra",
        packageSurcharge: "KiszerelÃ©s felÃ¡ra",
        packages: "KiszerelÃ©s",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Ãrcsoport Ã¡ra literenkÃ©nt",
        priceGroups: "Ãrcsoportok",
        pricePerLiter: "Ãr literenkÃ©nt",
        productPricing: "TermÃ©k Ã¡ra",
        purchasePrice: "VÃ©telÃ¡r",
        purchasePricePerLiter: "VÃ©telÃ¡r literenkÃ©nt",
        sellPrice: "EladÃ¡si Ã¡r",
        surcharge: "FelÃ¡r"
    },
    print: {
        adminRightsRequired:
            "A sablon szerkesztÃ©sÃ©hez vagy Ãºj sablon lÃ©trehozÃ¡sÃ¡hoz rendszergazdai jogokra van szÃ¼ksÃ©g.",
        allowAutomaticPrint: "Automatikus nyomtatÃ¡s engedÃ©lyezÃ©se",
        allowPrintAfterDispensing: "NyomtatÃ¡s engedÃ©lyezÃ©se szÃ­nkeverÃ©s utÃ¡n",
        allowPrintBeforeDispensing: "NyomtatÃ¡s engedÃ©lyezÃ©se szÃ­nkeverÃ©s elÅtt",
        automaticPrint: "Automatikus nyomtatÃ¡s  ",
        choosePrinter: "NyomtatÃ³",
        chooseSettings: "BeÃ¡llÃ­tÃ¡sok szerkesztÃ©se",
        chooseTemplate: "Sablon",
        copies: "MÃ¡solatok",
        createTemplate: "Sablon lÃ©trehozÃ¡sa",
        createTemplateHint:
            "Hozzon lÃ©tre egy Ãºj sablont a semmibÅl. Mentse a sablonok mappÃ¡ba, Ã©s indÃ­tsa Ãºjra az RCC-t.",
        defaultPrinter: "NyomtatÃ³",
        defaultSettings: "Default settings",
        defaultTemplate: "AlapÃ©rtelmezett sablon",
        editTemplate: "Sablon szerkesztÃ©se",
        editTemplateHint: "%{name} szerkesztÃ©se. A mÃ³dosÃ­tÃ¡sok az RCC ÃºjraindÃ­tÃ¡sa utÃ¡n lesznek lÃ¡thatÃ³ak.",
        noEditTemplate: "Nincs szerkeszthetÅ sablon",
        noPrinterSelected: "Nincs nyomtatÃ³ kivÃ¡lasztva",
        noPrintersAvailable: "NyomtatÃ³ nem elÃ©rhetÅ",
        noTemplateSelected: "Nincs kivÃ¡lasztott sablon",
        noTemplatesAvailable: "Sablon nem Ã¡ll rendelkezÃ©sre",
        numberOfCopies: "MÃ¡solatok szÃ¡ma",
        openTemplateEditor: "SablonszerkesztÅ megnyitÃ¡sa",
        printAfterDispensing: "NyomtatÃ¡s szÃ­nkeverÃ©s utÃ¡n",
        printAsImage: "NyomtatÃ¡s kÃ©pkÃ©nt",
        printBeforeDispensing: "NyomtatÃ¡s szÃ­nkeverÃ©s elÅtt",
        printOnRequest: "NyomtatÃ¡s folyamatban",
        printOptions: "NyomtatÃ¡si lehetÅsÃ©gek",
        printPagesAfterDispensing: "PÃ©ldÃ¡nyszÃ¡m keverÃ©s utÃ¡n",
        printPagesBeforeDispensing: "PÃ©ldÃ¡nyszÃ¡m keverÃ©s elÅtt",
        printPreview: "NyomtatÃ¡si elÅnÃ©zet",
        printSettings: "NyomtatÃ³ beÃ¡llÃ­tÃ¡sok",
        printTaskLinkVariable: "VÃ¡ltozÃ³ra valÃ³ hivatkozÃ¡s",
        printVariable: "NyomtatÃ¡s vÃ¡ltozÃ³",
        printerName: "NyomtatÃ³ neve",
        printerOptions: "NyomtatÃ³ opciÃ³k",
        printerSettings: "NyomtatÃ³ beÃ¡llÃ­tÃ¡sok",
        quickTintTemplate: "Gyors szÃ­nezÃ©s sablon",
        setDefaultPrinter: "AlapÃ©rtelmezett nyomtatÃ³ beÃ¡llÃ­tÃ¡sa",
        setDefaultTemplate: "AlapÃ©rtelmezett sablon beÃ¡llÃ­tÃ¡sa",
        setQuickTintTemplate: "Gyors szÃ­nezÃ©s sablon beÃ¡llÃ­tÃ¡sa",
        showPreviewDialogBeforePrint: "ElÅnÃ©zeti pÃ¡rbeszÃ©dpanel megjelenÃ­tÃ©se nyomtatÃ¡s elÅtt",
        template: "Sablon",
        templateName: "Sablon neve",
        templateSettings: "Template Settings"
    },
    printTemplate: {
        baseCode: "BÃ¡zis kÃ³dja",
        baseName: "BÃ¡zis neve",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "VÃ¡ros",
        customerEmail: "email",
        customerName: "nÃ©v",
        customerPhone: "telefonszÃ¡m",
        customerStreet: "utca",
        customerZipCode: "irÃ¡nyÃ­tÃ³ szÃ¡m",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BSF kategÃ³riÃ¡ja",
        orderQrCode: "QR kÃ³d",
        packageOrderCount: "CsomagmegrendelÃ©sek szÃ¡ma",
        posAddress: "Ãzlet CÃ­me",
        posAddressSecond: "POS address 3",
        posCity: "Ãzlet VÃ¡rosa",
        posContact: "Ãzlet kapcsolattartÃ³ja",
        posEmail: "Ãzlet email cÃ­me",
        posPhone: "Ãzlet telefonszÃ¡ma",
        posUrl: "Ãzlet Urkl cÃ­me",
        posZipCode: "Ãzlet irÃ¡nyÃ­tÃ³szÃ¡ma",
        priceBasePurchaseWithTax: "BÃ¡zis beszerzÃ©si Ã¡ra +ÃFA",
        priceBaseSellWithTax: "BÃ¡zis eladÃ¡si Ã¡ra + ÃFA",
        priceCntPurchaseWithTax: "SzÃ­nezÅpaszta beszerzÃ©si Ã¡ra + ÃFA",
        priceCntTotalSellWithTax: "SzÃ­nezÅpaszta eladÃ¡si Ã¡ra + ÃFA",
        priceMarginAllWithTax: "ÃrrÃ©s az Ã¶sszes kiszerelÃ©sre + ÃFA",
        priceMarginPerPkgWithTax: "Egy kiszerelÃ©s Ã¡rrÃ©se + ÃFA",
        priceSellPriceAllWithTax: "EladÃ¡si Ã¡r minden kiszerelÃ©sre + ÃFA",
        priceSellPricePerKgWithTax: "KilogrammonkÃ©nti eladÃ¡si Ã¡r + ÃFA",
        priceSellPricePerLWithTax: "LiterenkÃ©nti eladÃ¡si Ã¡r + ÃFA",
        priceSellPricePerPkgWithTax: "Egy kiszerelÃ©s eladÃ¡si Ã¡ra + ÃFA",
        priceSurchargeAllWithTax: "Ãsszes keverÃ©si dÃ­j + ÃFA",
        priceSurchargePerPkgWithTax: "KeverÃ©si dÃ­j + ÃFA",
        priceTintPurchaseAllWithTax: "SzÃ­nfelÃ¡r az Ã¶sszes termÃ©kre + ÃFA",
        priceTintPurchasePerPkgWithTax: "SzÃ­nfelÃ¡r egy kiszerelÃ©sre + ÃFA",
        priceTotalPurchaseAllWithTax: "Teljes Ã¡r minden kiszerelÃ©sre + ÃFA",
        priceTotalPurchasePerKgWithTax: "Teljes Ã¡r kilogrammonkÃ©nt + ÃFA",
        priceTotalPurchasePerLWithTax: "Teljes Ã¡r literenkÃ©nt + ÃFA",
        priceTotalPurchasePerPkgWithTax: "Teljes Ã¡r egy kiszerelÃ©sre +ÃFA",
        productAltName: "TermÃ©k",
        recipeInline: "Recept"
    },
    products: {
        bases: "BÃ¡zisok",
        numberOfProducts: "TermÃ©kek szÃ¡ma",
        packagesFor: "BÃ¡zis vÃ¡lasztÃ¡s",
        sizeOfPackage: "KiszerelÃ©s mÃ©rete"
    },
    purgeModal: {
        purgeAll: "Ãsszes tisztÃ­tÃ¡s",
        purgeAllChannels: "Minden csatorna tisztÃ­tÃ¡sa",
        purgeVolume: "TisztÃ­tÃ¡s mÃ©rtÃ©ke",
        startPurge: "TisztÃ­tÃ¡s indÃ­tÃ¡sa"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "SzÃ­nezÃ©s folymatban",
        dispensingIsNotAvailable: "SzÃ­nezÃ©s nem lehetsÃ©ges",
        machineNotConnected: "GÃ©p nem kapcsolÃ³dik",
        noColorantsSelected: "SzÃ­nezÅpaszta nincs kivÃ¡lasztva",
        noPrinterAvailable: "A nyomtatÃ¡s nem vÃ©gezhetÅ el, mivel nem Ã¡ll rendelkezÃ©sre nyomtatÃ³.",
        noTemplateAvailable: "A nyomtatÃ¡s nem vÃ©gezhetÅ el, mivel nem Ã¡ll rendelkezÃ©sre sablon.",
        overMaxCanisterSize: "Egy vagy tÃ¶bb szÃ­nezÅpaszta adagolÃ¡sa nem lehetsÃ©ges"
    },
    quickTintSettings: {
        alphabetically: "ABC sorrendben",
        byCanister: "KaniszterenkÃ©nt",
        closeAfterDispensing: "BezÃ¡rÃ¡s szÃ­nezÃ©s utÃ¡n",
        closeBeforeDispensing: "BezÃ¡rÃ¡s szÃ­nezÃ©s elÅtt",
        quickTintSettings: "Gyors szÃ­nezÃ©s beÃ¡llÃ­tÃ¡s",
        sorting: "VÃ¡logatÃ¡s",
        windowClosingRules: "Ablak bezÃ¡rÃ¡sÃ¡nak szabÃ¡lyai"
    },
    rccButtons: {
        abort: "megszakÃ­tÃ¡s",
        all: "Ã¶sszes",
        cancel: "mÃ©gse",
        continue: "folytatÃ¡s",
        help: "SÃºgÃ³",
        ignore: "figyelmen kÃ­vÃ¼l hagy",
        no: "nem",
        noToAll: "nem az Ã¶sszes",
        ok: "rendben",
        postpone: "elhalaszt",
        resume: "folytatÃ¡s",
        retry: "megismÃ©tel",
        skip: "Ã¡tugrÃ¡s",
        yes: "igen",
        yesToAll: "igen az Ã¶sszes"
    },
    rccDialog: {
        98: "KÃ©rem ellenÅrizze a bÃ¡zist %{0} a vonalkÃ³ddal",
        99: "Helyezze be a bÃ¡zist %{0}  Ã©s nyomja meg az OK gombot",
        100: "SzÃ­nezÅgÃ©p hiba. ÃjraindÃ­tja?",
        101: "SzÃ­nezÅgÃ©p hiba Ã¡llapotban, folytatÃ¡s nem lehetsÃ©ges",
        102: "ÃjtaindÃ­tÃ¡s sikertelen, folytatÃ¡s nem lehetsÃ©ges",
        103: "A recept Ã©rvÃ©nytelen szÃ­nezÅpasztÃ¡t tartalmaz: %{0}",
        104: "A recept Ã©rvÃ©nytelen szÃ­nezÅpasztÃ¡kat tartalmaz: %{0}",
        105: "SzÃ­nezÅpaszta a figyelmeztetÅ szint alatt: %{0}",
        106: "SzÃ­nezÅpaszta a figyelmeztetÅ  szint alatt: %{0}",
        107: "SzÃ­nezÅpaszta a kritikus szint alatt: %{0}",
        108: "SzÃ­nezÅpasztÃ¡k a kritikus  szint alatt: %{0}",
        109: "Helyezze be a vÃ¶drÃ¶t az adagolÃ¡shoz",
        110: "Helyezze be a vÃ¶drÃ¶t: %{0} a recept szÃ­nezÃ©sÃ©hez: %{1}",
        111: "Vegye ki  a vÃ¶drÃ¶t",
        112: "Kanna lyukasztÃ¡s?",
        113: "ÃjraindÃ­tÃ¡s hiba miatt kÃ©rem vÃ¡rjon",
        114: "Polc mozgÃ¡sban, kÃ©rem vÃ¡rjon",
        115: "Kanna lyukasztÃ¡sa. KÃ©rem, vÃ¡rjon",
        116: "Recept adagolÃ¡s, %{0}, kÃ©rem vÃ¡rjon | KiszerelÃ©s: %{1} %{2} | TermÃ©k: %{3} | BÃ¡zis: %{4} | VÃ¶dÃ¶r mÃ©ret: %{5}",
        117: "Recept adagolÃ¡s %{0}, kÃ©rem vÃ¡rjon | KiszerelÃ©s: %{1} %{2} | TermÃ©k: %{3} | BÃ¡zis: %{4} | VÃ¶dÃ¶r mÃ©ret: %{5}",
        118: "AdagolÃ¡s, kÃ©rem vÃ¡rjon |KiszerelÃ©s: %{0} -bÃ³l %{1}",
        119: "AdagolÃ¡s, kÃ©rem vÃ¡rjon |KiszerelÃ©s: %{0} -bÃ³l %{1}",
        120: "AdagolÃ¡s megszakÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        121: "VÃ¶dÃ¶r vonalkÃ³djÃ¡nak jÃ³vÃ¡hagyÃ¡sa",
        122: "BÃ¡zis vÃ¶dÃ¶r vonalkÃ³djÃ¡nak jÃ³vÃ¡hagyÃ¡sa | TermÃ©k: %{0} | BÃ¡zis: %{1} | VÃ¶dÃ¶r kiszerelÃ©s: %{2}",
        123: "AdagolÃ¡s megszakÃ­tva. Folytatja az adagolÃ¡st?",
        124: "AdagolÃ¡si hiba. %{0} : %{1}. Folytatja az adagolÃ¡st?",
        125: "EllenÅrizze hogy az elÅbb hasznÃ¡lt vÃ¶dÃ¶r a helyÃ©n van-e.",
        126: "EllenÅrizze, hogy Ãºj vÃ¶dÃ¶r Ã¡lljon rendelkezÃ©sre. A szÃ­nezÃ©s alaphelyzetbÅl indul.",
        127: "%{0} SzÃ­nezÅpaszta a minimÃ¡lis szint alatt. Folytaja a figyelmeztetÃ©s ellenÃ©re?",
        128: "%{0} SzÃ­nezÅpaszta a minimÃ¡lis szint alatt. Folytaja a figyelmeztetÃ©s ellenÃ©re?",
        129: "A kivÃ¡lasztott recept a tÃºladagolÃ¡si szabÃ¡lyba Ã¼tkÃ¶zik. A szÃ­nezÅpaszta Ã¶sszes megadott mennyisÃ©ge: %{0} %{1}, a maximÃ¡lisan megengedett mennyisÃ©gÅ± szÃ­nezÅpasztaok: %{2} %{3}. Folytatni szeretnÃ© a szÃ­nezÃ©st a figyelmeztetÃ©s ellenÃ©re?",
        130: "SzÃ­nezÅgÃ©p hiba Ã¡llapotban, ÃºjraindÃ­tja?",
        131: "SzÃ­nezÅgÃ©p hiba Ã¡llapotban, folytatÃ¡s nem lehetsÃ©ges",
        132: "ÃjraindÃ­tÃ¡s sikertelen, folytatÃ¡s nem lehetsÃ©ges",
        133: "TisztÃ­tÃ¡si recept Ã¼res, folytatÃ¡s nem lehetsÃ©ges",
        134: "Az tisztÃ­tÃ¡si recept olyan elemeket tartalmaz, amelyeket nem lehet adagolni, ennek ellenÃ©re is folytatni szeretnÃ©?",
        135: "Helyezze be a vÃ¶drÃ¶t a tisztÃ­tÃ¡shoz",
        136: "Vegye ki a vÃ¶drÃ¶t a tisztÃ­tÃ¡shoz",
        137: "ÃjraindÃ­tÃ¡si hibÃ¡k, kÃ©rem vÃ¡rjon",
        138: "Polc mozgÃ¡sban, kÃ©rem vÃ¡rjon",
        139: "TisztÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        140: "TisztÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        141: "TisztÃ­tÃ¡s megszakÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        142: "VÃ¶dÃ¶r hiba, ellenÅrizze, hogy a vÃ¶dÃ¶r a helyÃ©n van-e.",
        143: "A tisztÃ­tÃ³ folyamat olyan elemeket tartalmaz,amelyek nem alkalmasak a tisztÃ­tÃ¡sra. Folytatja?",
        144: "Helyezze be a vÃ¶drÃ¶t a tisztÃ­tÃ¡shoz",
        145: "ElÅkÃ©szÃ­tÃ©s, kÃ©rem vÃ¡rjon",
        146: "BefejezÃ©s, kÃ©rem vÃ¡rjon",
        150: "TisztÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        151: "TisztÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        152: "TisztitÃ¡s megszakÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        160: "VisszatÃ¶ltÃ©s, kÃ©rem vÃ¡rjon",
        161: "VisszatÃ¶ltÃ©s, kÃ©rem vÃ¡rjon",
        162: "VisszatÃ¶ltÃ©s megszakÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        170: "KeverÃ©s, kÃ©rem vÃ¡rjon",
        171: "KeverÃ©s, kÃ©rem vÃ¡rjon",
        172: "KeverÃ©s megszakÃ­tÃ¡sa, kÃ©rem vÃ¡rjon",
        180: "Kapcsolat indÃ­tÃ¡sa a szÃ­nezÅgÃ©ppel, kÃ©rem vÃ¡rjon",
        181: "Nem sikerÃ¼lt a kapcsolÃ³dÃ¡s a szÃ­nezÅgÃ©ppel %{0}: %{1}",
        182: "Nem sikerÃ¼lt a kapcsolÃ³dÃ¡s a szÃ­nezÅgÃ©ppel",
        183: "Az adagolÃ³bÃ³l hiÃ¡nyzik az adatbÃ¡zisban definiÃ¡lt szÃ­nezÅanyag: %{0}",
        184: "Az adagolÃ³bÃ³l hiÃ¡nyoznak az adatbÃ¡zisban definiÃ¡lt szÃ­nezÃ©kek: %{0}",
        185: "Kapcsolat bezÃ¡rÃ¡sa a szÃ­nezÅgÃ©ppel, kÃ©rem vÃ¡rjon",
        190: "SzervÃ­z ablak bezÃ¡rÃ¡sa a folytatÃ¡shoz",
        200: "ÃjraindÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        201: "Gyors ÃºjraindÃ­tÃ¡s, kÃ©rem vÃ¡rjon",
        202: "KapcsolÃ³dÃ¡s, kÃ©rem vÃ¡rjon",
        203: "ÃjraindÃ­tÃ¡s hiba, kÃ©rem vÃ¡rjon",
        205: "FedÅ automata nyitÃ¡sa, kÃ©rem vÃ¡rjon",
        206: "FedÅ automatikus zÃ¡rÃ¡sa, kÃ©rem vÃ¡rjon",
        207: "FedÅ automatikus mozgÃ¡sa, kÃ©rem vÃ¡rjon",
        210: "LyukasztÃ¡s, kÃ©rem vÃ¡rjon",
        211: "CsatlakozÃ¡s, kÃ©rem vÃ¡rjon",
        215: "Polc felfelÃ© mozog, kÃ©rem vÃ¡rjon",
        216: "Polc lefelÃ© mozog, kÃ©rem vÃ¡rjon",
        217: "Polc mozog, kÃ©rem vÃ¡rjon",
        220: "%{0} TÃ¡lca utÃ¡ntÃ¶ltÃ©si pozÃ­ciÃ³ba fordul, kÃ©rem vÃ¡rjon",
        221: "TÃ¡lca alaphelyzeti pozÃ­ciÃ³ba fordul, kÃ©rem vÃ¡rjon",
        222: "TÃ¡lca fordul, kÃ©rem vÃ¡rjon",
        230: "SzÃ­nezÅgÃ©p dolgozik, kÃ©rem vÃ¡rjon",
        240: "Kaniszter utÃ¡ntÃ¶ltÃ©s %{0}",
        241: "Kaniszter utÃ¡ntÃ¶ltÃ©s %{0}",
        242: "MozgÃ³ kaniszter: %{0} (%{1}) utÃ¡ntÃ¶ltÃ©s pozÃ­ciÃ³ba",
        243: "KÃ©rjÃ¼k, tÃ¶ltse Ãºjra a %{0} palackot a vonalkÃ³d hasznÃ¡latÃ¡val.",
        244: "KÃ©rjÃ¼k, tÃ¶ltse Ãºjra a tartÃ¡ly %{0} vonalkÃ³dot hasznÃ¡lva.",
        250: "TÃ¡volÃ­tsa el a kefÃ©s tisztÃ­tÃ³ tartÃ¡lyt, tisztÃ­tsa ki Ã©s tÃ¶ltse fel vÃ­zzel",
        251: "Tegye vissza a kefÃ©s tisztÃ­tÃ³ tartÃ¡lyt",
        254: "FedÅ nyitÃ¡sa",
        255: "TisztÃ­tsa meg a fedÅt az instrukciÃ³k szerint",
        256: "ErÅsÃ­tse meg, ha a tisztÃ­tÃ¡st befejezte Ã©s a fedÅt visszahelyezte",
        257: "FedÅ visszazÃ¡rva",
        260: "TÃ¡volÃ­tsa el a gombot Ã©s tisztÃ­tsa meg",
        261: "Tegye vissza a gombot",
        265: "TisztÃ­tsa meg a gÃ©pet a kiÃ¶mlÃ¶tt szÃ­nezÅpasztÃ¡tÃ³l vagy egyÃ©b folydÃ©ktÃ³l",
        266: "Rendben",
        270: "TÃ¶ltse fel a pÃ¡rÃ¡sÃ­tÃ³ vÃ­ztartÃ¡lyt Ã©s OK, ha kÃ©sz",
        271: "TÃ¶ltse fel a pÃ¡rÃ¡sÃ­tÃ³ vÃ­ztartÃ¡lyt Ã©s OK, ha kÃ©sz",
        272: "A vÃ­zszint alacsony, ellenÅrizze Ãºjra",
        273: "A vÃ­zszint alacsony, ellenÅrizze Ãºjra",
        274: "EllenÅrizze a vÃ­ztartÃ¡lyban a vÃ­zszintet",
        275: "KÃ©rem, vÃ¡rjon",
        280: "IndÃ­tsa Ãºjra a szÃ¡mÃ­tÃ³gÃ©pet",
        281: "A szÃ¡mÃ­tÃ³gÃ©p leÃ¡llÃ­tÃ¡sa",
        300: "EllenÅrizze, hogy jÃ³l helyezte-e be a vÃ¶drÃ¶t",
        301: "ElÅkÃ©szÃ­tÃ©s, kÃ©rem vÃ¡rjon",
        302: "BefejezÃ©s, kÃ©rem vÃ¡rjon",
        303: "A recept nem szÃ­nezhetÅ, mivel annyi szÃ­nezÅpasztÃ¡t tartalmaz %{0}, amely meghaladja a kaniszter szÃ¡mÃ¡ra meghatÃ¡rozott maximÃ¡lis adagolÃ¡si mennyisÃ©get",
        304: "A recept nem szÃ­nezhetÅ, mivel annyi szÃ­nezÅpasztÃ¡t tartalmaz %{0}, amely meghaladja a kaniszter szÃ¡mÃ¡ra meghatÃ¡rozott maximÃ¡lis adagolÃ¡si mennyisÃ©get",
        305: "A SzÃ­nezÅpaszta %{0} nem adhatÃ³ ki egyszerre, meg akarja osztani a receptet?",
        306: "A SzÃ­nezÅpaszta %{0} nem adhatÃ³ ki egyszerre, meg akarja osztani a receptet?",
        307: "A SzÃ­nezÅpaszta %{0} nem kerÃ¼l adagolÃ³ba, szeretnÃ© folytatni, Ã©s manuÃ¡lisan hozzÃ¡adni?",
        308: "A SzÃ­nezÅpaszta %{0} nem lesz kiadagolva. SzeretnÃ© folytatni, Ã©s manuÃ¡lisan hozzÃ¡adni?",
        309: "A kivÃ¡lasztott recept Ã¼res, hasznÃ¡lja a bÃ¡zis vÃ¶drÃ¶t ahogy van.",
        310: "Nincs szÃ­nezhetÅ vÃ¶dÃ¶r a szÃ­nezÃ©shez. KÃ©szÃ­tsen elÅ bÃ¡zist a kÃ©zi szÃ­nezÅpaszta adagolÃ¡sÃ¡hoz",
        311: "Vegye el a bÃ¡zis vÃ¶drÃ¶t Ã©s kÃ©szÃ­tse elÅ a kÃ©zi adagolÃ¡shoz",
        312: "Adjon hozzÃ¡ manuÃ¡lisan a (z) %{0} %{1} szÃ­nezÅpasztÃ¡t: %{2}, ErÅsÃ­tse meg ha kÃ©sz. ",
        313: "SzÃ­nezÃ©s manuÃ¡lisan",
        314: "A kivÃ¡lasztott formula megszegi a tÃºltÃ¶ltÃ©si szabÃ¡lyt, a szÃ­nezÅanyagok teljes mennyisÃ©ge: %{0} %{1}, a szÃ­nezÅanyagok megengedett maximÃ¡lis mennyisÃ©ge: %{2} %{3}. SzeretnÃ© folytatni a figyelmeztetÃ©s ellenÃ©re?",
        315: "Szkennelje be vagy Ã­rja be az alapdoboz UFI-kÃ³djÃ¡t",
        316: "Szkennelje be vagy Ã­rja be az alapdoboz UFI-kÃ³djÃ¡t|TermÃ©k: %{0}|BÃ¡zis: %{1}|Doboz mÃ©rete: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatikus tisztÃ­tÃ¡s indul",
        401: "Automatikus tisztÃ­tÃ¡s indul",
        405: "A kefetartÃ¡ly karbantartÃ¡sa szÃ¼ksÃ©ges",
        406: "A kefetartÃ¡ly karbantartÃ¡sa szÃ¼ksÃ©ges",
        410: "Az automatikus kupak karbantartÃ¡s indÃ­tÃ¡sa",
        411: "Az automatikus kupak karbantartÃ¡s indÃ­tÃ¡sa",
        415: "A kapcsolÃ³gombot meg kell tisztÃ­tani",
        416: "A kapcsolÃ³gombot meg kell tisztÃ­tani",
        420: "TisztÃ­tsa meg a szÃ­nezÅ gÃ©pet",
        421: "TisztÃ­tsa meg a szÃ­nezÅ gÃ©pet",
        425: "A kaniszterek utÃ¡ntÃ¶ltÃ©se indul",
        426: "A kaniszterek utÃ¡ntÃ¶ltÃ©se indul",
        430: "A szÃ¡mÃ­tÃ³gÃ©p ÃºjraindÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        431: "A szÃ¡mÃ­tÃ³gÃ©p ÃºjraindÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        435: "A szÃ¡mÃ­tÃ³gÃ©p leÃ¡llÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        436: "A szÃ¡mÃ­tÃ³gÃ©p leÃ¡llÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        440: "A szÃ­nezÅgÃ©p tisztÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        441: "A szÃ­nezÅgÃ©p tisztÃ­tÃ¡sÃ¡nak Ã¼temezÃ©se",
        445: "A szÃ­nezÅgÃ©p visszatÃ¶ltÃ©sÃ©nek Ã¼temezÃ©se",
        446: "A szÃ­nezÅgÃ©p visszatÃ¶ltÃ©sÃ©nek Ã¼temezÃ©se",
        450: "A szÃ­nezÅgÃ©p kaniszterei keverÃ©sÃ©nek Ã¼temezÃ©se",
        451: "A szÃ­nezÅgÃ©p kaniszterei keverÃ©sÃ©nek Ã¼temezÃ©se",
        990: "AdagolÃ¡si hiba %{0} : %{1}. MegismÃ©tli a feladatot?",
        991: "BelsÅ hiba tÃ¶rtÃ©nt %{0}",
        200000001: "Helyezze be a vÃ¶drÃ¶t az adagolÃ¡shoz",
        200000002: "Vegye ki a vÃ¶drÃ¶t",
        200000003: "A mennyisÃ©g a minimum adagolÃ¡si mennyisÃ©g '%{0}' alatt van, ennek ellenÃ©re is folytatja?",
        200000004: "UtÃ¡ntÃ¶ltÃ©s '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "AdatbÃ¡zis elÃ©rÃ©si Ãºtja",
        dispenser: "SzÃ­nezÅgÃ©p",
        dispenserConfigurationFile: "Dispenser config file",
        driverPath: "Driver elÃ©rÃ©si Ãºtvonal",
        extensionPath: "BÅvÃ­tmÃ©ny elÃ©rÃ©si Ãºtvonal",
        folder: "Mappa",
        formulaPath: "Recept elÃ©rÃ©si Ãºtvonal",
        host: "Rendszergazda",
        iddPath: "IDD konfigurÃ¡ciÃ³s fÃ¡jl",
        italtintoPath: "Italtinto konfigurÃ¡ciÃ³s elÃ©rÃ©si Ãºtvonal",
        lldPath: "LLD elÃ©rÃ©si Ãºtvonal",
        machineType: "GÃ©p tÃ­pus",
        noMachineAvailable: "No machine is available",
        protocolVersion: "Protokoll verziÃ³szÃ¡m",
        rccDriverSettings: "MeghajtÃ³ beÃ¡llÃ­tÃ¡sok",
        resultPath: "EredmÃ©ny elÃ©rÃ©si Ãºtja",
        save: "BeÃ¡llÃ­tÃ¡sok mentÃ©se",
        saveSettingsWarning:
            "FigyelmeztetÃ©s! Ennek a beÃ¡llÃ­tÃ¡snak a mÃ³dÃ³sÃ­tÃ¡sa hibÃ¡t okozhat a szÃ­nezÅgÃ©p mÅ±kÃ¶dÃ©sÃ©ben.",
        serviceSwPath: "SzolgÃ¡ltatÃ¡si szoftver elÃ©rÃ©si Ãºtja",
        simulationPath: "SzimulÃ¡ciÃ³ elÃ©rÃ©si Ãºtvonal"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "KÃ©zi szÃ­nezÅpaszta adagolÃ¡st engedÃ©lyez",
        ask: "KÃ©rÃ©s",
        canHandlingOptions: "VÃ¶dÃ¶r kezelÃ©si opciÃ³k",
        checkCanBeforeDispense: "EllenÅrizze a vÃ¶drÃ¶t az adagolÃ¡s elÅtt",
        checkOverfill: "TÃºltÃ¶ltÃ©s ellenÅrzÃ©se",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Csak a szÃ­nezÅanyag-csomagolÃ¡s hitelesÃ­tÃ©se",
        disable: "Nem engedÃ©lyezett",
        dispenseInvalidColorants: "ÃrvÃ©nytelen szÃ­nezÅanyagok adagolÃ¡sa",
        dispensingOptions: "AdagolÃ¡si beÃ¡llÃ­tÃ¡sok",
        enable: "EngedÃ©lyezett",
        enableUserIdentification: "FelhasznÃ¡lÃ³ azonosÃ­tÃ¡sa",
        fullValidation: "Teljes Ã©rvÃ©nyesÃ­tÃ©s",
        machineAccuracyWarning: "FigyelmeztetÃ©s a gÃ©p pontossÃ¡gÃ¡ra",
        machineOptions: "GÃ©p beÃ¡llÃ­tÃ¡sok",
        machineUnit: "AdagolÃ¡si egysÃ©g",
        minimalDispenseAmount: "MinimÃ¡lis adagolÃ¡si egysÃ©g",
        placeCanSensor: "VÃ¶dÃ¶r helyzet Ã©rzÃ©kelÅ",
        placeCanSensorDelay: "VÃ¶dÃ¶r helyzet Ã©rzÃ©kelÅ kÃ©sleltetÃ©s",
        rccMachineSettings: "SzÃ­nezÅgÃ©p beÃ¡llÃ­tÃ¡sok",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "VÃ¶dÃ¶r Ã©rzÃ©kelÅ visszaÃ¡llÃ­tÃ¡s ",
        removeCanSensorDelay: "VÃ¶dÃ¶r Ã©rzÃ©kelÅ visszaÃ¡llÃ­tÃ¡s kÃ©sleltetÃ©s",
        save: "BeÃ¡llÃ­tÃ¡sok mentÃ©se",
        sec: "mp.",
        skipPlaceCanDialog: "UgrÃ¡s a vÃ¶dÃ¶r tÃ¡lca ablakra",
        skipRemoveCanDialog: "UgrÃ¡s a vÃ¶dÃ¶r eltÃ¡volÃ­tÃ¡sa ablakra",
        splitFormula: "FelosztÃ¡si kÃ©plet",
        tmcEnabled: "SzÃ­nkezelÃ©si kÃ¶zpont engedÃ©lyezÃ©s",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "VonalkÃ³d megerÅsÃ­tÃ©s a bÃ¡zis vÃ¶dÃ¶rhÃ¶z",
        validateBarcodeRefill: "UtÃ¡ntÃ¶ltÃ©si vonalkÃ³d Ã©rvÃ©nyesÃ­tÃ©s",
        validateColorantsDuringInit: "ÃrvÃ©nyesÃ­tse a szÃ­nezÅpasztÃ¡kat az inicializÃ¡lÃ¡s sorÃ¡n"
    },
    rccPanel: {
        actionsRunningOnDispenser: "A szÃ­nezÅgÃ©pen fut nÃ©hÃ¡ny feladat",
        addLevel: "TÃ¶ltÃ©si szint beÃ¡llÃ­tÃ¡sa",
        addManually: "KÃ©zi hozzÃ¡adÃ¡s",
        barcodeNotSet: "A %{colorantName} (%{canisterName}) tartÃ¡lyhoz nincs vonalkÃ³d hozzÃ¡rendelve.",
        cancel: "TÃRLÃS",
        dispenseFormula: "Recept szÃ­nezÃ©se",
        dispenserIdle: "A szÃ­nezÅgÃ©p Ã¼zemkÃ©sz",
        dispenserIsBusy: "A szÃ­nezÅgÃ©p dolgozik",
        dispenserIsIdle: "A szÃ­nezÅgÃ©p Ã¼zemkÃ©sz",
        dispenserIsReady: "A szÃ­nezÅgÃ©p kÃ©sz a kÃ¶vetkezÅ feladatra",
        dispensingFormula: "Recept adagolÃ¡s",
        errorCode: "Hiba kÃ³d",
        explanation: "MagyarÃ¡zat",
        fillToMax: "TÃ¶ltÃ©s maximumig",
        finished: "KÃ©sz",
        inProgress: "Folyamatban",
        machineIsReady: "A szÃ­nezÅgÃ©p kÃ©szen Ã¡ll",
        moveToFill: "MozgatÃ¡s a tÃ¶ltÃ©shez",
        noMachineDialog: "A szÃ­nezÅgÃ©p nem kapcsolÃ³dik",
        of: "A  cÃ­mrÅl",
        packageSize: "KÃ©sztermÃ©k mÃ©ret",
        placeBaseCan: "BÃ¡zis vÃ¶dÃ¶r tÃ¡lca",
        pleaseCheckYourMachineConnection: "KÃ©rjÃ¼k, ellenÅrizze a gÃ©p csatlakozÃ¡sÃ¡t",
        pleaseRefill: "TÃ¶ltse fel",
        solution: "MegoldÃ¡s",
        subErrors: "CsatlakozÃ¡si problÃ©mÃ¡k",
        timeToEnd: "A befejezÃ©sig hÃ¡tra lÃ©vÅ idÅ",
        tintingFormula: "SzinezÃ©si recept",
        tintingPleaseWait: "SzÃ­nezÃ©s, kÃ©rem vÃ¡rjon",
        validateBaseCan: "ÃrvÃ©nyesÃ­tse a bÃ¡zis vÃ¶drÃ¶t",
        waiting: "VÃ¡rakozÃ¡s"
    },
    rccSettigns: {
        rccSettigns: "RCC kapcsolÃ³dva",
        rccUrl: "RCC url"
    },
    rccSpectroDialog: {
        100: "Bluetooth kapcsolÃ³dÃ¡s. GyÅzÅdjÃ¶n meg rÃ³la, hogy a Bluetooth engedÃ©lyezve van, Ã©s a kÃ©szÃ¼lÃ©k be van kapcsolva.",
        101: "Az eszkÃ¶z nem talÃ¡lhatÃ³. SzeretnÃ© Ãºjra prÃ³bÃ¡lni?",
        110: "GyÅzÅdjÃ¶n meg rÃ³la, hogy a NanomÃ©rÅ csatlakoztatva van, Ã©s nyomja meg a gombot az inicializÃ¡lÃ¡s megkezdÃ©sÃ©hez",
        111: "NanomÃ©rÅ nem talÃ¡lhatÃ³? SzeretnÃ© Ãºjra prÃ³bÃ¡lni?",
        112: "Nano kapcsolat megszakadt. VÃ¡rjon 10 mÃ¡sodpercet Ã©s csatlakozzon Ãºjra.",
        120: "CsatlakozÃ¡s az eszkÃ¶zhÃ¶z. KÃ©rjÃ¼k, vÃ¡rjon",
        121: "A mÅ±szer nem Ã©szlelhetÅ. Meg akarja prÃ³bÃ¡lni Ãºjra?",
        200: "Helyezze a kÃ©szÃ¼lÃ©ket fekete jelzÃ©sre, Ã©s folytassa vagy nyomja meg a gombot",
        201: "Helyezze a kÃ©szÃ¼lÃ©ket fekete jelzÃ©sre, Ã©s folytassa ",
        202: "Helyezze a kÃ©szÃ¼lÃ©ket fekete jelzÃ©sre, Ã©s nyomja meg a gombot",
        205: "Helyezze a kÃ©szÃ¼lÃ©ket fehÃ©r jelzÃ©sre, Ã©s folytassa vagy nyomja meg a gombot",
        206: "Helyezze a kÃ©szÃ¼lÃ©ket fehÃ©r jelzÃ©sre, Ã©s folytassa ",
        207: "Helyezze a kÃ©szÃ¼lÃ©ket fehÃ©r jelzÃ©sre, Ã©s nyomja meg a gombot",
        210: "Helyezze a kÃ©szÃ¼lÃ©ket diagnosztika jelzÃ©sre, Ã©s folytassa vagy nyomja meg a gombot",
        211: "Helyezze a kÃ©szÃ¼lÃ©ket diagnosztika jelzÃ©sre, Ã©s folytassa ",
        212: "Helyezze a kÃ©szÃ¼lÃ©ket diagnosztika jelzÃ©sre, Ã©s nyomja meg a gombot",
        215: "ZÃ¡rja le a fedelet Ã©s folytassa, vagy nyomja meg a gombot",
        216: "ZÃ¡rja le a fedelet Ã©s folytassa",
        217: "ZÃ¡rja le a fedelet Ã©s nyomja meg a gombot",
        220: "Helyezze a kÃ©szÃ¼lÃ©ket a 0 jelzÃ©sre Ã©s folytassa vagy nyomja meg a gombot",
        221: "Helyezze a kÃ©szÃ¼lÃ©ket 0 jelzÃ©sre Ã©s folytassa ",
        222: "Helyezze a kÃ©szÃ¼lÃ©ket 0 jelzÃ©sre Ã©s nyomja meg a gombot",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "VÃ©gezze el a kalibrÃ¡ciÃ³t az illesztÅprogramban",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "KalibrÃ¡ciÃ³ elÅkÃ©szÃ­tÃ©se, kÃ©rem vÃ¡rjon",
        298: "KalibrÃ¡ciÃ³, kÃ©rem vÃ¡rjon",
        299: "KalibrÃ¡ciÃ³ befejezve, kÃ©rem vÃ¡rjon",
        300: "Helyezze a kÃ©szÃ¼lÃ©ket a mintÃ¡ra Ã©s folytassa vagy nyomja meg a gombot",
        301: "Helyezze a kÃ©szÃ¼lÃ©ket a mintÃ¡ra  jelzÃ©sre Ã©s folytassa ",
        302: "Helyezze a kÃ©szÃ¼lÃ©ket a mintÃ¡ra jelzÃ©sre Ã©s nyomja meg a gombot",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "VÃ©gezze el a mÃ©rÃ©st a driverben",
        397: "BemÃ©rÃ©s elÅkÃ©szÃ­tÃ©se, kÃ©rem vÃ¡rjon",
        398: "BemÃ©rÃ©s, kÃ©rem vÃ¡rjon",
        399: "BemÃ©rÃ©s befejezve, kÃ©rem vÃ¡rjon",
        498: "BemÃ©rÃ©s letÃ¶ltÃ©se, kÃ©rem vÃ¡rjon",
        499: "Ãsszes bemÃ©rÃ©s letÃ¶ltÃ©se, kÃ©rem vÃ¡rjon",
        900: "MÅ±szer hiba %{0} : %{1}. SzeretnÃ© Ãºjra prÃ³bÃ¡lni?",
        901: "BelsÅ hiba tÃ¶rtÃ©nt %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "A szÃ¡mÃ­tÃ³gÃ©pnek Bluetooth-kapcsolattal kell rendelkeznie. A Spectro-t pÃ¡rosÃ­tani kell a szÃ¡mÃ­tÃ³gÃ©ppel. Windows 10 operÃ¡ciÃ³s rendszer 2018-as automatikus frissÃ­tÃ©ssel szÃ¼ksÃ©ges.",
        DatacolorSilent:
            "Csendes Ã¼zemmÃ³d hasznÃ¡lata esetÃ©n a Datacolor ablakok kÃ¶zvetlenÃ¼l a %{name}-ban jelennek meg. Ezekben az ablakokban a spectro paramÃ©terei nem mÃ³dosÃ­thatÃ³k.",
        DatacolorUseDiagnosticTile: "A diagnosztikai csempe hasznÃ¡lata javÃ­tja a mÃ©rÃ©s minÅsÃ©gÃ©t.",
        comPort: "COM-csatlakozÃ³",
        diagnosticTile: "A Datacolor diagnosztikai lapokat hasznÃ¡l",
        measureModes: "MÃ©rÃ©si mÃ³dok",
        measureModesOrder: "MÃ©rÃ©si mÃ³dok sorrendje",
        model: "Modell",
        noSpectroAvailable: "Nem Ã¡ll rendelkezÃ©sre spektrum",
        rccSpectroSettings: "SpektrofotomÃ©ter beÃ¡llÃ­tÃ¡sa",
        save: "BeÃ¡llÃ­tÃ¡sok mentÃ©se",
        silent: "Datacolor szÃ¼netel",
        simulationPath: "szimulÃ¡ciÃ³ elÃ©rÃ©si Ãºtvonal",
        spectroType: "SpektrofotomÃ©ter tÃ­pusa",
        useProfiledValues: "HasznÃ¡ljon elÅre beÃ¡llÃ­tott Ã©rtÃ©keket"
    },
    recirculateChannels: {
        recirculateAllChannels: "VisszatÃ¶ltÃ©s az Ã¶sszes csatornÃ¡bÃ³l",
        recirculateChannels: "VisszatÃ¶ltÃ©s a csatornÃ¡kbÃ³l",
        recirculatingSpeed: "VisszatÃ¶ltÃ©s sebessÃ©ge",
        recirculatingTime: "VisszatÃ¶ltÃ©s ideje",
        startRecirculating: "VisszatÃ¶ltÃ©s sebessÃ©ge"
    },
    redlikeLight: {
        finishPreviousSteps: "KÃ©rem fejezze be az elÅzÅ feladatokat",
        searchBySpectro: "KeresÃ©s spektro Ã¡ltal",
        searchFormula: "Recept keresÃ©se",
        selectBase: "VÃ¡lassza ki az alapot",
        selectColor: "SzÃ­n kivÃ¡lasztÃ¡sa",
        selectCustomer: "VevÅ kivÃ¡lasztÃ¡sa",
        selectFandeck: "SzÃ­nkÃ¡rtya kivÃ¡lasztÃ¡sa",
        selectPackage: "KiszerelÃ©s kivÃ¡lsztÃ¡sa",
        selectProduct: "TermÃ©k kivÃ¡lasztÃ¡sa kÃ¶telezÅ",
        startSelectFandeck: "Kezdje a szÃ­nkÃ¡rtya kivÃ¡lasztÃ¡sÃ¡val",
        startSelectProduct: "Kezdje a termÃ©k kivÃ¡lasztÃ¡sÃ¡val",
        stepByStepProgress: "Haladjon lÃ©pÃ©srÅl lÃ©pÃ©sre",
        typeHereToSearch: "KeresÃ©shez Ã­rjon be ide szÃ¶veget",
        typeToFilter: "SzÅ±rÃ©shez Ã­rjon be ide szÃ¶veget"
    },
    restartModal: {
        computerNeedsRestart: "A szÃ¡mÃ­tÃ³gÃ©pet Ãºjra kell indÃ­tani!",
        notCompletelyTranslated:
            "A nyelvvÃ¡ltoztatÃ¡shoz a szoftver ÃºjraindÃ­tÃ¡sa szÃ¼ksÃ©ges. ElÅfordulhat, hogy a szoftver nÃ©hÃ¡ny rÃ©szÃ©t mÃ©g nem fordÃ­tottÃ¡k le teljesen.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} Ãºjra kell indÃ­tani!"
    },
    searchPanel: {
        basePlaceholder: "vagy Ã­rjon be egy alapnevet",
        baseStartPlaceholder: "Kezdje egy alapnÃ©v beÃ­rÃ¡sÃ¡val",
        colorCodeNamePlaceholder: "vagy Ã­rja be a kÃ©plet kÃ³djÃ¡t/nevÃ©t",
        colorCodeNameStartPlaceholder: "Kezdje a kÃ©plet kÃ³djÃ¡nak/nevÃ©nek beÃ­rÃ¡sÃ¡val",
        colorCodePlaceholder: "VÃ¡lasszon, vagy Ã­rjon be egy recept szÃ¡mot",
        colorCodeStartPlaceholder: "Ãrja be egy recept szÃ¡mot",
        colorNameCodePlaceholder: "vagy Ã­rja be a kÃ©plet nevÃ©t/kÃ³djÃ¡t",
        colorNameCodeStartPlaceholder: "Kezdje a kÃ©plet nevÃ©nek/kÃ³djÃ¡nak beÃ­rÃ¡sÃ¡val",
        colorNamePlaceholder: "VÃ¡lasszon, vagy Ã­rjon be egy recept nevet",
        colorNameStartPlaceholder: "Ãrja be egy recept nevet",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "VÃ¡lasszon, vagy Ã­rjon be egy szÃ­nkÃ¡rtya nevet",
        fandeckStartPlaceholder: "Ãrja be egy szÃ­nkÃ¡rtya nevet",
        formulaByColor: "KÃ©plet szÃ­n szerint",
        noResultsFound: "Nincs eredmÃ©ny",
        packagePlaceholder: "vagy Ã­rja be a csomag nevÃ©t",
        packageStartPlaceholder: "Kezdje a csomag nevÃ©nek beÃ­rÃ¡sÃ¡val",
        productPlaceholder: "VÃ¡lasszon, vagy Ã­rjon be a termÃ©k nevÃ©t",
        productStartPlaceholder: "Ãrja be a termÃ©k nevÃ©t",
        standard: "AlapÃ©rtelmezett",
        typeFandeckToFilter: "Ãrjon ide a szÃ­nkÃ¡rtya szerinti szÅ±rÃ©shez",
        typeProductToFilter: "Ãrjon ide a termÃ©knÃ©v szerinti szÅ±rÃ©shez"
    },
    sendOrderModal: {
        customNote: "MegjegyzÃ©s szerkesztÃ©se",
        noCompatibleServers: "A hÃ¡lÃ³zatban nincsenek kompatibilis kiszolgÃ¡lÃ³k",
        orderOverview: "MegrendelÃ©s Ã¡ttekintÃ©se",
        selectTargetMachine: "CÃ©lgÃ©p kivÃ¡lasztÃ¡sa",
        sendOrder: "MegrendelÃ©s elkÃ¼ldÃ©se",
        sendOrderTo: "A megrendelÃ©s elkÃ¼ldÃ©sre kerÃ¼l a %{serverName} cÃ­mre",
        targetMachine: "CÃ©l gÃ©p"
    },
    server: {
        computerId: "SzÃ¡mÃ­tÃ³gÃ©p AzonosÃ­tÃ³",
        ip: "IP",
        selectServer: "KÃ©rem vÃ¡lasszon a lehetsÃ©ges szerverek kÃ¶zÃ¼l",
        server: "KiszolgÃ¡lÃ³"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "AktÃ­v kiszolgÃ¡lÃ³ bÅvÃ­tmÃ©nyek",
        currentlyActive: "A jelenleg aktÃ­v bÅvÃ­tmÃ©nyek",
        plugin: "Plugin",
        pluginName: "Plugin neve",
        statusActive: "AktÃ­v",
        statusInactive: "Nem aktÃ­v"
    },
    serviceActionsSettings: {
        canisterLevel: "Kaniszter szint",
        capClose: "ZÃ¡rva",
        capMiddle: "KÃ¶zÃ©pÃ¡llÃ¡s",
        capOpen: "Nyitva",
        cleanAllChannels: "Ãsszes csatorna tisztÃ­tÃ¡sa",
        cleanChannels: "CsatornÃ¡k tisztÃ­tÃ¡sa",
        computer: "SzÃ¡mÃ­tÃ³gÃ©p",
        computerReboot: "SzÃ¡mÃ­tÃ³gÃ©p ÃºjraindÃ­tÃ¡sa",
        computerShutdown: "SzÃ¡mÃ­tÃ³gÃ©p leÃ¡llÃ­tÃ¡sa",
        connectMachine: "Kapcsolat a gÃ©ppel",
        general: "ÃltalÃ¡nos",
        initialize: "ÃzembeÃ¡llÃ­tÃ¡s",
        noMachineIsConnected: "Nincs kapcsolat a gÃ©ppel",
        plug: "CsatlakozÃ³",
        plugger: "CsatlakozÃ³k",
        punch: "LyukasztÃ³",
        puncher: "LyukasztÃ³k",
        purgeChannels: "CsatornÃ¡k tisztÃ­tÃ¡sa",
        recirculate: "VisszavezetÃ©s",
        recirculateAllChannels: "Minden csatorna visszatÃ¶ltÃ©se",
        recirculateChannels: "CsatornÃ¡k visszatÃ¶ltÃ©se",
        serviceActions: "SzervÃ­z esemÃ©nyek",
        setCanisterLevel: "Kaniszter szint beÃ¡llÃ­tÃ¡s",
        shelfDown: "Polc le",
        shelfUp: "Polc fel",
        showServiceWindow: "Mutassa a szervÃ­zablakot",
        smartPurgeAllChannels: "Intelligens tisztÃ­tÃ¡s minden csatornÃ¡n",
        smartPurgeChannels: "CsatornÃ¡k intelligens tisztÃ­tÃ¡sa",
        startErrorReset: "Hibalista tÃ¶rlÃ©se",
        startHardReset: "Gyors visszaÃ¡llÃ­tÃ¡s",
        startReset: "IndÃ­tsa Ãºjra",
        stirAllCanisters: "Ãsszes kaniszter keverÃ©se",
        stirCanisters: "Kaniszterek keverÃ©se",
        stirCanistersMore: "Kaniszterek keverÃ©se"
    },
    spectroMode: {
        eggshell: "TojÃ¡shÃ©j",
        flat: "Lapos",
        gloss: "FÃ©nyes",
        matt: "Matt",
        matte: "Matt",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "HasonlÃ­tsa Ã¶ssze a szÃ­nmintÃ¡t a fÃ©nyessÃ©gi skÃ¡lÃ¡val, Ã©s vÃ¡lassza ki a fÃ©nyessÃ©gi szintet.",
        semiGloss: "FÃ©lfÃ©nyes"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "KalibrÃ¡lÃ¡s",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "EszkÃ¶z csatlakoztatÃ¡sa",
        connectedTo: "Csatlakozott az alÃ¡bbihoz",
        connectingDevice: "EszkÃ¶z csatlakozik",
        deselectAll: "Az Ã¶sszes kijelÃ¶lÃ©s tÃ¶rlÃ©se",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Az eszkÃ¶z nincs kalibrÃ¡lva",
        eraseResult: "Erase result",
        filter: "SzÅ±rÅ",
        foundInFormulas: "TalÃ¡lat a receptek kÃ¶zÃ¶tt",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "KÃ©zi bevitel",
        measure: "MÃ©rÃ©s",
        measurementResult: "MÃ©rÃ©si eredmÃ©ny",
        noFilters: "Nincs elÃ©rhetÅ szÅ±rÅ",
        noFormulas: "Nem talÃ¡lhatÃ³k receptek",
        noSelectedSpectro: "Nincs kivÃ¡lasztva spektrofotomÃ©ter",
        notSelected: "Nincs kivÃ¡lasztva",
        pressConnectButton:
            "GyÅzÅdjÃ¶n meg arrÃ³l, hogy a kÃ©szÃ¼lÃ©k csatlakoztatva van, Ã©s nyomja meg a csatlakoztatÃ¡s gombot",
        searchFormulas: "Recept keresÃ©se",
        selectSpectro: "Spectro kivÃ¡lasztÃ¡sa",
        showDetails: "RÃ©szletek mutatÃ¡sa",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "SpektrofotomÃ©ter kapcsolÃ³dva",
        spectroIsReady: "SpektrofotomÃ©ter kÃ©sz",
        spectroReady: "A kÃ©szÃ¼lÃ©k kÃ©szen Ã¡ll a tovÃ¡bbi feladatokra",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "A kÃ©szÃ¼lÃ©k kalibrÃ¡lva van, kezdheti a mÃ©rÃ©st",
        tolerance: "Spectro tÅ±rÃ©shatÃ¡ra Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) eltÃ©rÃ©s"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Egyedi kiszerelÃ©s neve %{1} %{2}",
        deleteSelectedRecords: "KivÃ¡lasztott tÃ©telek tÃ¶rlÃ©s",
        exportHistory: "Kiviteli elÅzmÃ©nyek",
        finishFormula: "BefejezÅ recept",
        foundInFormulas: "Recept talÃ¡latok",
        hideHiddenRecords: "Ne mutasson rejtett adatokat",
        hideSelectedRecord: "A kivÃ¡lasztott rekord elrejtÃ©se",
        historicalFormula: "KorÃ¡bbi kÃ©plet",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "A kivÃ¡lasztott rekord visszaÃ¡llÃ­tÃ¡sa",
        showAllRecords: "Az Ã¶sszes adat megjelenÃ­tÃ©se",
        standardFormula: "Standard formula",
        unknownFormula: "Ismeretlen formula"
    },
    stirCanisters: {
        selectCanisters: "Kaniszterek kivÃ¡lasztÃ¡sa",
        startStirring: "KeverÃ©s indÃ­tÃ¡sa",
        stirAllCanisters: "Ãsszes kaniszter keverÃ©se",
        stirCanisters: "Kaniszterek keverÃ©se",
        stirringSpeed: "KeverÃ©s sebessÃ©ge",
        stirringTime: "KeverÃ©si idÅ"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Nincs termÃ©k hozzÃ¡rendelve a %{code} vonalkÃ³dhoz",
        pleaseScanBarcode: "KÃ©rjÃ¼k, olvassa be az alap, termÃ©k, csomag vagy mÃ¡s tÃ©tel vonalkÃ³djÃ¡t",
        testBarcodes: "VonalkÃ³dok tesztelÃ©se"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "UtolsÃ³",
        next: "KÃ¶vetkezÅ"
    },
    ufiCodeModal: {
        currentStatus: "Jelenlegi Ã¡llapot",
        detailedInfoForColorant: "RÃ©szletes informÃ¡ciÃ³ a szÃ­nezÃ©krÅl %{colorantName}",
        userSetUfiCode: "FelhasznÃ¡lÃ³ Ã¡ltal beÃ¡llÃ­tott UFI kÃ³d, aktuÃ¡lis Ã©rtÃ©k"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "UFI alapkÃ³d Ã©rvÃ©nyesÃ­tÃ©s",
        confirmColorantRefilling: "SzÃ­nezÅanyag ÃºjratÃ¶ltÃ©sÃ©nek megerÅsÃ­tÃ©se",
        enableUfiCodes: "UFI-kÃ³dok engedÃ©lyezÃ©se",
        printUfiCode: "NyomtatÃ¡s, ha a szÃ­nezÅanyag mennyisÃ©ge meghaladja",
        printUfiCodePercentage: "Nyomtassa ki a szÃ¡zalÃ©kos arÃ¡nyt, ha a szÃ­nezÅanyag mennyisÃ©ge meghaladja",
        scanOrTypeUfiCode: "UFI-kÃ³d beolvasÃ¡sa vagy beÃ­rÃ¡sa",
        scanOrTypeUfiCodeOfBase: "Az alapdoboz UFI-kÃ³djÃ¡nak beolvasÃ¡sa vagy beÃ­rÃ¡sa",
        ufiCodesByPercentage: "UFI-kÃ³dok hasznÃ¡lata szÃ¡zalÃ©kos arÃ¡nyban",
        ufiCodesFromDatabase: "UFI-kÃ³dok hasznÃ¡lata az adatbÃ¡zisbÃ³l",
        ufiCodesFromLastFilling: "UFI-kÃ³dok hasznÃ¡lata az utolsÃ³ tÃ¶ltÃ©sbÅl"
    },
    userSettings: {
        addUser: "FelhasznÃ¡lÃ³ hozzÃ¡adÃ¡sa",
        assignedUserGroups: "HozzÃ¡rendelt felhasznÃ¡lÃ³i csoportok",
        availableUserGroups: "ElÃ©rhetÅ felhasznÃ¡lÃ³i csoportok",
        barcode: "VonalkÃ³d",
        confirmNewPassword: "JelszÃ³ megerÅsÃ­tÃ©se",
        editPassword: "JelszÃ³ szerkesztÃ©se",
        editUser: "FelhasznÃ¡lÃ³ szerkesztÃ©se",
        enableAutoLogin: "Automatikus bejelentkezÃ©s engedÃ©lyezÃ©se",
        newPassword: "Ãj jelszÃ³",
        noChange: "Nincs megmentendÅ vÃ¡ltozÃ¡s",
        oldPassword: "RÃ©gi jelszÃ³",
        password: "JelszÃ³",
        passwordsDoNotMatch: "A jelszavak nem egyeznek",
        restoreUser: "Ez a felhasznÃ¡lÃ³ tÃ¶rlÃ©sre kerÃ¼lt. SzeretnÃ© visszaÃ¡llÃ­tani?",
        userGroup: "User Group",
        userGroups: "FelhasznÃ¡lÃ³i csoportok",
        userManagement: "FelhasznÃ¡lÃ³i menedzsment",
        userSettings: "FelhasznÃ¡lÃ³i beÃ¡llÃ­tÃ¡sok",
        username: "FelhasznÃ¡lÃ³nÃ©v",
        usernameIsMissing: "A felhasznÃ¡lÃ³nÃ©v hiÃ¡nyzik"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "PÃ©ntek",
        monday: "HÃ©tfÅ",
        saturday: "Szombat",
        sunday: "VasÃ¡rnap",
        thursday: "CsÃ¼tÃ¶rtÃ¶k",
        tuesday: "Kedd",
        wednesday: "Szerda"
    },
    welcome: {
        availableDatabase:
            "A kiszolgÃ¡lÃ³ nem tud csatlakozni az adatbÃ¡zishoz. KÃ©rjÃ¼k, ellenÅrizze az adatbÃ¡zis konfigurÃ¡ciÃ³jÃ¡t.",
        availableDatabaseLocalError:
            "Hiba tÃ¶rtÃ©nt a helyi adatbÃ¡zishoz valÃ³ csatlakozÃ¡s sorÃ¡n (rossz fÃ¡jl, Ã©rvÃ©nytelen jelszÃ³)",
        availableDatabaseLocalMissing: "Helyi adatbÃ¡zis hiÃ¡nyzik",
        availableDatabaseLocalUpdate: "Helyi adatbÃ¡zist frissÃ­teni kell az Ãºjabb verziÃ³ra",
        availableDatabaseMainAndLocalError:
            "Hiba a fÅ Ã©s a helyi adatbÃ¡zisokhoz valÃ³ csatlakozÃ¡s sorÃ¡n (rossz fÃ¡jl, Ã©rvÃ©nytelen jelszÃ³)",
        availableDatabaseMainAndLocalMissing: "A fÅ Ã©s a helyi adatbÃ¡zis fÃ¡jlok hiÃ¡nyoznak",
        availableDatabaseMainAndLocalUpdate: "Mind a fÅ, mind a helyi adatbÃ¡zisokat frissÃ­teni kell az Ãºjabb verziÃ³ra",
        availableDatabaseMainError: "Hiba a fÅ adatbÃ¡zishoz valÃ³ csatlakozÃ¡s sorÃ¡n (rossz fÃ¡jl, Ã©rvÃ©nytelen jelszÃ³)",
        availableDatabaseMainMissing: "FÅ adatbÃ¡zis fÃ¡jl hiÃ¡nyzik",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "FÅ adatbÃ¡zist frissÃ­teni kell az Ãºjabb verziÃ³ra",
        closing: "A szoftver bezÃ¡rul",
        compatibility:
            "KÃ©rjÃ¼k, ellenÅrizze a szerver verziÃ³jÃ¡t. A kliens csak a %{0} vagy nagyobb kiszolgÃ¡lÃ³val kompatibilis.",
        compatibilityCheck: "A kompatibilitÃ¡s ellenÅrzÃ©se folyamatban van",
        compatibilityDatabase:
            "Az adatbÃ¡zis nem kompatibilis a szerverrel. KÃ©rjÃ¼k, ellenÅrizze az adatbÃ¡zis konfigurÃ¡ciÃ³jÃ¡t.",
        connectingServer: "CsatlakozÃ¡s a kiszolgÃ¡lÃ³hoz %{ip}",
        databaseCompatibility: "Az adatbÃ¡zis nem kompatibilis a szoftverrel.",
        databasesCompatibility: "Az adatbÃ¡zis nem kompatibilis a szoftverrel.",
        licenseVerification: "A licencellenÅrzÃ©s folyamatban van",
        loading: "BetÃ¶ltÃ©s",
        lostConnection: "A szolgÃ¡ltatÃ³val megszakadt a kapcsolat",
        moduleMessage:
            "Figyeljen a modul kivÃ¡lasztÃ¡sÃ¡ra, mert a modul jÃ¶vÅbeli vÃ¡ltozÃ¡sa csak erre a modul tÃ­pusra lesz elÃ©rhetÅ.",
        refresh: "FrissÃ­tÃ©s",
        restoring: "Restoring connection",
        selectModule: "KÃ©rjÃ¼k, vÃ¡lasszon egyet a rendelkezÃ©sre Ã¡llÃ³ modulok kÃ¶zÃ¼l.",
        stopUpdate: "FrissÃ­tÃ©s megÃ¡llÃ­tÃ¡sa",
        updateDatabase: "AdatbÃ¡zis frissÃ­tÃ©s",
        updatingDatabase: "AdatbÃ¡zis frissÃ­tÃ©se folyamtba",
        updatingDatabases: "Az adatbÃ¡zis frissÃ­tÃ©se kÃ©szen Ã¡ll",
        updatingWarning: "Az adatbÃ¡zis szerkezete a legÃºjabb verziÃ³ra frissÃ¼l, kÃ©rjÃ¼k vÃ¡rjon.",
        updatingWarningInfo: "Ne zÃ¡rja be ezt az ablakot, mert akkor a frissÃ­tÃ©st elÃ¶lrÅl kell kezdenie."
    }
};
